var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfrontDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430.43 467.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-2,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#bcbec0;}.cls-2{opacity:0.05;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-17,.cls-174,.cls-2,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-22,.cls-286,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-73,.cls-8,.cls-9{mix-blend-mode:multiply;}.cls-3{opacity:0.09;}.cls-4{opacity:0.13;}.cls-5{opacity:0.17;}.cls-6{opacity:0.21;}.cls-7{opacity:0.25;}.cls-8{opacity:0.3;}.cls-9{opacity:0.34;}.cls-10{opacity:0.38;}.cls-11{opacity:0.42;}.cls-12{opacity:0.46;}.cls-110,.cls-13,.cls-186,.cls-224,.cls-286{opacity:0.5;}.cls-14{fill:url(#New_Gradient_Swatch_copy_25);}.cls-15{fill:url(#New_Gradient_Swatch_copy_25-2);}.Graphic-Style-142{fill:url(#linear-gradient);}.cls-151,.cls-155,.cls-159,.cls-16,.cls-168,.cls-177,.cls-188,.cls-190,.cls-192,.cls-200,.cls-204,.cls-245,.cls-247,.cls-259,.cls-263,.cls-264,.cls-283,.cls-307,.cls-314,.cls-320,.cls-331,.cls-336,.cls-341,.cls-346,.cls-35,.cls-351,.cls-360,.cls-365,.cls-370,.cls-375,.cls-49,.cls-57,.cls-61{mix-blend-mode:color-dodge;}.cls-16{fill:url(#Radial_Gradient_1);}.cls-17{opacity:0.1;}.cls-18{fill:url(#radial-gradient);}.cls-19{fill:#10054d;}.cls-20{fill:url(#linear-gradient-2);}.cls-21{fill:url(#New_Gradient_Swatch_copy_13);}.cls-22,.cls-286{fill:#d1d3d4;}.cls-23{fill:url(#radial-gradient-2);}.cls-24{fill:url(#linear-gradient-3);}.cls-25{fill:url(#linear-gradient-4);}.cls-26{fill:url(#New_Gradient_Swatch_copy_7);}.cls-27{fill:url(#New_Gradient_Swatch_copy_7-2);}.cls-28{fill:url(#New_Gradient_Swatch_copy_10);}.cls-29{fill:url(#New_Gradient_Swatch_copy_9);}.cls-30{fill:url(#New_Gradient_Swatch_copy_7-3);}.cls-31{fill:url(#New_Gradient_Swatch_copy_7-4);}.cls-32{fill:url(#New_Gradient_Swatch_copy_10-2);}.cls-33{fill:url(#New_Gradient_Swatch_copy_7-5);}.cls-34{fill:url(#New_Gradient_Swatch_copy_7-6);}.cls-35{fill:url(#Radial_Gradient_1-2);}.cls-36{fill:url(#New_Gradient_Swatch_copy_7-7);}.cls-37{fill:url(#New_Gradient_Swatch_copy_7-8);}.cls-38{fill:url(#radial-gradient-3);}.cls-39{fill:url(#radial-gradient-4);}.cls-40{fill:url(#New_Gradient_Swatch_copy_7-9);}.cls-41{fill:url(#linear-gradient-5);}.cls-42{fill:url(#New_Gradient_Swatch_copy_13-2);}.cls-43{fill:url(#radial-gradient-5);}.cls-44{fill:url(#linear-gradient-6);}.cls-45{fill:url(#New_Gradient_Swatch_copy_13-3);}.cls-46{fill:url(#New_Gradient_Swatch_copy_10-3);}.cls-47{fill:url(#New_Gradient_Swatch_copy_13-4);}.cls-48{fill:url(#New_Gradient_Swatch_copy_13-5);}.cls-49{fill:url(#Radial_Gradient_1-3);}.cls-50{fill:url(#radial-gradient-6);}.cls-51{fill:url(#radial-gradient-7);}.cls-52{fill:url(#linear-gradient-7);}.cls-53{fill:url(#linear-gradient-8);}.cls-54{fill:url(#linear-gradient-9);}.cls-55{fill:url(#New_Gradient_Swatch_copy_8);}.cls-56{fill:url(#linear-gradient-10);}.cls-57{fill:url(#Radial_Gradient_1-4);}.cls-58{fill:url(#linear-gradient-11);}.cls-59{fill:url(#linear-gradient-12);}.cls-60{fill:url(#linear-gradient-13);}.cls-61{fill:url(#Radial_Gradient_1-5);}.cls-62{fill:url(#radial-gradient-8);}.cls-63{fill:url(#New_Gradient_Swatch_copy_13-6);}.cls-64{fill:url(#radial-gradient-9);}.cls-65{fill:url(#radial-gradient-10);}.cls-66{fill:url(#linear-gradient-14);}.cls-67{fill:url(#New_Gradient_Swatch_copy_26);}.Graphic-Style-121{fill:url(#linear-gradient-16);}.Graphic-Style-120{fill:url(#New_Gradient_Swatch_copy_26-2);}.cls-68{fill:url(#New_Gradient_Swatch_copy_25-3);}.cls-69{fill:url(#New_Gradient_Swatch_copy_25-4);}.cls-70{fill:url(#New_Gradient_Swatch_copy_25-5);}.cls-71{fill:url(#linear-gradient-17);}.Graphic-Style-118{fill:url(#New_Gradient_Swatch_copy_25-6);}.cls-72{fill:url(#New_Gradient_Swatch_copy_25-7);}.cls-73{fill:#231f20;opacity:0.2;}.cls-74{fill:url(#linear-gradient-18);}.cls-75{fill:url(#linear-gradient-19);}.cls-76{fill:url(#New_Gradient_Swatch_copy_35);}.cls-77{fill:#8969c3;}.cls-78{fill:#e6e7e8;}.cls-185,.cls-186,.cls-206,.cls-248,.cls-258,.cls-260,.cls-261,.cls-262,.cls-265,.cls-78{mix-blend-mode:screen;}.cls-79{fill:url(#linear-gradient-20);}.cls-80{fill:url(#New_Gradient_Swatch_copy_35-2);}.cls-81{fill:url(#linear-gradient-21);}.cls-82{fill:url(#New_Gradient_Swatch_copy_35-3);}.cls-83{fill:url(#linear-gradient-22);}.cls-84{fill:url(#New_Gradient_Swatch_copy_35-4);}.cls-85{fill:url(#linear-gradient-23);}.cls-86{fill:url(#New_Gradient_Swatch_copy_35-5);}.cls-87{fill:url(#linear-gradient-24);}.cls-88{fill:url(#New_Gradient_Swatch_copy_35-6);}.cls-89{fill:url(#linear-gradient-25);}.cls-90{fill:url(#New_Gradient_Swatch_copy_35-7);}.cls-91{fill:url(#linear-gradient-26);}.cls-92{fill:url(#New_Gradient_Swatch_copy_35-8);}.cls-93{fill:url(#linear-gradient-27);}.cls-94{fill:url(#New_Gradient_Swatch_copy_35-9);}.cls-95{fill:url(#linear-gradient-28);}.cls-96{fill:url(#New_Gradient_Swatch_copy_35-10);}.cls-97{fill:url(#linear-gradient-29);}.cls-98{fill:url(#New_Gradient_Swatch_copy_35-11);}.cls-99{fill:url(#linear-gradient-30);}.cls-100{fill:url(#New_Gradient_Swatch_copy_35-12);}.cls-101{fill:url(#linear-gradient-31);}.cls-102{fill:url(#New_Gradient_Swatch_copy_35-13);}.cls-103{fill:url(#linear-gradient-32);}.cls-104{fill:url(#New_Gradient_Swatch_copy_35-14);}.cls-105{fill:url(#linear-gradient-33);}.cls-106{fill:url(#New_Gradient_Swatch_copy_35-15);}.cls-107{fill:url(#linear-gradient-34);}.cls-108{fill:url(#New_Gradient_Swatch_copy_35-16);}.cls-109{fill:url(#New_Gradient_Swatch_copy_25-8);}.cls-111,.cls-160,.cls-223,.cls-224{fill:#fff;}.cls-111{opacity:0.15;}.cls-112{fill:#190333;}.cls-113{fill:url(#linear-gradient-35);}.Graphic-Style-119{fill:url(#New_Gradient_Swatch_copy_25-9);}.cls-114{fill:url(#linear-gradient-37);}.cls-115{fill:url(#linear-gradient-38);}.cls-116{fill:url(#New_Gradient_Swatch_copy_35-17);}.cls-117{fill:url(#linear-gradient-39);}.cls-118{fill:url(#New_Gradient_Swatch_copy_35-18);}.cls-119{fill:url(#linear-gradient-40);}.cls-120{fill:url(#New_Gradient_Swatch_copy_35-19);}.cls-121{fill:url(#linear-gradient-41);}.cls-122{fill:url(#New_Gradient_Swatch_copy_35-20);}.cls-123{fill:url(#linear-gradient-42);}.cls-124{fill:url(#New_Gradient_Swatch_copy_35-21);}.cls-125{fill:url(#linear-gradient-43);}.cls-126{fill:url(#New_Gradient_Swatch_copy_35-22);}.cls-127{fill:url(#linear-gradient-44);}.cls-128{fill:url(#New_Gradient_Swatch_copy_35-23);}.cls-129{fill:url(#linear-gradient-45);}.cls-130{fill:url(#New_Gradient_Swatch_copy_35-24);}.cls-131{fill:url(#linear-gradient-46);}.cls-132{fill:url(#New_Gradient_Swatch_copy_35-25);}.cls-133{fill:url(#linear-gradient-47);}.cls-134{fill:url(#New_Gradient_Swatch_copy_35-26);}.cls-135{fill:url(#linear-gradient-48);}.cls-136{fill:url(#New_Gradient_Swatch_copy_35-27);}.cls-137{fill:url(#linear-gradient-49);}.cls-138{fill:url(#New_Gradient_Swatch_copy_35-28);}.cls-139{fill:url(#linear-gradient-50);}.cls-140{fill:url(#New_Gradient_Swatch_copy_35-29);}.cls-141{fill:url(#linear-gradient-51);}.cls-142{fill:url(#New_Gradient_Swatch_copy_35-30);}.cls-143{fill:url(#linear-gradient-52);}.cls-144{fill:url(#New_Gradient_Swatch_copy_35-31);}.cls-145{fill:url(#linear-gradient-53);}.cls-146{fill:url(#New_Gradient_Swatch_copy_35-32);}.cls-147{fill:url(#New_Gradient_Swatch_copy_25-10);}.cls-148{fill:url(#New_Gradient_Swatch_copy_13-7);}.cls-149{fill:url(#New_Gradient_Swatch_copy_13-8);}.cls-150{fill:url(#New_Gradient_Swatch_copy_13-9);}.cls-151{fill:url(#Radial_Gradient_1-6);}.cls-152{fill:url(#New_Gradient_Swatch_copy_13-10);}.cls-153{fill:url(#New_Gradient_Swatch_copy_13-11);}.cls-154{fill:url(#New_Gradient_Swatch_copy_13-12);}.cls-155{fill:url(#Radial_Gradient_1-7);}.cls-156{fill:url(#New_Gradient_Swatch_copy_13-13);}.cls-157{fill:url(#New_Gradient_Swatch_copy_13-14);}.cls-158{fill:url(#New_Gradient_Swatch_copy_13-15);}.cls-159{fill:url(#Radial_Gradient_1-8);}.cls-161{fill:url(#New_Gradient_Swatch_copy_25-11);}.cls-162{fill:url(#New_Gradient_Swatch_copy_25-12);}.cls-163{fill:url(#linear-gradient-54);}.cls-164{fill:url(#New_Gradient_Swatch_copy_25-15);}.cls-165{fill:url(#New_Gradient_Swatch_copy_25-16);}.cls-166{fill:url(#New_Gradient_Swatch_copy_25-17);}.cls-167{fill:url(#linear-gradient-55);}.cls-168{fill:url(#radial-gradient-11);}.cls-169{fill:url(#New_Gradient_Swatch_copy_25-19);}.cls-170{fill:url(#linear-gradient-57);}.cls-171{fill:url(#New_Gradient_Swatch_copy_25-21);}.cls-172{fill:url(#New_Gradient_Swatch_copy_25-22);}.cls-173{fill:url(#linear-gradient-58);}.cls-174{fill:#a7a9ac;}.cls-175{fill:url(#linear-gradient-59);}.cls-176{fill:url(#linear-gradient-60);}.cls-177{fill:url(#linear-gradient-61);}.cls-178{fill:url(#New_Gradient_Swatch_copy_25-23);}.cls-179{fill:url(#New_Gradient_Swatch_copy_25-24);}.cls-180{fill:url(#New_Gradient_Swatch_copy_25-25);}.cls-181{fill:url(#New_Gradient_Swatch_copy_8-2);}.cls-182{fill:url(#New_Gradient_Swatch_copy_8-3);}.cls-183{fill:url(#New_Gradient_Swatch_copy_8-4);}.cls-184{fill:#ffe4a7;}.cls-185{fill:url(#New_Gradient_Swatch_copy_38);}.cls-186{fill:url(#linear-gradient-62);}.Graphic-Style-140{fill:url(#linear-gradient-63);}.Graphic-Style-139{fill:url(#linear-gradient-64);}.cls-187{fill:url(#New_Gradient_Swatch_copy_7-10);}.cls-188{fill:url(#Radial_Gradient_1-9);}.cls-189{fill:url(#New_Gradient_Swatch_copy_7-11);}.cls-190{fill:url(#Radial_Gradient_1-10);}.cls-191{fill:url(#New_Gradient_Swatch_copy_7-12);}.cls-192{fill:url(#Radial_Gradient_1-11);}.cls-193{fill:url(#New_Gradient_Swatch_copy_25-28);}.cls-194{fill:url(#New_Gradient_Swatch_copy_25-29);}.cls-195{fill:url(#New_Gradient_Swatch_copy_25-30);}.cls-196{fill:url(#New_Gradient_Swatch_copy_25-31);}.cls-197{fill:url(#New_Gradient_Swatch_copy_25-32);}.cls-198{fill:url(#New_Gradient_Swatch_copy_25-33);}.cls-199{fill:url(#linear-gradient-71);}.cls-200{fill:url(#Radial_Gradient_1-12);}.cls-201{fill:url(#New_Gradient_Swatch_copy_26-4);}.cls-202{fill:url(#New_Gradient_Swatch_copy_26-5);}.cls-203{fill:url(#New_Gradient_Swatch_copy_26-6);}.cls-204{fill:url(#Radial_Gradient_1-13);}.cls-205{fill:url(#linear-gradient-72);}.cls-206,.cls-223{opacity:0.3;}.cls-206{fill:url(#linear-gradient-73);}.cls-207{opacity:0.14;}.cls-208{opacity:0.22;}.cls-209{opacity:0.31;}.cls-210{opacity:0.4;}.cls-211{opacity:0.48;}.cls-212{opacity:0.57;}.cls-213{opacity:0.65;}.cls-214{opacity:0.74;}.cls-215{opacity:0.83;}.cls-216{opacity:0.91;}.cls-218{fill:url(#linear-gradient-74);}.cls-219{fill:url(#New_Gradient_Swatch_copy_8-5);}.cls-220{fill:url(#linear-gradient-75);}.cls-221{fill:url(#New_Gradient_Swatch_copy_8-6);}.cls-222{fill:url(#New_Gradient_Swatch_copy_13-16);}.cls-225{fill:url(#New_Gradient_Swatch_copy_13-17);}.cls-226{fill:url(#New_Gradient_Swatch_copy_13-18);}.cls-227{fill:url(#New_Gradient_Swatch_copy_9-2);}.cls-228{fill:url(#New_Gradient_Swatch_copy_9-3);}.cls-229{fill:url(#New_Gradient_Swatch_copy_9-4);}.cls-230{fill:url(#radial-gradient-12);}.cls-231{fill:url(#radial-gradient-13);}.cls-232{fill:url(#New_Gradient_Swatch_copy_13-19);}.cls-233{fill:url(#New_Gradient_Swatch_copy_8-7);}.cls-234{fill:url(#New_Gradient_Swatch_copy_8-8);}.cls-235{fill:url(#radial-gradient-14);}.cls-236{fill:url(#linear-gradient-76);}.cls-237{fill:url(#New_Gradient_Swatch_copy_13-20);}.cls-238{fill:url(#New_Gradient_Swatch_copy_10-4);}.cls-239{fill:url(#radial-gradient-15);}.cls-240{fill:url(#radial-gradient-16);}.cls-241{fill:url(#New_Gradient_Swatch_copy_13-21);}.cls-242{fill:url(#New_Gradient_Swatch_copy_9-5);}.cls-243{fill:url(#New_Gradient_Swatch_copy_9-6);}.cls-244{fill:url(#New_Gradient_Swatch_copy_9-7);}.cls-246{fill:#2af6ff;}.cls-247{fill:url(#linear-gradient-77);}.cls-249{fill:url(#linear-gradient-78);}.cls-250,.cls-255{opacity:0.7;}.cls-250{fill:url(#linear-gradient-79);}.cls-251{fill:url(#linear-gradient-80);}.cls-252{fill:url(#linear-gradient-81);}.cls-253{fill:url(#linear-gradient-82);}.cls-254{fill:url(#linear-gradient-83);}.cls-255{fill:url(#linear-gradient-84);}.cls-256{fill:url(#linear-gradient-85);}.cls-257{fill:url(#linear-gradient-86);}.cls-258{fill:url(#linear-gradient-87);}.cls-259{fill:url(#linear-gradient-88);}.cls-260{fill:url(#linear-gradient-89);}.cls-261{fill:url(#linear-gradient-90);}.cls-262{fill:url(#linear-gradient-91);}.cls-263{fill:url(#linear-gradient-92);}.cls-264{fill:url(#linear-gradient-93);}.cls-265{fill:url(#linear-gradient-94);}.cls-266{fill:url(#radial-gradient-17);}.cls-267{fill:url(#radial-gradient-18);}.cls-268{fill:url(#linear-gradient-95);}.cls-269{fill:url(#New_Gradient_Swatch_copy_10-5);}.cls-270{fill:url(#linear-gradient-96);}.cls-271{fill:url(#radial-gradient-19);}.cls-272{fill:url(#radial-gradient-20);}.cls-273{fill:url(#New_Gradient_Swatch_copy_9-8);}.cls-274{fill:url(#New_Gradient_Swatch_copy_9-9);}.cls-275{fill:url(#radial-gradient-21);}.cls-276{fill:url(#radial-gradient-22);}.cls-277{fill:url(#New_Gradient_Swatch_copy_9-10);}.cls-278{fill:url(#linear-gradient-97);}.cls-279{fill:url(#New_Gradient_Swatch_copy_9-11);}.cls-280{fill:url(#radial-gradient-23);}.cls-281{fill:url(#New_Gradient_Swatch_copy_10-6);}.cls-282{fill:url(#New_Gradient_Swatch_copy_9-12);}.cls-283{fill:url(#Radial_Gradient_1-14);}.cls-284{fill:url(#linear-gradient-98);}.cls-285{fill:url(#New_Gradient_Swatch_copy_9-13);}.cls-287{fill:url(#linear-gradient-99);}.cls-288{fill:url(#New_Gradient_Swatch_copy_25-34);}.cls-289{fill:url(#New_Gradient_Swatch_copy_25-35);}.cls-290{fill:url(#New_Gradient_Swatch_copy_25-36);}.cls-291{fill:url(#New_Gradient_Swatch_copy_25-37);}.cls-292{fill:#25054d;}.cls-293{fill:#4b61b8;}.cls-294{fill:url(#New_Gradient_Swatch_copy_25-38);}.cls-295{fill:url(#linear-gradient-100);}.cls-296{fill:url(#radial-gradient-24);}.cls-297{fill:url(#linear-gradient-101);}.cls-298{fill:url(#New_Gradient_Swatch_copy_7-13);}.cls-299{fill:url(#linear-gradient-102);}.cls-300{fill:url(#New_Gradient_Swatch_copy_7-14);}.cls-301{fill:url(#radial-gradient-25);}.cls-302{fill:url(#linear-gradient-103);}.cls-303{fill:url(#New_Gradient_Swatch_copy_7-15);}.cls-304{fill:url(#New_Gradient_Swatch_copy_10-7);}.cls-305{fill:url(#New_Gradient_Swatch_copy_7-16);}.cls-306{fill:url(#New_Gradient_Swatch_copy_7-17);}.cls-307{fill:url(#Radial_Gradient_1-15);}.cls-308{fill:url(#radial-gradient-26);}.cls-309{fill:url(#New_Gradient_Swatch_copy_7-18);}.cls-310{fill:url(#linear-gradient-104);}.cls-311{fill:url(#linear-gradient-105);}.cls-312{fill:url(#linear-gradient-106);}.cls-313{fill:url(#New_Gradient_Swatch_copy_13-22);}.cls-314{fill:url(#Radial_Gradient_1-16);}.cls-315{fill:url(#New_Gradient_Swatch_copy_13-23);}.cls-316{fill:url(#New_Gradient_Swatch_copy_13-24);}.cls-317{fill:url(#New_Gradient_Swatch_copy_9-14);}.cls-318{fill:url(#New_Gradient_Swatch_copy_9-15);}.cls-319{fill:url(#New_Gradient_Swatch_copy_9-16);}.cls-320{fill:url(#Radial_Gradient_1-17);}.cls-321{fill:url(#linear-gradient-107);}.cls-322{fill:url(#linear-gradient-108);}.cls-323{fill:url(#New_Gradient_Swatch_copy_7-19);}.cls-324{fill:url(#linear-gradient-109);}.cls-325{fill:url(#New_Gradient_Swatch_copy_7-20);}.cls-326{fill:url(#New_Gradient_Swatch_copy_7-21);}.cls-327{fill:url(#radial-gradient-27);}.cls-328{fill:url(#New_Gradient_Swatch_copy_9-17);}.cls-329{fill:url(#New_Gradient_Swatch_copy_9-18);}.cls-330{fill:url(#New_Gradient_Swatch_copy_9-19);}.cls-331{fill:url(#Radial_Gradient_1-18);}.cls-332{fill:url(#linear-gradient-110);}.cls-333{fill:url(#linear-gradient-111);}.cls-334{fill:url(#linear-gradient-112);}.cls-335{fill:url(#linear-gradient-113);}.cls-336{fill:url(#radial-gradient-28);}.cls-337{fill:url(#linear-gradient-114);}.cls-338{fill:url(#linear-gradient-115);}.cls-339{fill:url(#linear-gradient-116);}.cls-340{fill:url(#linear-gradient-117);}.cls-341{fill:url(#radial-gradient-29);}.cls-342{fill:url(#linear-gradient-118);}.cls-343{fill:url(#linear-gradient-119);}.cls-344{fill:url(#linear-gradient-120);}.cls-345{fill:url(#linear-gradient-121);}.cls-346{fill:url(#radial-gradient-30);}.cls-347{fill:url(#linear-gradient-122);}.cls-348{fill:url(#linear-gradient-123);}.cls-349{fill:url(#linear-gradient-124);}.cls-350{fill:url(#linear-gradient-125);}.cls-351{fill:url(#radial-gradient-31);}.cls-352{fill:url(#linear-gradient-126);}.cls-353{fill:url(#linear-gradient-127);}.cls-354{fill:url(#linear-gradient-128);}.cls-355{fill:url(#linear-gradient-129);}.cls-356{fill:url(#linear-gradient-130);}.cls-357{fill:url(#linear-gradient-131);}.cls-358{fill:url(#linear-gradient-132);}.cls-359{fill:url(#linear-gradient-133);}.cls-360{fill:url(#radial-gradient-32);}.cls-361{fill:url(#linear-gradient-134);}.cls-362{fill:url(#linear-gradient-135);}.cls-363{fill:url(#linear-gradient-136);}.cls-364{fill:url(#linear-gradient-137);}.cls-365{fill:url(#radial-gradient-33);}.cls-366{fill:url(#linear-gradient-138);}.cls-367{fill:url(#linear-gradient-139);}.cls-368{fill:url(#linear-gradient-140);}.cls-369{fill:url(#linear-gradient-141);}.cls-370{fill:url(#radial-gradient-34);}.cls-371{fill:url(#linear-gradient-142);}.cls-372{fill:url(#linear-gradient-143);}.cls-373{fill:url(#linear-gradient-144);}.cls-374{fill:url(#linear-gradient-145);}.cls-375{fill:url(#radial-gradient-35);}.cls-376{fill:url(#linear-gradient-146);}.cls-377{fill:url(#linear-gradient-147);}.cls-378{fill:url(#linear-gradient-148);}.cls-379{fill:url(#linear-gradient-149);}.cls-380{fill:#f7aa90;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25",
    x1: 3818.01,
    y1: 209.69,
    x2: 4047.41,
    y2: 158.27,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-2",
    x1: 3852.89,
    y1: 188.29,
    x2: 3949.96,
    y2: 159.22,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3954.53,
    y1: 54.17,
    x2: 3884,
    y2: 188.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746a3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 306.94,
    cy: 179.91,
    r: 39.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 5731.35,
    cy: 145.52,
    r: 4,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2a78c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5738.9,
    y1: 167.16,
    x2: 5738.9,
    y2: 162.61,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#330a68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13",
    x1: 5736.47,
    y1: 154.07,
    x2: 5743.31,
    y2: 154.07,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#975ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56ef4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 5259.18,
    cy: 2.91,
    r: 5.15,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 5559.73, -286.65)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 5711.05,
    y1: 150.45,
    x2: 5720.15,
    y2: 150.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 5703.75,
    y1: 155.06,
    x2: 5711.36,
    y2: 155.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7",
    x1: 5710.88,
    y1: 136.14,
    x2: 5716.85,
    y2: 136.14,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1fc3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-2",
    x1: 5703.39,
    y1: 138.26,
    x2: 5711.7,
    y2: 138.26,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10",
    x1: 5710.65,
    y1: 108.34,
    x2: 5716.31,
    y2: 104.18,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9",
    x1: 5712.52,
    y1: 109.83,
    x2: 5715.92,
    y2: 107.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-3",
    x1: 5712.61,
    y1: 111.89,
    x2: 5722.88,
    y2: 112.19,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-4",
    x1: 5712.65,
    y1: 106.6,
    x2: 5716.33,
    y2: 106.6,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-2",
    x1: 5706.97,
    y1: 103.57,
    x2: 5712.91,
    y2: 100.44,
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-5",
    x1: 5702.61,
    y1: 114.27,
    x2: 5716.98,
    y2: 111.69,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-6",
    x1: 5705.56,
    y1: 109.49,
    x2: 5711.97,
    y2: 106.79,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-2",
    cx: 5707.83,
    cy: 108.43,
    r: 5.26,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-7",
    x1: 5703.68,
    y1: 120.54,
    x2: 5709.99,
    y2: 119.94,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-8",
    x1: 5717.71,
    y1: 119.75,
    x2: 5719.75,
    y2: 119.75,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 5724.31,
    cy: 119.04,
    r: 6.21,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 5725.97,
    cy: 116.26,
    r: 9.65,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-9",
    x1: 5694.9,
    y1: 113.16,
    x2: 5716.78,
    y2: 112.09,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5730.55,
    y1: 172.2,
    x2: 5732.35,
    y2: 166.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-2",
    x1: 5729.26,
    y1: 156.16,
    x2: 5738.01,
    y2: 156.16,
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 5733.49,
    cy: 112.2,
    r: 6.09,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 5738.48,
    y1: 115.6,
    x2: 5734.37,
    y2: 108.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#602213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6d310e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a4108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-3",
    x1: 5727.32,
    y1: 119.75,
    x2: 5743.51,
    y2: 119.75,
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-3",
    x1: 5736.51,
    y1: 119.12,
    x2: 5735.24,
    y2: 116.85,
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-4",
    x1: 5729,
    y1: 130.72,
    x2: 5744.34,
    y2: 130.72,
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-5",
    x1: 5733,
    y1: 125.23,
    x2: 5736.76,
    y2: 115.57,
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-3",
    cx: 5735.84,
    cy: 119.47,
    r: 3.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 5715.21,
    cy: 96.32,
    r: 6.81,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 5714.01,
    cy: 96.38,
    r: 7.27,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 5707.17,
    y1: 94.72,
    x2: 5714.81,
    y2: 94.72,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 5730.94,
    y1: 156.51,
    x2: 5738.5,
    y2: 154.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 5713.58,
    y1: 155.79,
    x2: 5752.59,
    y2: 147.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8",
    x1: 5722.69,
    y1: 155.7,
    x2: 5727.95,
    y2: 154.52,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 5708.87,
    y1: 153.73,
    x2: 5743.1,
    y2: 146.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-4",
    cx: 5722.67,
    cy: 158.55,
    r: 6.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 5727.76,
    y1: 144.78,
    x2: 5725.9,
    y2: 148.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 5727.36,
    y1: 149.04,
    x2: 5725.61,
    y2: 145.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 5998.38,
    y1: 58.53,
    x2: 6014.16,
    y2: 54.99,
    gradientTransform: "matrix(-0.87, 0.5, 0, 1.15, 5519.59, -2921.76)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-5",
    cx: 5727.98,
    cy: 150.95,
    r: 4.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 6044.1, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 5036.95,
    cy: -19.17,
    r: 4.25,
    gradientTransform: "matrix(-0.99, 0.11, 0.11, 0.99, 5326.3, -403.08)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-6",
    x1: 5725.78,
    y1: 132.42,
    x2: 5735.23,
    y2: 132.42,
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 5252.52,
    cy: -3.62,
    r: 5.77,
    gradientTransform: "matrix(-1, 0.08, 0.08, 1, 5559.73, -286.65)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 5722.79,
    cy: 122.01,
    r: 2.79,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 269.42,
    y1: 73.55,
    x2: 179.16,
    y2: 245.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26",
    x1: 184.83,
    y1: 239.76,
    x2: 346.46,
    y2: 191.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 56.67,
    y1: 247.85,
    x2: 269.25,
    y2: 200.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-2",
    x1: 224.07,
    y1: 312.93,
    x2: 474.04,
    y2: 238.08,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-3",
    x1: 212.25,
    y1: 269.63,
    x2: 360.58,
    y2: 225.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-4",
    x1: 76.34,
    y1: 301.16,
    x2: 271.9,
    y2: 257.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-5",
    x1: 238.08,
    y1: 388.41,
    x2: 429.96,
    y2: 330.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 27.82,
    y1: 328.87,
    x2: 216.52,
    y2: 408.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-6",
    x1: 210.78,
    y1: 324.81,
    x2: 474.21,
    y2: 245.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-7",
    x1: 35.15,
    y1: 436.91,
    x2: 227.23,
    y2: 393.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -63.03,
    y1: 276.01,
    x2: -75.86,
    y2: 254.68,
    gradientTransform: "translate(305.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2b0758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#390c73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -77.5,
    y1: 265.62,
    x2: -82.18,
    y2: 257.51,
    gradientTransform: "translate(305.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b086cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#b68fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c7a7dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a586cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35",
    x1: -93.93,
    y1: 269.71,
    x2: -84.2,
    y2: 266.8,
    gradientTransform: "translate(305.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f79c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a580cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#b492d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cdb0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d1b4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#dbc4e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebdef3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -72.3,
    y1: 268.61,
    x2: -76.98,
    y2: 260.49,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-2",
    x1: -88.73,
    y1: 272.7,
    x2: -79,
    y2: 269.79,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -67.09,
    y1: 271.59,
    x2: -71.78,
    y2: 263.48,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-3",
    x1: -83.52,
    y1: 275.69,
    x2: -73.8,
    y2: 272.78,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -61.89,
    y1: 274.58,
    x2: -66.58,
    y2: 266.47,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-4",
    x1: -78.32,
    y1: 278.68,
    x2: -68.6,
    y2: 275.76,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -56.69,
    y1: 277.57,
    x2: -61.38,
    y2: 269.46,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-5",
    x1: -73.12,
    y1: 281.66,
    x2: -63.4,
    y2: 278.75,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -51.49,
    y1: 280.56,
    x2: -56.17,
    y2: 272.44,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-6",
    x1: -67.92,
    y1: 284.65,
    x2: -58.2,
    y2: 281.74,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -46.29,
    y1: 283.55,
    x2: -50.97,
    y2: 275.43,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-7",
    x1: -62.72,
    y1: 287.64,
    x2: -52.99,
    y2: 284.73,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -41.09,
    y1: 286.53,
    x2: -45.77,
    y2: 278.42,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-8",
    x1: -57.52,
    y1: 290.63,
    x2: -47.79,
    y2: 287.71,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -35.89,
    y1: 289.52,
    x2: -40.57,
    y2: 281.41,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-9",
    x1: -52.32,
    y1: 293.61,
    x2: -42.59,
    y2: 290.7,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -30.69,
    y1: 292.51,
    x2: -35.37,
    y2: 284.4,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-10",
    x1: -47.12,
    y1: 296.6,
    x2: -37.39,
    y2: 293.69,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -25.49,
    y1: 295.5,
    x2: -30.17,
    y2: 287.38,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-11",
    x1: -41.92,
    y1: 299.59,
    x2: -32.19,
    y2: 296.68,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -20.29,
    y1: 298.48,
    x2: -24.97,
    y2: 290.37,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-12",
    x1: -36.72,
    y1: 302.58,
    x2: -26.99,
    y2: 299.66,
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -15.09,
    y1: 301.47,
    x2: -19.77,
    y2: 293.36,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-13",
    x1: -31.52,
    y1: 305.56,
    x2: -21.79,
    y2: 302.65,
    gradientTransform: "translate(455.52 56.9) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -9.88,
    y1: 304.46,
    x2: -14.57,
    y2: 296.35,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-14",
    x1: -26.31,
    y1: 308.55,
    x2: -16.59,
    y2: 305.64,
    gradientTransform: "translate(457.74 54.68) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -4.68,
    y1: 307.45,
    x2: -9.37,
    y2: 299.33,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-15",
    x1: -21.11,
    y1: 311.54,
    x2: -11.39,
    y2: 308.63,
    gradientTransform: "translate(459.96 52.46) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.52,
    y1: 310.43,
    x2: -4.17,
    y2: 302.32,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-16",
    x1: -15.91,
    y1: 314.53,
    x2: -6.19,
    y2: 311.61,
    gradientTransform: "translate(462.18 50.25) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-8",
    x1: 287.12,
    y1: 226.41,
    x2: 261.28,
    y2: 292.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 28.09,
    y1: 328.96,
    x2: 216.49,
    y2: 408.06,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-9",
    x1: 8.91,
    y1: 370.84,
    x2: 314.84,
    y2: 302.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 5312.5,
    y1: 290.29,
    x2: 5299.67,
    y2: 268.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 5298.04,
    y1: 279.9,
    x2: 5293.35,
    y2: 271.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-17",
    x1: 5281.61,
    y1: 283.99,
    x2: 5291.33,
    y2: 281.08,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 5303.24,
    y1: 282.89,
    x2: 5298.55,
    y2: 274.78,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-18",
    x1: 5286.81,
    y1: 286.98,
    x2: 5296.53,
    y2: 284.07,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 5308.44,
    y1: 285.88,
    x2: 5303.76,
    y2: 277.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-19",
    x1: 5292.01,
    y1: 289.97,
    x2: 5301.73,
    y2: 287.06,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 5313.64,
    y1: 288.86,
    x2: 5308.96,
    y2: 280.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-20",
    x1: 5297.21,
    y1: 292.96,
    x2: 5306.94,
    y2: 290.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 5318.84,
    y1: 291.85,
    x2: 5314.16,
    y2: 283.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-21",
    x1: 5302.41,
    y1: 295.94,
    x2: 5312.14,
    y2: 293.03,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 5324.04,
    y1: 294.84,
    x2: 5319.36,
    y2: 286.73,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-22",
    x1: 5307.61,
    y1: 298.93,
    x2: 5317.34,
    y2: 296.02,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 5329.24,
    y1: 297.83,
    x2: 5324.56,
    y2: 289.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-23",
    x1: 5312.81,
    y1: 301.92,
    x2: 5322.54,
    y2: 299.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 5334.44,
    y1: 300.81,
    x2: 5329.76,
    y2: 292.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-24",
    x1: 5318.01,
    y1: 304.91,
    x2: 5327.74,
    y2: 301.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 5339.64,
    y1: 303.8,
    x2: 5334.96,
    y2: 295.69,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-25",
    x1: 5323.21,
    y1: 307.89,
    x2: 5332.94,
    y2: 304.98,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 5344.84,
    y1: 306.79,
    x2: 5340.16,
    y2: 298.68,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-26",
    x1: 5328.41,
    y1: 310.88,
    x2: 5338.14,
    y2: 307.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 5350.05,
    y1: 309.78,
    x2: 5345.36,
    y2: 301.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-27",
    x1: 5333.62,
    y1: 313.87,
    x2: 5343.34,
    y2: 310.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 5355.25,
    y1: 312.76,
    x2: 5350.56,
    y2: 304.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-28",
    x1: 5338.82,
    y1: 316.86,
    x2: 5348.54,
    y2: 313.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 5360.45,
    y1: 315.75,
    x2: 5355.76,
    y2: 307.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-29",
    x1: 5344.02,
    y1: 319.85,
    x2: 5353.74,
    y2: 316.93,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 5365.65,
    y1: 318.74,
    x2: 5360.97,
    y2: 310.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-30",
    x1: 5349.22,
    y1: 322.83,
    x2: 5358.94,
    y2: 319.92,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 5370.85,
    y1: 321.73,
    x2: 5366.17,
    y2: 313.61,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-31",
    x1: 5354.42,
    y1: 325.82,
    x2: 5364.15,
    y2: 322.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 5376.05,
    y1: 324.71,
    x2: 5371.37,
    y2: 316.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_35-32",
    x1: 5359.62,
    y1: 328.81,
    x2: 5369.35,
    y2: 325.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 5465.89, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-10",
    x1: 5662.66,
    y1: 240.69,
    x2: 5636.81,
    y2: 307.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 5771.52, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-7",
    x1: -1472.58,
    y1: 321.16,
    x2: -1416.44,
    y2: 308.58,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-8",
    x1: -1463.82,
    y1: 315.94,
    x2: -1439.74,
    y2: 308.73,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-9",
    x1: -1436.93,
    y1: 278.49,
    x2: -1453.88,
    y2: 310.8,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-6",
    cx: 5667.63,
    cy: 314.28,
    r: 9.69,
    gradientTransform: "matrix(-1, 0, 0, 1, 5771.52, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-10",
    x1: -1447.05,
    y1: 306.28,
    x2: -1390.92,
    y2: 293.7,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-11",
    x1: -1438.29,
    y1: 301.06,
    x2: -1414.22,
    y2: 293.85,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-12",
    x1: -1411.4,
    y1: 263.61,
    x2: -1428.36,
    y2: 295.92,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-7",
    cx: 5642.11,
    cy: 299.4,
    r: 9.69,
    gradientTransform: "matrix(-1, 0, 0, 1, 5771.52, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-13",
    x1: -1422.07,
    y1: 291.95,
    x2: -1365.94,
    y2: 279.37,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-14",
    x1: -1413.31,
    y1: 286.73,
    x2: -1389.24,
    y2: 279.52,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-15",
    x1: -1386.42,
    y1: 249.28,
    x2: -1403.38,
    y2: 281.59,
    gradientTransform: "translate(1553.64)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-8",
    cx: 5617.13,
    cy: 285.07,
    r: 9.69,
    gradientTransform: "matrix(-1, 0, 0, 1, 5771.52, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-11",
    x1: 279.43,
    y1: 321.39,
    x2: 801.46,
    y2: 165.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-12",
    x1: -205.46,
    y1: 436.2,
    x2: 481.98,
    y2: 282.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -192.59,
    y1: 181.68,
    x2: 594.77,
    y2: 512.22,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-15",
    x1: 5417.2,
    y1: 177.97,
    x2: 5598.9,
    y2: 123.57,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-16",
    x1: 5250.77,
    y1: 216.58,
    x2: 5490.25,
    y2: 162.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-17",
    x1: 5440.11,
    y1: 229.8,
    x2: 5633.16,
    y2: 172,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 5228.63,
    y1: 169.93,
    x2: 5418.41,
    y2: 249.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 156.43,
    cy: 183.45,
    r: 35.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b61b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#38498a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#273360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#19203e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0e1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#06080f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-19",
    x1: 5236.94,
    y1: 278.38,
    x2: 5429.02,
    y2: 235.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 5229.88,
    y1: 170.44,
    x2: 5418.28,
    y2: 249.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-21",
    x1: 5427.95,
    y1: 214.67,
    x2: 5607.85,
    y2: 160.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-22",
    x1: 5260.73,
    y1: 254.26,
    x2: 5497.84,
    y2: 201.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 5265.45,
    y1: 166.59,
    x2: 5536.46,
    y2: 280.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 5597.82, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 225.22,
    y1: 385.06,
    x2: 398.27,
    y2: 333.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56ef4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 46.48,
    y1: 406.03,
    x2: 274.07,
    y2: 355.02,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 256.75,
    y1: 335.84,
    x2: 101.83,
    y2: 222.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8a2076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#601652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3e0e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#23081e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0f030d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-23",
    x1: 5676.84,
    y1: 4068.36,
    x2: 5775.87,
    y2: 4038.7,
    gradientTransform: "translate(5863.79 4216.9) rotate(180)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-24",
    x1: 5583.44,
    y1: 4080.39,
    x2: 5713.89,
    y2: 4051.15,
    gradientTransform: "translate(5863.79 4216.9) rotate(180)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-25",
    x1: 5704.44,
    y1: 3960.43,
    x2: 5662.85,
    y2: 4039.69,
    gradientTransform: "translate(5863.79 4216.9) rotate(180)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-2",
    x1: 207.23,
    y1: 172.36,
    x2: 289.71,
    y2: 147.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-3",
    x1: 129.45,
    y1: 182.38,
    x2: 238.08,
    y2: 158.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-4",
    x1: 230.22,
    y1: 82.47,
    x2: 195.58,
    y2: 148.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_38",
    x1: 198,
    y1: 161.76,
    x2: 198,
    y2: 43.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#741bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#56148b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3b0e60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#26093e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#150523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#09020f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#020104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 198,
    y1: 152.7,
    x2: 198,
    y2: 18.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#29eef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#1fb7be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#17868b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#105d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0a3b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#062123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#030f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 3906.36,
    y1: 305.18,
    x2: 3962.49,
    y2: 292.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 3915.11,
    y1: 299.96,
    x2: 3939.19,
    y2: 292.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-10",
    x1: 3942.01,
    y1: 262.51,
    x2: 3925.05,
    y2: 294.82,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-9",
    cx: 288.7,
    cy: 298.3,
    r: 9.69,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-11",
    x1: 3967.53,
    y1: 247.63,
    x2: 3950.58,
    y2: 279.94,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-10",
    cx: 263.17,
    cy: 283.42,
    r: 9.69,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-12",
    x1: 3992.51,
    y1: 233.3,
    x2: 3975.56,
    y2: 265.61,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-11",
    cx: 238.2,
    cy: 269.09,
    r: 9.69,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-28",
    x1: 234.6,
    y1: 304.16,
    x2: 475.71,
    y2: 231.97,
    gradientTransform: "translate(142 50.84)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-29",
    x1: 26.29,
    y1: 333.51,
    x2: 344.3,
    y2: 262.22,
    gradientTransform: "translate(142 50.84)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-30",
    x1: -57.45,
    y1: 300.62,
    x2: 169.87,
    y2: 232.55,
    gradientTransform: "translate(142 50.84)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-31",
    x1: -253.84,
    y1: 328.29,
    x2: 45.98,
    y2: 261.08,
    gradientTransform: "translate(142 50.84)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-32",
    x1: 3918.78,
    y1: 437.24,
    x2: 4149.61,
    y2: 385.49,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-33",
    x1: 3954.2,
    y1: 415.73,
    x2: 4052.35,
    y2: 386.34,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 4065.77,
    y1: 261.92,
    x2: 3995.24,
    y2: 396.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-12",
    cx: 205.47,
    cy: 406.28,
    r: 39.44,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-4",
    x1: 3730.15,
    y1: 249.54,
    x2: 3965.39,
    y2: 196.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-5",
    x1: 400.51,
    y1: 237.04,
    x2: 437.91,
    y2: 194.2,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-6",
    x1: 3892.63,
    y1: 112.89,
    x2: 3838.04,
    y2: 216.94,
    gradientTransform: "matrix(-1, 0, 0, 1, 4217.88, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-13",
    cx: 369.17,
    cy: 218.77,
    r: 23.47,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -1083.52,
    y1: 102.84,
    x2: -1107.73,
    y2: 84.54,
    gradientTransform: "matrix(0.87, 0.5, -1.5, 0.29, 1464.43, 730.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 368.04,
    y1: 200.16,
    x2: 381.61,
    y2: 221.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a17bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a883c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b490cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c5a3dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#dbbbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6b6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b595dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9d7dcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8e6ec6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 5631.11,
    y1: 239.32,
    x2: 5631.11,
    y2: 234.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 5990.27, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-5",
    x1: 359.27,
    y1: 239.21,
    x2: 357.11,
    y2: 222.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 5622.13,
    y1: 244.74,
    x2: 5624.07,
    y2: 239.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 5990.27, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-6",
    x1: 5626.02,
    y1: 232.17,
    x2: 5626.13,
    y2: 218.86,
    gradientTransform: "matrix(-1, 0, 0, 1, 5990.27, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-16",
    x1: 345.13,
    y1: 257.28,
    x2: 363.06,
    y2: 228.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-17",
    x1: 353.49,
    y1: 236.56,
    x2: 382.64,
    y2: 227.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-18",
    x1: 325.81,
    y1: 239.44,
    x2: 363.31,
    y2: 231.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-2",
    x1: 353.49,
    y1: 235.8,
    x2: 382.64,
    y2: 227.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-3",
    x1: 325.81,
    y1: 238.69,
    x2: 363.31,
    y2: 230.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-4",
    x1: 364.54,
    y1: 204.23,
    x2: 349.13,
    y2: 233.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 193.2,
    cy: -2961.15,
    r: 4.95,
    gradientTransform: "matrix(-0.36, 0.93, 0.93, 0.36, 3195.6, 1094.59)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -1575.64,
    cy: -1732.16,
    r: 5.61,
    gradientTransform: "matrix(-0.18, 0.98, 0.98, 0.18, 1778.79, 2069.28)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-19",
    x1: 4971.97,
    y1: 67.4,
    x2: 4990.25,
    y2: 67.4,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, 5320, -128.29)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-7",
    x1: 350.92,
    y1: 225.84,
    x2: 348.05,
    y2: 221.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-8",
    x1: 356.34,
    y1: 231.71,
    x2: 356.46,
    y2: 218.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 3565.01,
    cy: 560.76,
    r: 7.51,
    gradientTransform: "matrix(-0.99, -0.15, -0.15, 0.99, 3962.69, 190.51)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 3571.17,
    y1: 564.94,
    x2: 3566.1,
    y2: 555.98,
    gradientTransform: "matrix(-0.99, -0.15, -0.15, 0.99, 3962.69, 190.51)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-20",
    x1: 367.73,
    y1: 583.43,
    x2: 377.18,
    y2: 568.18,
    gradientTransform: "matrix(0.99, 0.15, -0.15, 0.99, 69.41, -411.71)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-4",
    x1: 357.23,
    y1: 212.84,
    x2: 349.62,
    y2: 206.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 4157.63,
    cy: 886.6,
    r: 5.42,
    gradientTransform: "translate(3856.81 2644.95) rotate(-157.13)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 2797.55,
    cy: 54.84,
    r: 5.61,
    gradientTransform: "translate(1883.63 2575.43) rotate(-123.77)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-21",
    x1: 384.56,
    y1: -107.31,
    x2: 389.93,
    y2: -116.73,
    gradientTransform: "translate(-7.83 382.3) rotate(-7.86)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-5",
    x1: 349.13,
    y1: 228.85,
    x2: 356.7,
    y2: 226.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-6",
    x1: 322.25,
    y1: 229.49,
    x2: 364.77,
    y2: 219.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-7",
    x1: 343.94,
    y1: 212.38,
    x2: 342.09,
    y2: 215.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 201.54,
    y1: 2.15,
    x2: 274.86,
    y2: 90.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#3ec2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3790a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#32658c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2d4375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2a2864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#271457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26094f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1dc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -320.72,
    y1: 2367.47,
    x2: -285.53,
    y2: 2367.47,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 521.8, -2523.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e00d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -317.03,
    y1: 2372.51,
    x2: -298.5,
    y2: 2372.51,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 266.57,
    y1: 55.46,
    x2: 271.98,
    y2: 81.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 270.97,
    y1: 64.19,
    x2: 257.14,
    y2: 41.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 251.4,
    y1: 46.03,
    x2: 263.12,
    y2: 56.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 265.64,
    y1: 61.96,
    x2: 253.77,
    y2: 47.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 5406.87,
    y1: -777.53,
    x2: 5415.81,
    y2: -777.53,
    gradientTransform: "matrix(0, -1.15, 0.87, 0.5, 935.51, 6700.66)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 5406.95,
    y1: -784.97,
    x2: 5413.53,
    y2: -784.97,
    gradientTransform: "matrix(0, -1.15, 0.87, 0.5, 935.51, 6700.66)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 250.37,
    y1: 51.67,
    x2: 259.69,
    y2: 56.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 205.96,
    y1: 37.59,
    x2: 242.06,
    y2: 37.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 119.36,
    y1: 33.2,
    x2: 193.15,
    y2: 63.12,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 7606.24,
    y1: 88.06,
    x2: 7608.04,
    y2: 38.56,
    gradientTransform: "matrix(-1, 0, 0, 1, 7764.88, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 7604.45,
    y1: 17.85,
    x2: 7607.67,
    y2: 68.42,
    gradientTransform: "matrix(-1, 0, 0, 1, 7764.88, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 7606.96,
    y1: 59.62,
    x2: 7608.45,
    y2: 85.16,
    gradientTransform: "matrix(-1, 0, 0, 1, 7764.88, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 363.63,
    y1: 150.41,
    x2: 410.42,
    y2: 206.31,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 5561.59,
    y1: 143.19,
    x2: 5626.19,
    y2: 220.37,
    gradientTransform: "matrix(-1, 0, 0, 1, 5629.67, 0)",
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 5567.8,
    y1: 188.17,
    x2: 5622.43,
    y2: 188.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 5629.67, 0)",
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 5753.89,
    cy: 101.3,
    r: 25.2,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 5758.97,
    cy: 102.26,
    r: 20.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 5769.64,
    y1: 76.61,
    x2: 5801.76,
    y2: 69.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-5",
    x1: 5769.91,
    y1: 76.68,
    x2: 5800.49,
    y2: 69.82,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 5770.19,
    y1: 76.39,
    x2: 5798.6,
    y2: 70.03,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 5757.47,
    cy: 102.12,
    r: 23.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 5761.95,
    cy: 107.27,
    r: 22.44,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-8",
    x1: 5763.45,
    y1: 88.84,
    x2: 5783.52,
    y2: 88.84,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-9",
    x1: 5776.62,
    y1: 89.21,
    x2: 5757.39,
    y2: 87.87,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 5783.89,
    cy: 75.32,
    r: 3.48,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 5783.89,
    cy: 75.22,
    r: 3.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-10",
    x1: 5764.07,
    y1: 72.91,
    x2: 5779.96,
    y2: 64.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 149.53,
    y1: 78.2,
    x2: 164.36,
    y2: 75.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-11",
    x1: 151.79,
    y1: 76.5,
    x2: 164.59,
    y2: 76.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 5769.65,
    cy: 59.71,
    r: 5.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-6",
    x1: 5767.07,
    y1: 66.55,
    x2: 5769.97,
    y2: 64.19,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-12",
    x1: 5766.39,
    y1: 65.24,
    x2: 5773.9,
    y2: 65.24,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-14",
    cx: 5768.97,
    cy: 67.12,
    r: 2.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 5768.18,
    y1: 62.98,
    x2: 5770.21,
    y2: 53.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-13",
    x1: 142.53,
    y1: 77.7,
    x2: 158.07,
    y2: 73.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 5766.09,
    y1: 62.5,
    x2: 5766.09,
    y2: 56.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 5926.34, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-34",
    x1: 198.76,
    y1: 381.32,
    x2: 183.65,
    y2: 320.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-35",
    x1: 179.86,
    y1: 339.97,
    x2: 329.68,
    y2: 295.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-36",
    x1: 163.57,
    y1: 336.56,
    x2: 218.93,
    y2: 336.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-37",
    x1: 133.59,
    y1: 370.65,
    x2: 182.92,
    y2: 359.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-38",
    x1: 252.12,
    y1: 197.33,
    x2: 184.07,
    y2: 327.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 274.55,
    y1: 4198.76,
    x2: 273.25,
    y2: 4192.28,
    gradientTransform: "matrix(0.99, -0.1, -0.1, -0.99, 226.76, 4377.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f9b69e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fdd7c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedfcb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 72.92,
    cy: 203.69,
    r: 4.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 81.44,
    y1: 228.07,
    x2: 81.44,
    y2: 222.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-13",
    x1: 78.69,
    y1: 213.32,
    x2: 86.4,
    y2: 213.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 72.02,
    y1: 233.76,
    x2: 74.05,
    y2: 227.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-14",
    x1: 70.57,
    y1: 215.68,
    x2: 80.43,
    y2: 215.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 75.33,
    cy: 166.13,
    r: 6.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 80.96,
    y1: 169.96,
    x2: 76.33,
    y2: 161.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-15",
    x1: 68.39,
    y1: 174.64,
    x2: 86.64,
    y2: 174.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_10-7",
    x1: 78.75,
    y1: 173.93,
    x2: 77.31,
    y2: 171.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-16",
    x1: 70.27,
    y1: 187,
    x2: 87.57,
    y2: 187,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-17",
    x1: 74.78,
    y1: 180.82,
    x2: 79.02,
    y2: 169.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-15",
    cx: 77.99,
    cy: 174.33,
    r: 4.22,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: -579.96,
    cy: 673.26,
    r: 4.79,
    gradientTransform: "translate(717.8 -403.08) rotate(6.44)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-18",
    x1: 66.65,
    y1: 188.92,
    x2: 77.3,
    y2: 188.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 5655.94,
    y1: 370.14,
    x2: 5678.33,
    y2: 370.14,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#linear-gradient-100"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 5679.09,
    y1: 342.41,
    x2: 5685.89,
    y2: 342.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#linear-gradient-100"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 5678.02,
    y1: 346.96,
    x2: 5680.06,
    y2: 344.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-22",
    x1: 5654.78,
    y1: 395.62,
    x2: 5672.89,
    y2: 366.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-16",
    cx: 5671.61,
    cy: 380.87,
    r: 12.1,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-23",
    x1: 5663.22,
    y1: 374.7,
    x2: 5692.66,
    y2: 365.88,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_13-24",
    x1: 5635.27,
    y1: 377.61,
    x2: 5673.14,
    y2: 369.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-14",
    x1: 5663.22,
    y1: 373.93,
    x2: 5692.66,
    y2: 365.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-15",
    x1: 5635.27,
    y1: 376.85,
    x2: 5673.14,
    y2: 368.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-16",
    x1: 5674.38,
    y1: 342.05,
    x2: 5658.82,
    y2: 371.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-17",
    cx: 5669,
    cy: 374.36,
    r: 9.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 5660.95,
    y1: 373.59,
    x2: 5683.33,
    y2: 373.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#linear-gradient-100"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 5651.34,
    y1: 363.96,
    x2: 5674,
    y2: 363.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#270656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-19",
    x1: 5653.14,
    y1: 347.84,
    x2: 5640.44,
    y2: 354.2,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 5655.48,
    y1: 334.55,
    x2: 5664.33,
    y2: 334.55,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#linear-gradient-100"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-20",
    x1: 5647.69,
    y1: 356.42,
    x2: 5665.83,
    y2: 343.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-21",
    x1: 5667.1,
    y1: 362.5,
    x2: 5670.79,
    y2: 343.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 5660.51,
    cy: -1566.11,
    r: 7.83,
    gradientTransform: "matrix(-1, 0, 0, 1.3, 5876.24, 2369.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd65b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa98c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-17",
    x1: 5658.82,
    y1: 366.91,
    x2: 5666.46,
    y2: 364.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-18",
    x1: 5631.68,
    y1: 367.57,
    x2: 5674.62,
    y2: 357.94,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-19",
    x1: 5653.58,
    y1: 350.28,
    x2: 5651.71,
    y2: 353.84,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-18",
    cx: 5653.83,
    cy: 359,
    r: 7.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 5876.24, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 4523.82,
    y1: 415.68,
    x2: 4519.99,
    y2: 409.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a5a2b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b7b4c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9b98a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 4519.93,
    y1: 415.15,
    x2: 4523.31,
    y2: 409.32,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 4522.16,
    y1: 416.01,
    x2: 4518.87,
    y2: 410.32,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a5a2b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#b7b4c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9b98a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 4518.55,
    y1: 415.71,
    x2: 4521.45,
    y2: 410.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 4520.64,
    cy: 413.15,
    r: 2.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 4532.81,
    y1: 420.85,
    x2: 4528.98,
    y2: 414.22,
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 4528.92,
    y1: 420.32,
    x2: 4532.3,
    y2: 414.49,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 4531.15,
    y1: 421.18,
    x2: 4527.86,
    y2: 415.49,
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 4527.54,
    y1: 420.88,
    x2: 4530.44,
    y2: 415.88,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 4529.63,
    cy: 418.32,
    r: 2.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 4505.46,
    y1: 405.31,
    x2: 4501.63,
    y2: 398.68,
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 4501.57,
    y1: 404.78,
    x2: 4504.95,
    y2: 398.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 4503.8,
    y1: 405.64,
    x2: 4500.51,
    y2: 399.95,
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 4500.19,
    y1: 405.34,
    x2: 4503.09,
    y2: 400.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 4502.27,
    cy: 402.78,
    r: 2.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 4514.45,
    y1: 410.48,
    x2: 4510.62,
    y2: 403.85,
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 4510.56,
    y1: 409.95,
    x2: 4513.94,
    y2: 404.12,
    gradientTransform: "matrix(-0.5, -0.86, -0.86, 0.5, 2885.42, 4097)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 4512.79,
    y1: 410.81,
    x2: 4509.5,
    y2: 405.12,
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 4509.18,
    y1: 410.51,
    x2: 4512.08,
    y2: 405.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 4511.26,
    cy: 407.95,
    r: 2.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 4767.91, 0)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 319.37,
    y1: 280.98,
    x2: 279.47,
    y2: 425.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c46aa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9033c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 353.82,
    y1: 320.31,
    x2: 274.03,
    y2: 441.81,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 382.27,
    y1: 271.84,
    x2: 279.81,
    y2: 441.85,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 402,
    y1: 330.45,
    x2: 268.7,
    y2: 453.31,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: -991.49,
    y1: 415.68,
    x2: -995.32,
    y2: 409.05,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -995.39,
    y1: 415.15,
    x2: -992,
    y2: 409.32,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -993.16,
    y1: 416.01,
    x2: -996.44,
    y2: 410.32,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -996.76,
    y1: 415.71,
    x2: -993.86,
    y2: 410.71,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: -994.68,
    cy: 413.15,
    r: 2.36,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -982.5,
    y1: 420.85,
    x2: -986.33,
    y2: 414.22,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -986.4,
    y1: 420.32,
    x2: -983.01,
    y2: 414.49,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -984.16,
    y1: 421.18,
    x2: -987.45,
    y2: 415.49,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -987.77,
    y1: 420.88,
    x2: -984.87,
    y2: 415.88,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: -985.69,
    cy: 418.32,
    r: 2.36,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -1009.86,
    y1: 405.31,
    x2: -1013.68,
    y2: 398.68,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -1013.75,
    y1: 404.78,
    x2: -1010.37,
    y2: 398.95,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -1011.52,
    y1: 405.64,
    x2: -1014.8,
    y2: 399.95,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -1015.12,
    y1: 405.34,
    x2: -1012.22,
    y2: 400.34,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: -1013.04,
    cy: 402.78,
    r: 2.36,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -1000.87,
    y1: 410.48,
    x2: -1004.69,
    y2: 403.85,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -1004.76,
    y1: 409.95,
    x2: -1001.38,
    y2: 404.12,
    gradientTransform: "translate(1250.33 562.28) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -1002.53,
    y1: 410.81,
    x2: -1005.81,
    y2: 405.12,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#linear-gradient-112"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -1006.13,
    y1: 410.51,
    x2: -1003.23,
    y2: 405.51,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#New_Gradient_Swatch_copy_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: -1004.05,
    cy: 407.95,
    r: 2.36,
    gradientTransform: "translate(1181.63)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 102.55,
    y1: 322.17,
    x2: 149.47,
    y2: 418.4,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 88.6,
    y1: 301.25,
    x2: 155.58,
    y2: 439.98,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 27.86,
    y1: 289.48,
    x2: 166.59,
    y2: 445.89,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 4.07,
    y1: 343.71,
    x2: 175.79,
    y2: 450.81,
    xlinkHref: "#linear-gradient-126"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "158.24 424.64 216.63 458.64 276.66 423.8 218.24 389.84 158.24 424.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "159.91 424.59 216.73 457.68 274.98 423.88 218.12 390.83 159.91 424.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.58 424.54 216.84 456.72 273.3 423.95 218.01 391.82 161.58 424.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "163.25 424.5 216.94 455.76 271.62 424.03 217.9 392.81 163.25 424.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "164.92 424.45 217.04 454.8 269.94 424.1 217.78 393.8 164.92 424.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "166.59 424.4 217.15 453.84 268.26 424.18 217.67 394.78 166.59 424.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "168.26 424.36 217.25 452.88 266.58 424.25 217.56 395.77 168.26 424.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "169.94 424.31 217.36 451.92 264.89 424.33 217.45 396.76 169.94 424.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "171.61 424.26 217.46 450.96 263.21 424.4 217.33 397.75 171.61 424.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "173.28 424.22 217.56 450 261.53 424.48 217.22 398.74 173.28 424.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "174.95 424.17 217.67 449.04 259.85 424.56 217.11 399.72 174.95 424.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "176.62 424.12 217.77 448.08 258.17 424.63 217 400.71 176.62 424.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "319.18 197.15 319.18 208.03 256.14 171.92 256.14 161.04 319.18 197.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "319.14 197.15 319.14 208.03 382.14 170.79 382.14 159.96 319.14 197.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-142",
    points: "382.14 159.96 319.14 197.15 256.14 161.04 319.22 123.81 382.14 159.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "318.93 202.29 320.04 196.92 381.08 160.86 319.19 196.43 257.59 162.14 318.48 197.48 318.93 202.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M339.31,157.69c-5.47,2.28-8.17.47-12.28-1.91s-4.58-4.71-1.42-6.19c6-2.8,9.36,0,13.47,2.4S342.53,156.34,339.31,157.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M316.17,173c-6,2.28-8.7.54-12.81-1.83s-5.9-4.42-1.42-6.2,8.77.09,12.88,2.47S319.43,171.77,316.17,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M315.51,143.92a6.75,6.75,0,0,0,.66,2.27c.28.58.37,1.24.68,1.13s-.09-2.78-.09-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M301.34,167.52a3.35,3.35,0,0,0-.07,1.64,1.76,1.76,0,0,0,2.15.47c.85-.42,1.22-1.3,1.55-1.53s2.15-.44,3.51-1.6,1.18-2.42-.19-2.45a11.35,11.35,0,0,0-4.71,1.18A14.46,14.46,0,0,0,301.34,167.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M302,168.77c1,.2,2.22-.65,2.8-1.13s1.6-.23,2.91-1.27,1.78-1.76,1.18-2.11-2.79-.25-4.5.68-2.85,1.59-2.85,1.59-.42,1.27-.21,1.55S301.43,168.65,302,168.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M302,139.6a22.31,22.31,0,0,0-.24,7.08c.48,3.95-.28,11.89-.45,14.7s-1.15,6.26.27,7a3.06,3.06,0,0,0,3.44-1.14c1.14-1.32,1.39-2.6,1.25-2.84s-.35-1.32.1-3.65a71.9,71.9,0,0,0,1.28-9.81c-.07-1.84-.72-10.48-.72-10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M307.62,150.91a71.9,71.9,0,0,1-1.28,9.81c-.45,2.33-.24,3.4-.1,3.65s-.11,1.52-1.25,2.84a4,4,0,0,1-1.44,1.07,12.75,12.75,0,0,0,1.23-6c0-4.79,1-10.89,1.13-14.22.08-1.95-.37-5.63-.37-8l1.36.4S307.55,149.07,307.62,150.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M315.84,119.19s3-.3,4.16.28,3.1,2.43,3.11,3-1.61,1.23-2.57,1-1.07-.42-1.85-.58a15.76,15.76,0,0,1-2.91-1C315.21,121.6,315.84,119.19,315.84,119.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M332.9,147.93l.4,2.24a12.27,12.27,0,0,1-1.62.81c-.51.17-1.34-.16-1.76.37a7.83,7.83,0,0,1-3.54,2.18c-1.52.3-2.59-.19-2.61-.63s.37-1.15,1.76-2.06a10.15,10.15,0,0,0,2.56-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M333,149.37c-.21.25-2.76.85-3.18,1.38a10.4,10.4,0,0,1-4,2.28c-1.1.19-1.94-.36-1.83-.78.15-.6,1.15-1.15,2-1.82a10.11,10.11,0,0,0,1.83-2.22l5.22-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M340.39,152l.05,2.09-.95.94-.3-.11a6.59,6.59,0,0,1-2.43,2.7,4.16,4.16,0,0,1-3.93.4c-.46-.37-.46-.72.7-2.27l2.82-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M340.28,153.24a18.8,18.8,0,0,0-2.27,2.47,4.74,4.74,0,0,1-4.72,1.93c-1.52-.51.53-2.11.95-2.8s1.6-2.43,1.6-2.43l4.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M327.69,122.27s-.47,10-.41,12.35,1.45,8.62,1.21,9.73-.76,2.09-.9,2.78-.34,1.65-.34,1.65a4.5,4.5,0,0,0,3.19,1.21c1.7-.21,2.58-.52,2.74-.94s-.24-11.27-.24-11.27l.23-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.8,146.94c.25-2.77-.56-6.21-1.43-10-.73-3.15-.34-10.81-.19-13.16l2.93.78-.17,13.18s.4,10.85.24,11.27-1,.7-2.51.91A9.62,9.62,0,0,0,331.8,146.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M332.4,122.92s.68,7.92.85,11.43a68.45,68.45,0,0,0,1.49,10.26,22.07,22.07,0,0,1,.83,5.73c-.13,1.28-.72,2.29,0,2.84a6.45,6.45,0,0,0,3.95.56c.63-.32,1.15-.25,1.15-1.5a105.31,105.31,0,0,0-.66-11.09c-.49-2.81.3-12.65.31-13.91a8.31,8.31,0,0,0-1.11-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M334.08,98.52c1.25.35,2.81.24,1.46,3.47s-6.24,14.22-6.24,14.22a19.46,19.46,0,0,1-1.43-7.46c.25-3.47,2.33-9.4,2.33-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M331.63,102.47l-.53-.23-.35.37.14.77a40.17,40.17,0,0,0-2,4.64,13.25,13.25,0,0,0-.47,5.25,10.5,10.5,0,0,0,1.23,2.73s.74-5.32,1-6.59,1-5.8,1-5.8l.53-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M331.45,98.66a3.76,3.76,0,0,0-2.73.87c-.85.77-1.32,1.76-1.58,3.71-.24,1.72.08,5.55,0,6.52s-.39,7.11-.56,9-.76,4.1.31,5.17,2.22,1.63,2.5,1,1.11-6.21.66-7.87-1.7-5.07-1.63-7.11,1-7.53,1.56-8.61S331.45,98.66,331.45,98.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.63,106.48c.14-1.89.18-3.37.18-3.37l.74-.4-.49-.87a3.27,3.27,0,0,0,1.18-1.18,14.84,14.84,0,0,1,1.47-2h0a2.83,2.83,0,0,1,.73,0s-.87,1.63-1.46,2.7-1.49,6.56-1.56,8.61a17,17,0,0,0,.88,4.61c-.22-.5-.62-1.54-.71-1.82A20.55,20.55,0,0,1,327.63,106.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M327.79,106.29c.14-1.9.19-3.38.19-3.38l.85-.23-.6-1.1a1.85,1.85,0,0,0,1-.88,5.14,5.14,0,0,1,1.52-2.06h0a2.83,2.83,0,0,1,.73,0s-.87,1.63-1.46,2.7-1.49,6.56-1.56,8.61a17,17,0,0,0,.88,4.61c-.22-.5-.62-1.54-.71-1.82A21.87,21.87,0,0,1,327.79,106.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M339.25,122.66a8.31,8.31,0,0,1,1.11,4.58c0,1.26-.8,11.1-.31,13.91a105.31,105.31,0,0,1,.66,11.09c0,1.25-.52,1.18-1.15,1.5a3.42,3.42,0,0,1-1.4.1,9.23,9.23,0,0,0,1.15-4.07c.3-4-1.15-8.46-.95-12.12a104.77,104.77,0,0,0-.26-14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331,99.19l3.1-.67c1,.27,2.11.27,2,1.73a17.94,17.94,0,0,1-2,3,24.48,24.48,0,0,0-1.71,1.86l-.9-3.2L329.87,104a15,15,0,0,1,.05-2.44A22.87,22.87,0,0,1,331,99.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M331,99.19l3.1-.67c1,.27,2.11.27,2,1.73a17.94,17.94,0,0,1-2,3,11.17,11.17,0,0,1-1.66,1.39l-1-2.73-1.48,1.62a8.79,8.79,0,0,1,0-2A22.87,22.87,0,0,1,331,99.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M335.17,98.61s1,.3.44,1.69-2.64,3.72-4,6.91a24.45,24.45,0,0,0-2.2,10.43c.09,3.86.37,7.34,1.25,8.26s4,2.19,7.19,1.64,4.12-1.78,3.77-2.55-2.22-8.71-2.36-9.89,1-4.33,1.32-5.57.95-3.77.51-5.16-1.23-1.55-2-2.38c-.52-.54-1.32-1.33-2.26-2.14A5.2,5.2,0,0,0,335.17,98.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.61,107.21c1.36-3.19,3.47-5.52,4-6.91.45-1.18-.19-1.58-.38-1.66h0a4.57,4.57,0,0,1,1.55.9,5.77,5.77,0,0,1-.2,2.81,7.44,7.44,0,0,0-.31,2.47l-1.18.25v1.16s-.51-.43-2.07,2.08-2.69,3.83-3.52,6.86A25.57,25.57,0,0,1,331.61,107.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M331.61,107.21c1.36-3.19,3.47-5.52,4-6.91.45-1.18-.19-1.58-.38-1.66h0a4.57,4.57,0,0,1,1.55.9,5.77,5.77,0,0,1-.2,2.81c-.42,1.75-.53,2.15-.53,2.15l-1.18.25v1.16s-.81-.1-2.25,2.48a25.8,25.8,0,0,0-3.12,6.78A25.57,25.57,0,0,1,331.61,107.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M332.51,108.31c1.44-2.58,2.26-2.57,2.26-2.57v-1.15l1.18-.26s.11-.39.53-2.15a5.55,5.55,0,0,0,.18-2.74l.12.09a5.77,5.77,0,0,1-.2,2.81c-.42,1.75-.53,2.15-.53,2.15l-1.18.25v1.16s-.81-.1-2.25,2.48a25.8,25.8,0,0,0-3.12,6.78c0-.34.09-.56.13-.9A28.71,28.71,0,0,1,332.51,108.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M338.87,118.94s-1,.39-2,.69-2.24.62-2.24.62,0,1.5.61,1.53,3.68-.79,3.86-1.16S338.87,118.94,338.87,118.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M338.87,118.94s-1,.39-2,.69-2.24.62-2.24.62.09,1.23.69,1.25,3.68-.78,3.86-1.15S338.87,118.94,338.87,118.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M324.35,117.76a4.23,4.23,0,0,0,.46,2.12,7.57,7.57,0,0,0,1.55,1.85s.16-2.1-.39-2.89A3.37,3.37,0,0,0,324.35,117.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M325,117.85a3.09,3.09,0,0,1-1.22.59,19.09,19.09,0,0,0-2.89.18c-.55.2-2.28.71-2.32,1.18s.58.16,1.09.09,1.33-.14,1.33-.14a10.23,10.23,0,0,1-1.65,1.42c-.63.36-1.65.53-1.82.89s.05.7.57,1a3.11,3.11,0,0,0,2.08.39,5.19,5.19,0,0,0,3-.87c.54-.44,2.05-1.63,2.39-1.83a14.84,14.84,0,0,1,1.57-.67l-2.06-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M318.1,123.11c-.52-.35-.73-.69-.57-1a.62.62,0,0,1,.16-.17,3.17,3.17,0,0,0,2.64.63,14.2,14.2,0,0,0,3.91-2.41,8.77,8.77,0,0,1,2.5-1.09l.42,1.11a14.84,14.84,0,0,0-1.57.67c-.34.2-1.85,1.39-2.39,1.83a5.19,5.19,0,0,1-3,.87A3.11,3.11,0,0,1,318.1,123.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337,123.5c0-2.55-1.69-5.79-2.48-7.7s.23-7.7,1.43-10.22c1-2,3.82-1.34,5.27-.7a13.72,13.72,0,0,1-.62,4.65c-.35,1.24-1.46,4.39-1.32,5.57s2,9.13,2.36,9.89-.58,2-3.77,2.55a11.31,11.31,0,0,1-1.62.14A12.72,12.72,0,0,0,337,123.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M340.29,103.18c1.35.42,1.42,3,.57,4.92-.55,1.23-1.85,4-2.31,5.24s-1.21,3.68-2.5,4.37-4.7,1.83-6,2.41-3.65,1.61-3.65,1.61a12,12,0,0,0-1-2.59,5.71,5.71,0,0,0-1-1.38s4.58-2.15,6.15-3,2.38-1.37,2.73-2.17,1.47-4.32,1.84-5.18C336,105.23,337.1,102.16,340.29,103.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M308.6,171.64s-.51,1.5.11,1.82a2.92,2.92,0,0,0,2.38.17c.79-.35,1.11-.7,1.94-.7a11.71,11.71,0,0,0,4.7-2.38c.62-.79,0-1.69-1.55-1.57a36.81,36.81,0,0,0-4.16.44C311.62,169.56,308.6,171.64,308.6,171.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M309.29,172.75c1.45.17,1.92-.23,3.26-.51s5.15-1.82,5.08-2.68-.94-.67-1.68-.6-3.1.23-3.29.23-4,1.73-4,1.73-.28,1.25,0,1.43S308.9,172.7,309.29,172.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M306.48,140.64a8.09,8.09,0,0,0,0,5.1,45.72,45.72,0,0,1,1.83,11.13c0,4.1-.45,14.68.18,15.26a3.88,3.88,0,0,0,3.71.14c1.44-1.06,2.22-2.56,2.08-3.08s-1.25-2.4-.87-4.06,1.67-7.42,1.42-11.34-.9-14.15-.9-14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M310,108.28c.92.45,1.85,1.21,1.89,3.52s.07,3.42-.39,3.72-.81,0-.9.65a7.28,7.28,0,0,0,.09,1.71l-5-1.13a2.4,2.4,0,0,0,0-1.65c-.33-.83-1.79-2.45-.68-4.83A4,4,0,0,1,310,108.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M312,110.25c0,.44-.25,1.15-.88,1.2a.94.94,0,0,0-.78,1.13c.14.35,0,.44,0,.44s-.46-.18-.67.19.07,1.15.21,1.46-.9,1.22-1.76,1.29-2,0-2.38-.46a4.83,4.83,0,0,1-1.25-4.28,4.13,4.13,0,0,1,4.67-3.38C311.19,108.24,312,109.62,312,110.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M316.23,119a1.49,1.49,0,0,1,.53,1.35,7.85,7.85,0,0,1-.95,2.22l-8.76-.49s-6.76-.29-6.46-3,2.09-2.51,6-1.49a35.84,35.84,0,0,0,6.71,1.29C314.56,119,316.23,119,316.23,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M311.55,119.18s-.55-1.9-1.68-2.13a17.05,17.05,0,0,1-2.89-.44,3,3,0,0,1-1.18-1s-.87.24-.23,1S311.55,119.18,311.55,119.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M316.35,121.59c-.33.65-.54,1-.54,1l-8.76-.49s-6.74-.29-6.46-3c1.62.4,5.69,2.06,9.4,2.26C313.39,121.52,315.47,121.57,316.35,121.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.29,140l2.61-.35s.66,10.23.9,14.15-1,9.67-1.42,11.34.73,3.54.87,4.06-.51,1.76-1.72,2.79a35.26,35.26,0,0,0-.12-6c-.15-1.8,1.2-8.34.83-12.24C312.91,150.31,311.62,142.07,311.29,140Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M307.35,117.39a12.47,12.47,0,0,1-2.13-1,19.86,19.86,0,0,0-2.53.11,2.63,2.63,0,0,0-2.24,2.73,37.3,37.3,0,0,0,1.05,6.38,14.52,14.52,0,0,1,.11,6.62c-.44,2.43-2,7.74-1.85,8.32s1.44,2.64,4.47,3.7,8.06,1.32,10.1-1-.6-10.37-.72-14.3,1.32-5.58-.34-7.62a10.66,10.66,0,0,0-4.61-3.53A9.6,9.6,0,0,1,307.35,117.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.69,119.31a4.23,4.23,0,0,0-2.35-1.64,9.73,9.73,0,0,1-3.23-.89,1.74,1.74,0,0,1-.74-.91l-1.35.5a2.24,2.24,0,0,0,1.78,2.2c1.9.57,4,.55,5.41,1.35a12.44,12.44,0,0,1,2.1,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M311.69,119.31a4.23,4.23,0,0,0-2.35-1.64,9.73,9.73,0,0,1-3.23-.89,1.74,1.74,0,0,1-.74-.91l-1.35.5s0,1.32,1.92,1.9,4.37.74,5.57,1.64a19.14,19.14,0,0,1,1.8,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M304.16,116.32c0,.27.26,1.34,1.91,1.84,1.89.58,4.37.74,5.57,1.64.45.34.82.64,1.1.88l.57.74a19.14,19.14,0,0,0-1.8-1.51c-1.2-.9-3.68-1.06-5.57-1.64s-1.92-1.9-1.92-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M335.12,98.15l.4.86a10.14,10.14,0,0,1-2.06,2.49c-.88.56-1.92,1.18-2.22.74a8,8,0,0,1-.63-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M335.17,98.61l-.49,0a10.18,10.18,0,0,1-2.38,2.08c-.9.37-1.78.41-2.17-.21a14.88,14.88,0,0,1-.65-5.94c.33-1.51,2.45-4.35,5.55-2.29s.9,5.68.79,5.8S335.17,98.61,335.17,98.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M335.82,98.14s.45-1,0-1.33a.51.51,0,0,0-.18-.09.61.61,0,0,0-.62.19l-.43.47s-.08-.49-.29-1.4c-.14-.59-.88-1.11-2.41-1-.81.07-1.82.48-2.38,0s-.11-1.39.16-1.85,2.89-3.15,5.64-1.18S336.56,97.41,335.82,98.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.56,122.75c1.3-1.94,3.17-.39,4.52.92a46.21,46.21,0,0,0-.47,5.27c.12,3.93,2.75,12,.72,14.3a6.43,6.43,0,0,1-4.48,1.77,27.29,27.29,0,0,0,.35-3.18c.15-3.38-.87-5.26-1.28-9.8S307.87,125.27,309.56,122.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304.47,111.41a5.12,5.12,0,0,0,2.38,1,8,8,0,0,0,3.45-.2.68.68,0,0,0,0,.38c.14.35,0,.44,0,.44s-.46-.18-.67.19.07,1.15.21,1.46-.9,1.22-1.76,1.29-2,0-2.38-.46A4.85,4.85,0,0,1,304.47,111.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "312.62 151.65 312.62 161.4 311.46 160.72 311.46 150.94 312.62 151.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "312.62 151.65 312.62 161.4 324.47 154.59 324.47 144.81 312.62 151.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M318,155.1v.66a.32.32,0,0,0,.48.27l.91-.52a.59.59,0,0,0,.3-.53v-.48a.32.32,0,0,0-.48-.28l-1,.61A.3.3,0,0,0,318,155.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M312.62,151.65v3a.67.67,0,0,0,.68.68h4.82a1.72,1.72,0,0,0,1.36-.66l4.41-5.52a2.65,2.65,0,0,0,.58-1.67v-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M312.62,151.65v3a.67.67,0,0,0,.68.68h4.82a1.72,1.72,0,0,0,1.36-.66l4.41-5.52a2.65,2.65,0,0,0,.58-1.67v-2.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "324.47 144.81 312.62 151.65 311.46 150.94 323.32 144.11 324.47 144.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M317.07,145.7l1.53-.88a.92.92,0,0,1,1-.08l.38.19-.06.29a1.25,1.25,0,0,1,.05.36v1l-.34.2-.09.48-.4-.2v-.9c0-.42-.3-.59-.66-.37l-1.21.69a1.46,1.46,0,0,0-.66,1.15v.89l-.37.22-.07.46-.39-.2v-1A2.92,2.92,0,0,1,317.07,145.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M320.32,145.78v1l-.82.48v-.89c0-.43-.3-.6-.67-.38l-1.2.69a1.47,1.47,0,0,0-.67,1.15v.89l-.83.48v-1a3,3,0,0,1,1.33-2.3L319,145C319.73,144.6,320.32,144.94,320.32,145.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "312.59 154.94 312.5 151.72 311.46 150.94 312.65 151.47 320.76 146.96 312.76 151.66 312.59 154.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M317.44,141.3a24,24,0,0,1,1.89,2.68c.31.58.3.68.16,1.88-.07.56-.18,1-.48,1-.14,0-.05-.31-.05-.31s0,.55-.41.64-.17-.36-.17-.36-.11.59-.47.66-.16-.4-.16-.4-.13.62-.42.72-.33-.08-.33-.51a3.59,3.59,0,0,0-.67-1.73c-.47-.85-.87-1.23-.82-2a2.25,2.25,0,0,0-.61-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M312.56,121.62a2.75,2.75,0,0,0-3.59,2.13c-.39,1.68.44,8.09,1.09,9.87s4.67,9.76,4.67,9.76a10.48,10.48,0,0,0,2.29-.58,3,3,0,0,0,1.29-1.2s-2.77-6.87-3.31-8.47-.34-5.64-.5-7.44C314.29,123.5,314.12,122.17,312.56,121.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M322.58,120.28c.18.2.08.65-.5.7s-1.83-.08-2.3-.08A19.24,19.24,0,0,1,317,120Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M319.75,119.25c.55.31,1.41.49,1.87.72s.85.1,1,.31,0,.77-1.09.52a9.86,9.86,0,0,0-2.45-.39c-.68,0-2,0-2.23-.36s.22-.86.22-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M323.55,122.47c.12-.22-1-.18-1.36,0a19.52,19.52,0,0,0-1.8.78c-.2.13-.47.34.26.38C322.05,123.67,323.14,123.25,323.55,122.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "117.43 209.59 198.18 256.62 278.61 209.68 197.77 162.6 117.43 209.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-142",
    points: "117.43 115.26 198.18 162.28 278.61 115.34 197.77 68.27 117.43 115.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "198.12 239.81 198.12 252.97 272.9 209.35 272.9 196.19 198.12 239.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-121",
    points: "198.16 239.81 198.16 252.97 123.14 209.23 123.14 196.12 198.16 239.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-120",
    points: "198.17 265.31 198.17 394.09 274.98 349.44 274.98 224.28 198.17 265.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "198.13 291.11 198.17 291.08 198.17 256.62 198.15 256.6 198.13 256.62 198.13 291.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "198.13 291.11 198.17 291.08 198.17 256.62 198.15 256.6 198.13 256.62 198.13 291.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "198.13 400.38 198.15 400.37 198.13 400.35 198.13 400.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "198.13 400.38 198.15 400.37 198.13 400.35 198.13 400.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-118",
    points: "252.18 265.05 198.17 295.09 198.17 404.37 278.61 357.6 278.61 228.71 261.01 239 252.18 265.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "198.17 400.38 198.17 400.35 198.15 400.37 198.17 400.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "291.59 328.09 212.29 282.75 239.68 266.84 318.98 312.19 291.59 328.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M291.81,319.22l-79.43-45.47c-1.94-1.12-3.51-4.12-3.51-6.7h0c0-2.58,1.57-3.77,3.51-2.65l79.43,45.47c1.94,1.12,3.51,4.12,3.51,6.7h0C295.32,319.15,293.75,320.34,291.81,319.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M240.6,256.9a2.14,2.14,0,0,1-.86,2S215.46,273,215.44,273c-.56.32-.2-.39-1.05-.88a6.79,6.79,0,0,1-3.08-5.32c0-1-.89-1-.35-1.29l24.41-14.16a2.21,2.21,0,0,1,2.15.24A6.79,6.79,0,0,1,240.6,256.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M216.23,271.06c0,2-1.38,2.74-3.09,1.76a6.79,6.79,0,0,1-3.08-5.32c0-1.95,1.38-2.74,3.08-1.75A6.77,6.77,0,0,1,216.23,271.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M214.31,270c0,.78-.55,1.1-1.24.71a2.74,2.74,0,0,1-1.23-2.13c0-.79.55-1.1,1.23-.71A2.72,2.72,0,0,1,214.31,270Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M213.29,265.67a2.25,2.25,0,0,0-2.11-.26,2.47,2.47,0,0,1,1.85.37,6.78,6.78,0,0,1,3.08,5.31,2.1,2.1,0,0,1-1,2c.76-.21,1.24-1,1.24-2.12A6.79,6.79,0,0,0,213.29,265.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M245.81,259.88a2.16,2.16,0,0,1-.87,2L220.64,276c-.56.31-.2-.39-1-.88a6.79,6.79,0,0,1-3.08-5.32c0-1-.89-1-.35-1.29l24.41-14.16a2.18,2.18,0,0,1,2.15.24A6.77,6.77,0,0,1,245.81,259.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M221.43,274.05c0,1.95-1.38,2.74-3.09,1.76a6.82,6.82,0,0,1-3.08-5.32c0-1.95,1.38-2.74,3.08-1.76A6.8,6.8,0,0,1,221.43,274.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M219.51,273c0,.78-.55,1.1-1.23.7a2.69,2.69,0,0,1-1.24-2.13c0-.78.55-1.09,1.24-.7A2.72,2.72,0,0,1,219.51,273Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M218.49,268.66a2.22,2.22,0,0,0-2.11-.26,2.45,2.45,0,0,1,1.85.36,6.82,6.82,0,0,1,3.08,5.32,2.1,2.1,0,0,1-1,2c.76-.22,1.24-1,1.24-2.12A6.79,6.79,0,0,0,218.49,268.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M251,262.87a2.16,2.16,0,0,1-.87,2L225.84,279c-.56.31-.2-.4-1.05-.88a6.82,6.82,0,0,1-3.08-5.32c0-1-.89-1-.34-1.3l24.4-14.15a2.2,2.2,0,0,1,2.15.23A6.8,6.8,0,0,1,251,262.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M226.63,277c0,1.95-1.38,2.74-3.08,1.75a6.77,6.77,0,0,1-3.09-5.31c0-2,1.38-2.74,3.09-1.76A6.79,6.79,0,0,1,226.63,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M224.71,276c0,.78-.55,1.09-1.23.7a2.7,2.7,0,0,1-1.24-2.13c0-.78.55-1.1,1.24-.7A2.7,2.7,0,0,1,224.71,276Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M223.69,271.65a2.22,2.22,0,0,0-2.11-.26,2.4,2.4,0,0,1,1.85.36,6.79,6.79,0,0,1,3.08,5.32,2.11,2.11,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.77,6.77,0,0,0,223.69,271.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M256.21,265.86a2.17,2.17,0,0,1-.87,2L231,282c-.56.31-.2-.4-1-.89a6.78,6.78,0,0,1-3.08-5.31c0-1-.89-1-.34-1.3L251,260.3a2.23,2.23,0,0,1,2.16.24A6.82,6.82,0,0,1,256.21,265.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M231.83,280c0,2-1.38,2.74-3.08,1.76a6.77,6.77,0,0,1-3.09-5.31c0-2,1.38-2.74,3.09-1.76A6.78,6.78,0,0,1,231.83,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M229.91,279c0,.79-.55,1.1-1.23.71a2.75,2.75,0,0,1-1.24-2.13c0-.78.56-1.1,1.24-.71A2.74,2.74,0,0,1,229.91,279Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M228.89,274.63a2.19,2.19,0,0,0-2.1-.25,2.39,2.39,0,0,1,1.84.36,6.78,6.78,0,0,1,3.08,5.31,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.8,6.8,0,0,0,228.89,274.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M261.41,268.85a2.14,2.14,0,0,1-.87,1.95s-24.28,14.14-24.3,14.14c-.55.32-.2-.39-1-.88a6.77,6.77,0,0,1-3.09-5.32c0-1-.89-1-.34-1.29l24.4-14.16a2.23,2.23,0,0,1,2.16.24A6.79,6.79,0,0,1,261.41,268.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M237,283c0,2-1.38,2.74-3.08,1.76a6.77,6.77,0,0,1-3.09-5.32c0-1.95,1.38-2.74,3.09-1.75A6.78,6.78,0,0,1,237,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M235.11,282c0,.78-.55,1.1-1.23.71a2.75,2.75,0,0,1-1.24-2.13c0-.79.56-1.1,1.24-.71A2.74,2.74,0,0,1,235.11,282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M234.09,277.62a2.23,2.23,0,0,0-2.1-.26,2.44,2.44,0,0,1,1.84.37,6.78,6.78,0,0,1,3.08,5.31,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.77,6.77,0,0,0,234.09,277.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M266.61,271.83a2.16,2.16,0,0,1-.87,2l-24.3,14.14c-.55.31-.2-.39-1-.88a6.77,6.77,0,0,1-3.09-5.32c0-1-.89-1-.34-1.29l24.41-14.16a2.18,2.18,0,0,1,2.15.24A6.78,6.78,0,0,1,266.61,271.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M242.23,286c0,1.95-1.38,2.74-3.08,1.76a6.82,6.82,0,0,1-3.08-5.32c0-1.95,1.38-2.74,3.08-1.76A6.82,6.82,0,0,1,242.23,286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M240.31,285c0,.78-.55,1.1-1.23.7a2.71,2.71,0,0,1-1.24-2.13c0-.78.56-1.09,1.24-.7A2.72,2.72,0,0,1,240.31,285Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M239.3,280.61a2.22,2.22,0,0,0-2.11-.26,2.43,2.43,0,0,1,1.84.36,6.82,6.82,0,0,1,3.08,5.32,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.79,6.79,0,0,0,239.3,280.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M271.81,274.82a2.18,2.18,0,0,1-.86,2l-24.31,14.14c-.55.31-.2-.4-1-.88a6.82,6.82,0,0,1-3.08-5.32c0-1-.9-1-.35-1.3l24.41-14.15a2.18,2.18,0,0,1,2.15.24A6.78,6.78,0,0,1,271.81,274.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M247.43,289c0,1.95-1.38,2.74-3.08,1.75a6.78,6.78,0,0,1-3.08-5.31c0-1.95,1.38-2.74,3.08-1.76A6.79,6.79,0,0,1,247.43,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M245.52,288c0,.78-.56,1.1-1.24.7a2.72,2.72,0,0,1-1.23-2.13c0-.78.55-1.1,1.23-.7A2.71,2.71,0,0,1,245.52,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M244.5,283.6a2.22,2.22,0,0,0-2.11-.26,2.39,2.39,0,0,1,1.84.36,6.79,6.79,0,0,1,3.08,5.32,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.78,6.78,0,0,0,244.5,283.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M277,277.81a2.19,2.19,0,0,1-.86,2l-24.31,14.14c-.55.31-.2-.4-1-.89a6.78,6.78,0,0,1-3.08-5.31c0-1-.9-1-.35-1.3l24.41-14.16a2.21,2.21,0,0,1,2.15.24A6.82,6.82,0,0,1,277,277.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M252.63,292c0,2-1.38,2.75-3.08,1.76a6.78,6.78,0,0,1-3.08-5.31c0-2,1.38-2.74,3.08-1.76A6.78,6.78,0,0,1,252.63,292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M250.72,290.94c0,.79-.56,1.1-1.24.71a2.72,2.72,0,0,1-1.23-2.13c0-.78.55-1.1,1.23-.71A2.75,2.75,0,0,1,250.72,290.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M249.7,286.58a2.21,2.21,0,0,0-2.11-.25,2.39,2.39,0,0,1,1.84.36,6.78,6.78,0,0,1,3.08,5.31,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.82,6.82,0,0,0,249.7,286.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M282.21,280.8a2.16,2.16,0,0,1-.86,1.95l-24.3,14.14c-.56.32-.2-.39-1.05-.88a6.78,6.78,0,0,1-3.08-5.31c0-1-.9-1-.35-1.3L277,275.24a2.21,2.21,0,0,1,2.15.24A6.79,6.79,0,0,1,282.21,280.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M257.83,295c0,2-1.38,2.74-3.08,1.76a6.79,6.79,0,0,1-3.08-5.32c0-1.95,1.38-2.74,3.08-1.75A6.78,6.78,0,0,1,257.83,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M255.92,293.93c0,.79-.56,1.1-1.24.71a2.74,2.74,0,0,1-1.23-2.13c0-.79.55-1.1,1.23-.71A2.75,2.75,0,0,1,255.92,293.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M254.9,289.57a2.25,2.25,0,0,0-2.11-.26,2.44,2.44,0,0,1,1.84.37,6.78,6.78,0,0,1,3.08,5.31,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.82,6.82,0,0,0,254.9,289.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M287.41,283.78a2.18,2.18,0,0,1-.86,2l-24.3,14.14c-.56.31-.2-.39-1.05-.88a6.79,6.79,0,0,1-3.08-5.32c0-1-.89-1-.35-1.29l24.41-14.16a2.18,2.18,0,0,1,2.15.24A6.78,6.78,0,0,1,287.41,283.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M263,298c0,1.95-1.38,2.74-3.08,1.76a6.82,6.82,0,0,1-3.08-5.32c0-1.95,1.38-2.74,3.08-1.76A6.82,6.82,0,0,1,263,298Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M261.12,296.92c0,.78-.56,1.1-1.24.7a2.7,2.7,0,0,1-1.23-2.13c0-.78.55-1.09,1.23-.7A2.73,2.73,0,0,1,261.12,296.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M260.1,292.56a2.25,2.25,0,0,0-2.11-.26,2.43,2.43,0,0,1,1.84.36,6.8,6.8,0,0,1,3.09,5.32,2.1,2.1,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.79,6.79,0,0,0,260.1,292.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M292.61,286.77a2.18,2.18,0,0,1-.86,2l-24.3,14.14c-.56.31-.2-.4-1.05-.88a6.82,6.82,0,0,1-3.08-5.32c0-1-.89-1-.35-1.3l24.41-14.15a2.18,2.18,0,0,1,2.15.24A6.78,6.78,0,0,1,292.61,286.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M268.23,300.94c0,1.95-1.38,2.74-3.08,1.75a6.78,6.78,0,0,1-3.08-5.31c0-1.95,1.38-2.74,3.08-1.76A6.79,6.79,0,0,1,268.23,300.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M266.32,299.91c0,.78-.55,1.1-1.24.7a2.72,2.72,0,0,1-1.23-2.13c0-.78.55-1.1,1.23-.7A2.69,2.69,0,0,1,266.32,299.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M265.3,295.55a2.22,2.22,0,0,0-2.11-.26,2.38,2.38,0,0,1,1.84.36,6.77,6.77,0,0,1,3.09,5.32,2.09,2.09,0,0,1-1,2c.76-.21,1.24-1,1.24-2.12A6.78,6.78,0,0,0,265.3,295.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M297.81,289.76a2.17,2.17,0,0,1-.86,2l-24.3,14.14c-.56.31-.2-.4-1-.89a6.78,6.78,0,0,1-3.08-5.31c0-1-.89-1-.35-1.3l24.41-14.15a2.17,2.17,0,0,1,2.15.23A6.82,6.82,0,0,1,297.81,289.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M273.44,303.93c0,1.95-1.38,2.74-3.09,1.75a6.78,6.78,0,0,1-3.08-5.31c0-2,1.38-2.74,3.08-1.76A6.77,6.77,0,0,1,273.44,303.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M271.52,302.9c0,.78-.55,1.09-1.24.7a2.72,2.72,0,0,1-1.23-2.13c0-.78.55-1.1,1.23-.71A2.72,2.72,0,0,1,271.52,302.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M270.5,298.53a2.21,2.21,0,0,0-2.11-.25,2.41,2.41,0,0,1,1.85.36,6.78,6.78,0,0,1,3.08,5.31,2.1,2.1,0,0,1-1,2c.76-.21,1.24-1,1.24-2.12A6.82,6.82,0,0,0,270.5,298.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M303,292.75a2.14,2.14,0,0,1-.87,1.95l-24.3,14.15c-.56.31-.2-.4-1.05-.89a6.78,6.78,0,0,1-3.08-5.31c0-1-.89-1-.35-1.3l24.41-14.16a2.21,2.21,0,0,1,2.15.24A6.77,6.77,0,0,1,303,292.75Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-102",
    cx: 275.55,
    cy: 305.13,
    rx: 2.51,
    ry: 4.35,
    transform: "translate(-116.33 180.79) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M276.72,305.88c0,.79-.55,1.1-1.23.71a2.72,2.72,0,0,1-1.24-2.13c0-.79.55-1.1,1.24-.71A2.74,2.74,0,0,1,276.72,305.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M275.7,301.52a2.25,2.25,0,0,0-2.11-.26,2.46,2.46,0,0,1,1.85.37,6.78,6.78,0,0,1,3.08,5.31,2.1,2.1,0,0,1-1,2c.76-.21,1.24-1,1.24-2.12A6.82,6.82,0,0,0,275.7,301.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M308.22,295.73a2.16,2.16,0,0,1-.87,2l-24.3,14.14c-.56.31-.2-.39-1.05-.88a6.79,6.79,0,0,1-3.08-5.32c0-1-.89-1-.34-1.29L303,290.18a2.18,2.18,0,0,1,2.15.24A6.77,6.77,0,0,1,308.22,295.73Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-104",
    cx: 280.76,
    cy: 308.12,
    rx: 2.51,
    ry: 4.35,
    transform: "translate(-117.13 183.82) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M281.92,308.87c0,.78-.55,1.1-1.23.7a2.69,2.69,0,0,1-1.24-2.13c0-.78.55-1.09,1.24-.7A2.72,2.72,0,0,1,281.92,308.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M280.9,304.51a2.25,2.25,0,0,0-2.11-.26,2.45,2.45,0,0,1,1.85.36,6.82,6.82,0,0,1,3.08,5.32,2.11,2.11,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.77,6.77,0,0,0,280.9,304.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M313.42,298.72a2.16,2.16,0,0,1-.87,2l-24.3,14.14c-.56.31-.2-.39-1.05-.88a6.82,6.82,0,0,1-3.08-5.32c0-1-.89-1-.34-1.3l24.4-14.15a2.2,2.2,0,0,1,2.16.24A6.78,6.78,0,0,1,313.42,298.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 285.96,
    cy: 311.11,
    rx: 2.51,
    ry: 4.35,
    transform: "translate(-117.93 186.86) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M287.12,311.86c0,.78-.55,1.1-1.23.7a2.73,2.73,0,0,1-1.24-2.13c0-.78.56-1.1,1.24-.7A2.72,2.72,0,0,1,287.12,311.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M286.1,307.5a2.2,2.2,0,0,0-2.1-.26,2.43,2.43,0,0,1,1.84.36,6.79,6.79,0,0,1,3.08,5.32,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.77,6.77,0,0,0,286.1,307.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M318.62,301.71a2.17,2.17,0,0,1-.87,2l-24.3,14.14c-.55.31-.2-.4-1-.89a6.77,6.77,0,0,1-3.09-5.31c0-1-.89-1-.34-1.3l24.4-14.15a2.19,2.19,0,0,1,2.16.23A6.82,6.82,0,0,1,318.62,301.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-108",
    cx: 291.16,
    cy: 314.1,
    rx: 2.51,
    ry: 4.35,
    transform: "translate(-118.72 189.89) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M292.32,314.85c0,.78-.55,1.09-1.23.7a2.73,2.73,0,0,1-1.24-2.13c0-.78.56-1.1,1.24-.7A2.7,2.7,0,0,1,292.32,314.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M291.3,310.49a2.17,2.17,0,0,0-2.1-.26,2.39,2.39,0,0,1,1.84.36,6.79,6.79,0,0,1,3.08,5.32,2.09,2.09,0,0,1-1,2c.75-.21,1.24-1,1.24-2.12A6.77,6.77,0,0,0,291.3,310.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M315.86,295.89l-79.43-45.47a2.24,2.24,0,0,0-2.36-.15l-23.9,13.9a2.28,2.28,0,0,1,2.21.23l79.43,45.47c1.94,1.12,3.51,4.12,3.51,6.7h0a3,3,0,0,1-1.29,2.88h0l24-14a3,3,0,0,0,1.29-2.88h0C319.37,300,317.8,297,315.86,295.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "213.13 264.91 237.24 250.98 237.63 251.16 213.51 265.15 213.13 264.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "213.13 264.91 237.24 250.98 237.05 250.82 212.93 264.81 213.13 264.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "218.33 267.89 242.44 253.96 242.83 254.14 218.72 268.13 218.33 267.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "218.33 267.89 242.44 253.96 242.25 253.79 218.13 267.78 218.33 267.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "223.53 270.86 247.64 256.93 248.03 257.11 223.92 271.1 223.53 270.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "223.53 270.86 247.64 256.93 247.45 256.77 223.33 270.76 223.53 270.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "228.73 273.84 252.84 259.91 253.23 260.09 229.12 274.07 228.73 273.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "228.73 273.84 252.84 259.91 252.65 259.74 228.53 273.73 228.73 273.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "233.93 276.81 258.05 262.88 258.44 263.06 234.32 277.05 233.93 276.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "233.93 276.81 258.05 262.88 257.85 262.72 233.73 276.7 233.93 276.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "239.13 279.79 263.25 265.86 263.64 266.04 239.52 280.02 239.13 279.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "239.13 279.79 263.25 265.86 263.05 265.69 238.94 279.68 239.13 279.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "244.33 282.76 268.45 268.83 268.84 269.01 244.72 283 244.33 282.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "244.33 282.76 268.45 268.83 268.25 268.67 244.14 282.65 244.33 282.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "249.53 285.74 273.65 271.81 274.04 271.99 249.92 285.98 249.53 285.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "249.53 285.74 273.65 271.81 273.45 271.64 249.34 285.63 249.53 285.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "254.73 288.71 278.85 274.78 279.24 274.96 255.12 288.95 254.73 288.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "254.73 288.71 278.85 274.78 278.65 274.62 254.54 288.61 254.73 288.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "259.93 291.69 284.05 277.76 284.44 277.94 260.32 291.93 259.93 291.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "259.93 291.69 284.05 277.76 283.86 277.59 259.74 291.58 259.93 291.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "265.13 294.66 289.25 280.73 289.64 280.91 265.52 294.9 265.13 294.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "265.13 294.66 289.25 280.73 289.06 280.57 264.94 294.56 265.13 294.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "270.34 297.63 294.45 283.71 294.84 283.89 270.73 297.88 270.34 297.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "270.34 297.63 294.45 283.71 294.26 283.54 270.14 297.53 270.34 297.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "275.54 300.61 299.65 286.68 300.04 286.86 275.93 300.85 275.54 300.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "275.54 300.61 299.65 286.68 299.46 286.52 275.34 300.5 275.54 300.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "280.74 303.58 304.85 289.66 305.24 289.84 281.13 303.82 280.74 303.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "280.74 303.58 304.85 289.66 304.66 289.49 280.54 303.48 280.74 303.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "285.94 306.56 310.06 292.63 310.44 292.81 286.33 306.8 285.94 306.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "285.94 306.56 310.06 292.63 309.86 292.47 285.74 306.45 285.94 306.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "291.14 309.54 315.26 295.61 315.65 295.79 291.53 309.77 291.14 309.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "291.14 309.54 315.26 295.61 315.06 295.44 290.94 309.43 291.14 309.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M291.81,309.87,212.38,264.4c-1.94-1.12-3.51.07-3.51,2.65h0c0,2.58,1.57,5.58,3.51,6.7l79.43,45.47c1.94,1.12,3.51-.07,3.51-2.65h0C295.32,314,293.75,311,291.81,309.87Zm1.39,9.05a2.17,2.17,0,0,1-1-.32l-79.43-45.47a7.74,7.74,0,0,1-3.15-6.08c0-1.09.37-2.35,1.4-2.35a2.17,2.17,0,0,1,1,.32l79.43,45.47a7.74,7.74,0,0,1,3.15,6.08C294.6,317.65,294.23,318.92,293.2,318.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "293.76 311.91 317.88 297.98 318.07 298.28 293.95 312.27 293.76 311.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "293.76 311.91 317.88 297.98 317.75 297.8 293.63 311.79 293.76 311.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "295.14 315.35 319.25 301.43 319.31 301.79 295.19 315.78 295.14 315.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "295.14 315.35 319.25 301.43 319.21 301.2 295.09 315.19 295.14 315.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "198.17 400.38 198.17 400.35 198.15 400.37 198.17 400.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-121",
    points: "198.13 388.79 198.13 285.65 197.61 285.95 156.6 263.83 137.34 270.89 121.94 262.49 121.94 344.52 198.13 388.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-119",
    points: "198.13 404.37 198.13 295.12 197.58 295.43 187.47 290.43 168.89 298.78 117.43 270.58 117.43 357.47 198.13 404.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "104.4 342.38 183.7 297.03 156.31 281.13 77.01 326.47 104.4 342.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M104.18,333.5,183.61,288c1.94-1.12,3.51-4.12,3.51-6.7h0c0-2.58-1.57-3.77-3.51-2.65l-79.43,45.47c-1.94,1.12-3.51,4.12-3.51,6.7h0C100.67,333.43,102.24,334.62,104.18,333.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M155.38,271.18a2.14,2.14,0,0,0,.87,1.95l24.3,14.15c.56.31.2-.4,1-.89a6.78,6.78,0,0,0,3.08-5.31c0-1,.89-1,.35-1.3l-24.41-14.16a2.21,2.21,0,0,0-2.15.24A6.77,6.77,0,0,0,155.38,271.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M179.76,285.34c0,2,1.38,2.74,3.09,1.76a6.79,6.79,0,0,0,3.08-5.32c0-1.95-1.38-2.74-3.08-1.75A6.77,6.77,0,0,0,179.76,285.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M181.68,284.31c0,.79.55,1.1,1.23.71a2.72,2.72,0,0,0,1.24-2.13c0-.79-.55-1.1-1.24-.71A2.74,2.74,0,0,0,181.68,284.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M182.7,280a2.25,2.25,0,0,1,2.11-.26,2.47,2.47,0,0,0-1.85.37,6.78,6.78,0,0,0-3.08,5.31,2.1,2.1,0,0,0,1,2c-.76-.21-1.24-1-1.24-2.12A6.82,6.82,0,0,1,182.7,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M150.18,274.16a2.16,2.16,0,0,0,.87,2l24.3,14.14c.56.31.2-.39,1.05-.88a6.79,6.79,0,0,0,3.08-5.32c0-1,.89-1,.34-1.29l-24.4-14.16a2.21,2.21,0,0,0-2.15.24A6.77,6.77,0,0,0,150.18,274.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M174.56,288.33c0,1.95,1.38,2.74,3.09,1.76a6.79,6.79,0,0,0,3.08-5.32c0-1.95-1.38-2.74-3.08-1.76A6.8,6.8,0,0,0,174.56,288.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M176.48,287.3c0,.78.55,1.1,1.23.7a2.69,2.69,0,0,0,1.24-2.13c0-.78-.55-1.09-1.24-.7A2.72,2.72,0,0,0,176.48,287.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M177.5,282.94a2.25,2.25,0,0,1,2.11-.26,2.49,2.49,0,0,0-1.85.36,6.82,6.82,0,0,0-3.08,5.32,2.11,2.11,0,0,0,1,2c-.75-.21-1.23-1-1.23-2.12A6.79,6.79,0,0,1,177.5,282.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M145,277.15a2.16,2.16,0,0,0,.87,2l24.3,14.14c.56.31.2-.39,1-.88a6.82,6.82,0,0,0,3.08-5.32c0-1,.89-1,.34-1.3l-24.4-14.15a2.18,2.18,0,0,0-2.15.24A6.77,6.77,0,0,0,145,277.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M169.36,291.32c0,1.95,1.38,2.74,3.08,1.76a6.8,6.8,0,0,0,3.09-5.32c0-1.95-1.38-2.74-3.09-1.76A6.79,6.79,0,0,0,169.36,291.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M171.28,290.29c0,.78.55,1.1,1.23.7a2.7,2.7,0,0,0,1.24-2.13c0-.78-.55-1.1-1.24-.7A2.72,2.72,0,0,0,171.28,290.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M172.3,285.93a2.22,2.22,0,0,1,2.11-.26,2.45,2.45,0,0,0-1.85.36,6.79,6.79,0,0,0-3.08,5.32,2.11,2.11,0,0,0,1,2c-.75-.21-1.24-.95-1.24-2.12A6.77,6.77,0,0,1,172.3,285.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M139.78,280.14a2.17,2.17,0,0,0,.87,2L165,296.24c.56.31.2-.4,1-.89a6.77,6.77,0,0,0,3.09-5.31c0-1,.89-1,.34-1.3L145,274.59a2.22,2.22,0,0,0-2.16.23A6.82,6.82,0,0,0,139.78,280.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M164.16,294.31c0,1.95,1.38,2.74,3.08,1.75a6.77,6.77,0,0,0,3.09-5.31c0-2-1.38-2.74-3.09-1.76A6.79,6.79,0,0,0,164.16,294.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M166.08,293.28c0,.78.55,1.09,1.23.7a2.73,2.73,0,0,0,1.24-2.13c0-.78-.56-1.1-1.24-.7A2.7,2.7,0,0,0,166.08,293.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M167.1,288.92a2.17,2.17,0,0,1,2.1-.26,2.39,2.39,0,0,0-1.84.36,6.79,6.79,0,0,0-3.08,5.32,2.09,2.09,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.77,6.77,0,0,1,167.1,288.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M134.58,283.13a2.14,2.14,0,0,0,.87,1.95l24.3,14.15c.55.31.2-.4,1-.89a6.77,6.77,0,0,0,3.09-5.31c0-1,.89-1,.34-1.3l-24.4-14.16a2.23,2.23,0,0,0-2.16.24A6.79,6.79,0,0,0,134.58,283.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M159,297.29c0,2,1.38,2.74,3.08,1.76a6.79,6.79,0,0,0,3.08-5.32c0-2-1.38-2.74-3.08-1.75A6.78,6.78,0,0,0,159,297.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M160.88,296.26c0,.79.55,1.1,1.23.71a2.75,2.75,0,0,0,1.24-2.13c0-.79-.56-1.1-1.24-.71A2.74,2.74,0,0,0,160.88,296.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M161.89,291.9a2.25,2.25,0,0,1,2.11-.26,2.44,2.44,0,0,0-1.84.37,6.78,6.78,0,0,0-3.08,5.31,2.09,2.09,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.82,6.82,0,0,1,161.89,291.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M129.38,286.12a2.16,2.16,0,0,0,.86,1.95l24.31,14.14c.55.31.2-.39,1-.88a6.77,6.77,0,0,0,3.09-5.32c0-1,.89-1,.34-1.29l-24.41-14.16a2.21,2.21,0,0,0-2.15.24A6.79,6.79,0,0,0,129.38,286.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M153.76,300.28c0,2,1.38,2.74,3.08,1.76a6.79,6.79,0,0,0,3.08-5.32c0-2-1.38-2.74-3.08-1.76A6.82,6.82,0,0,0,153.76,300.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M155.68,299.25c0,.78.55,1.1,1.23.71a2.75,2.75,0,0,0,1.24-2.14c0-.78-.56-1.09-1.24-.7A2.72,2.72,0,0,0,155.68,299.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M156.69,294.89a2.25,2.25,0,0,1,2.11-.26A2.48,2.48,0,0,0,157,295a6.82,6.82,0,0,0-3.08,5.32,2.09,2.09,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.79,6.79,0,0,1,156.69,294.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M124.18,289.1a2.18,2.18,0,0,0,.86,2l24.31,14.14c.55.31.2-.39,1-.88a6.82,6.82,0,0,0,3.08-5.32c0-1,.9-1,.35-1.3l-24.41-14.15a2.18,2.18,0,0,0-2.15.24A6.78,6.78,0,0,0,124.18,289.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M148.56,303.27c0,2,1.38,2.74,3.08,1.76a6.82,6.82,0,0,0,3.08-5.32c0-1.95-1.38-2.74-3.08-1.76A6.82,6.82,0,0,0,148.56,303.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M150.47,302.24c0,.78.56,1.1,1.24.7a2.7,2.7,0,0,0,1.23-2.13c0-.78-.55-1.1-1.23-.7A2.73,2.73,0,0,0,150.47,302.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M151.49,297.88a2.22,2.22,0,0,1,2.11-.26,2.43,2.43,0,0,0-1.84.36,6.79,6.79,0,0,0-3.08,5.32,2.08,2.08,0,0,0,1,2c-.75-.21-1.24-.95-1.24-2.12A6.78,6.78,0,0,1,151.49,297.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M119,292.09a2.19,2.19,0,0,0,.86,2l24.3,14.14c.56.31.21-.4,1.05-.89a6.78,6.78,0,0,0,3.08-5.31c0-1,.9-1,.35-1.3,0,0-24.39-14.15-24.41-14.15a2.2,2.2,0,0,0-2.15.23A6.82,6.82,0,0,0,119,292.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M143.36,306.26c0,1.95,1.38,2.74,3.08,1.75a6.78,6.78,0,0,0,3.08-5.31c0-2-1.38-2.74-3.08-1.76A6.79,6.79,0,0,0,143.36,306.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M145.27,305.23c0,.78.56,1.09,1.24.7a2.72,2.72,0,0,0,1.23-2.13c0-.78-.55-1.1-1.23-.7A2.71,2.71,0,0,0,145.27,305.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M146.29,300.87a2.19,2.19,0,0,1,2.11-.26,2.39,2.39,0,0,0-1.84.36,6.79,6.79,0,0,0-3.08,5.32,2.09,2.09,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.78,6.78,0,0,1,146.29,300.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M113.78,295.08a2.16,2.16,0,0,0,.86,1.95l24.3,14.15c.56.31.2-.4,1.05-.89a6.78,6.78,0,0,0,3.08-5.31c0-1,.9-1,.35-1.3L119,289.52a2.21,2.21,0,0,0-2.15.24A6.79,6.79,0,0,0,113.78,295.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M138.16,309.24c0,2,1.38,2.74,3.08,1.76a6.79,6.79,0,0,0,3.08-5.32c0-1.95-1.38-2.74-3.08-1.75A6.78,6.78,0,0,0,138.16,309.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M140.07,308.21c0,.79.56,1.1,1.24.71a2.74,2.74,0,0,0,1.23-2.13c0-.79-.55-1.1-1.23-.71A2.75,2.75,0,0,0,140.07,308.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M141.09,303.85a2.25,2.25,0,0,1,2.11-.26,2.44,2.44,0,0,0-1.84.37,6.8,6.8,0,0,0-3.09,5.31,2.1,2.1,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.82,6.82,0,0,1,141.09,303.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M108.58,298.07a2.16,2.16,0,0,0,.86,1.95l24.3,14.14c.56.32.2-.39,1-.88a6.79,6.79,0,0,0,3.08-5.32c0-1,.89-1,.35-1.29l-24.41-14.16a2.21,2.21,0,0,0-2.15.24A6.79,6.79,0,0,0,108.58,298.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M133,312.23c0,1.95,1.38,2.74,3.08,1.76a6.79,6.79,0,0,0,3.08-5.32c0-1.95-1.38-2.74-3.08-1.76A6.82,6.82,0,0,0,133,312.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M134.87,311.2c0,.78.55,1.1,1.24.71a2.74,2.74,0,0,0,1.23-2.13c0-.79-.55-1.1-1.23-.71A2.7,2.7,0,0,0,134.87,311.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M135.89,306.84a2.25,2.25,0,0,1,2.11-.26,2.47,2.47,0,0,0-1.84.36,6.8,6.8,0,0,0-3.09,5.32,2.1,2.1,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.79,6.79,0,0,1,135.89,306.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M103.38,301.05a2.15,2.15,0,0,0,.86,2l24.3,14.14c.56.31.2-.39,1.05-.88a6.82,6.82,0,0,0,3.08-5.32c0-1,.89-1,.35-1.29L108.61,295.5a2.18,2.18,0,0,0-2.15.24A6.78,6.78,0,0,0,103.38,301.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M127.75,315.22c0,1.95,1.38,2.74,3.09,1.76a6.82,6.82,0,0,0,3.08-5.32c0-2-1.38-2.74-3.08-1.76A6.8,6.8,0,0,0,127.75,315.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M129.67,314.19c0,.78.55,1.1,1.24.7a2.7,2.7,0,0,0,1.23-2.13c0-.78-.55-1.1-1.23-.7A2.7,2.7,0,0,0,129.67,314.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M130.69,309.83a2.22,2.22,0,0,1,2.11-.26,2.42,2.42,0,0,0-1.84.36,6.79,6.79,0,0,0-3.09,5.32,2.07,2.07,0,0,0,1,2c-.76-.21-1.24-.95-1.24-2.12A6.78,6.78,0,0,1,130.69,309.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M98.17,304a2.17,2.17,0,0,0,.87,2l24.3,14.14c.56.31.2-.4,1-.88a6.82,6.82,0,0,0,3.08-5.32c0-1,.89-1,.35-1.3l-24.41-14.15a2.2,2.2,0,0,0-2.15.23A6.8,6.8,0,0,0,98.17,304Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M122.55,318.21c0,2,1.38,2.74,3.09,1.75a6.78,6.78,0,0,0,3.08-5.31c0-2-1.38-2.74-3.08-1.76A6.77,6.77,0,0,0,122.55,318.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M124.47,317.18c0,.78.55,1.09,1.23.7a2.7,2.7,0,0,0,1.24-2.13c0-.78-.55-1.1-1.24-.7A2.7,2.7,0,0,0,124.47,317.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M125.49,312.82a2.22,2.22,0,0,1,2.11-.26,2.41,2.41,0,0,0-1.85.36,6.79,6.79,0,0,0-3.08,5.32,2.09,2.09,0,0,0,1,2c-.76-.21-1.24-1-1.24-2.12A6.78,6.78,0,0,1,125.49,312.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M93,307a2.17,2.17,0,0,0,.87,2l24.3,14.14c.56.31.2-.4,1-.89a6.78,6.78,0,0,0,3.08-5.31c0-1,.89-1,.34-1.3l-24.4-14.16a2.21,2.21,0,0,0-2.15.24A6.77,6.77,0,0,0,93,307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M117.35,321.19c0,2,1.38,2.74,3.09,1.76a6.79,6.79,0,0,0,3.08-5.32c0-1.95-1.38-2.74-3.08-1.75A6.77,6.77,0,0,0,117.35,321.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M119.27,320.16c0,.79.55,1.1,1.23.71a2.72,2.72,0,0,0,1.24-2.13c0-.78-.55-1.1-1.24-.71A2.74,2.74,0,0,0,119.27,320.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M120.29,315.8a2.25,2.25,0,0,1,2.11-.26,2.46,2.46,0,0,0-1.85.37,6.78,6.78,0,0,0-3.08,5.31,2.11,2.11,0,0,0,1,2c-.75-.21-1.23-1-1.23-2.12A6.82,6.82,0,0,1,120.29,315.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M87.77,310a2.14,2.14,0,0,0,.87,2l24.3,14.14c.56.32.2-.39,1-.88a6.79,6.79,0,0,0,3.08-5.32c0-1,.89-1,.34-1.29L93,304.46a2.21,2.21,0,0,0-2.15.24A6.77,6.77,0,0,0,87.77,310Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M112.15,324.18c0,1.95,1.38,2.74,3.08,1.76a6.77,6.77,0,0,0,3.09-5.32c0-1.95-1.38-2.74-3.09-1.75A6.78,6.78,0,0,0,112.15,324.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M114.07,323.15c0,.78.55,1.1,1.23.71a2.72,2.72,0,0,0,1.24-2.13c0-.79-.55-1.1-1.24-.71A2.72,2.72,0,0,0,114.07,323.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M115.09,318.79a2.25,2.25,0,0,1,2.11-.26,2.49,2.49,0,0,0-1.85.36,6.82,6.82,0,0,0-3.08,5.32,2.11,2.11,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.77,6.77,0,0,1,115.09,318.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M82.57,313a2.16,2.16,0,0,0,.87,2l24.3,14.14c.56.31.2-.39,1-.88a6.79,6.79,0,0,0,3.09-5.32c0-1,.89-1,.34-1.29l-24.4-14.16a2.2,2.2,0,0,0-2.16.24A6.78,6.78,0,0,0,82.57,313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M107,327.17c0,1.95,1.38,2.74,3.08,1.76a6.8,6.8,0,0,0,3.09-5.32c0-1.95-1.38-2.74-3.09-1.76A6.82,6.82,0,0,0,107,327.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M108.87,326.14c0,.78.55,1.1,1.23.7a2.71,2.71,0,0,0,1.24-2.13c0-.78-.56-1.09-1.24-.7A2.72,2.72,0,0,0,108.87,326.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M109.89,321.78a2.2,2.2,0,0,1,2.1-.26,2.43,2.43,0,0,0-1.84.36,6.82,6.82,0,0,0-3.08,5.32,2.07,2.07,0,0,0,1,2c-.75-.21-1.24-.95-1.24-2.11A6.77,6.77,0,0,1,109.89,321.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M77.37,316a2.17,2.17,0,0,0,.87,2l24.3,14.14c.55.31.2-.4,1-.88a6.8,6.8,0,0,0,3.09-5.32c0-1,.89-1,.34-1.3l-24.4-14.15a2.22,2.22,0,0,0-2.16.23A6.82,6.82,0,0,0,77.37,316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M101.75,330.16c0,1.95,1.38,2.74,3.08,1.75a6.78,6.78,0,0,0,3.08-5.31c0-2-1.38-2.74-3.08-1.76A6.79,6.79,0,0,0,101.75,330.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M103.67,329.13c0,.78.55,1.09,1.23.7a2.73,2.73,0,0,0,1.24-2.13c0-.78-.56-1.1-1.24-.7A2.7,2.7,0,0,0,103.67,329.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M104.68,324.77a2.22,2.22,0,0,1,2.11-.26,2.39,2.39,0,0,0-1.84.36,6.79,6.79,0,0,0-3.08,5.32,2.09,2.09,0,0,0,1,2c-.75-.21-1.24-1-1.24-2.12A6.78,6.78,0,0,1,104.68,324.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M80.13,310.17l79.43-45.47a2.22,2.22,0,0,1,2.36-.14l23.9,13.89a2.28,2.28,0,0,0-2.21.23l-79.43,45.47c-1.94,1.12-3.51,4.12-3.51,6.7h0a3,3,0,0,0,1.29,2.88h0l-24-14a3,3,0,0,1-1.29-2.88h0C76.62,314.29,78.19,311.29,80.13,310.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "182.86 279.19 158.75 265.26 158.36 265.44 182.47 279.43 182.86 279.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "182.86 279.19 158.75 265.26 158.94 265.1 183.06 279.09 182.86 279.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "177.66 282.17 153.55 268.24 153.16 268.42 177.27 282.41 177.66 282.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "177.66 282.17 153.55 268.24 153.74 268.07 177.86 282.06 177.66 282.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "172.46 285.14 148.35 271.21 147.96 271.39 172.07 285.38 172.46 285.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "172.46 285.14 148.35 271.21 148.54 271.05 172.66 285.04 172.46 285.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "167.26 288.12 143.15 274.19 142.76 274.37 166.87 288.36 167.26 288.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "167.26 288.12 143.15 274.19 143.34 274.02 167.46 288.01 167.26 288.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "162.06 291.09 137.94 277.16 137.56 277.34 161.67 291.33 162.06 291.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "162.06 291.09 137.94 277.16 138.14 277 162.25 290.99 162.06 291.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "156.86 294.07 132.74 280.14 132.35 280.32 156.47 294.31 156.86 294.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "156.86 294.07 132.74 280.14 132.94 279.97 157.05 293.96 156.86 294.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "151.66 297.04 127.54 283.11 127.15 283.29 151.27 297.28 151.66 297.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "151.66 297.04 127.54 283.11 127.74 282.95 151.85 296.94 151.66 297.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "146.46 300.02 122.34 286.09 121.95 286.27 146.07 300.26 146.46 300.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "146.46 300.02 122.34 286.09 122.54 285.92 146.65 299.91 146.46 300.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "141.26 302.99 117.14 289.06 116.75 289.24 140.87 303.23 141.26 302.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "141.26 302.99 117.14 289.06 117.34 288.9 141.45 302.89 141.26 302.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "136.06 305.97 111.94 292.04 111.55 292.22 135.66 306.21 136.06 305.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "136.06 305.97 111.94 292.04 112.14 291.87 136.25 305.86 136.06 305.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "130.85 308.94 106.74 295.01 106.35 295.19 130.46 309.18 130.85 308.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "130.85 308.94 106.74 295.01 106.93 294.85 131.05 308.84 130.85 308.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "125.65 311.92 101.54 297.99 101.15 298.17 125.26 312.16 125.65 311.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "125.65 311.92 101.54 297.99 101.73 297.82 125.85 311.81 125.65 311.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "120.45 314.89 96.34 300.96 95.95 301.14 120.06 315.13 120.45 314.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "120.45 314.89 96.34 300.96 96.53 300.8 120.65 314.79 120.45 314.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "115.25 317.87 91.14 303.94 90.75 304.12 114.86 318.11 115.25 317.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "115.25 317.87 91.14 303.94 91.33 303.77 115.45 317.76 115.25 317.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "110.05 320.84 85.94 306.91 85.55 307.09 109.66 321.08 110.05 320.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "110.05 320.84 85.94 306.91 86.13 306.75 110.25 320.74 110.05 320.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "104.85 323.82 80.73 309.89 80.34 310.07 104.46 324.06 104.85 323.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "104.85 323.82 80.73 309.89 80.93 309.72 105.05 323.71 104.85 323.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M100.67,330.85h0c0,2.58,1.57,3.77,3.51,2.65L183.61,288c1.94-1.12,3.51-4.12,3.51-6.7h0c0-2.58-1.57-3.77-3.51-2.65l-79.43,45.47C102.24,325.27,100.67,328.27,100.67,330.85Zm.72,0a7.74,7.74,0,0,1,3.15-6.08L184,279.3a2.17,2.17,0,0,1,1-.32c1,0,1.4,1.27,1.4,2.35a7.74,7.74,0,0,1-3.15,6.08l-79.43,45.47a2.17,2.17,0,0,1-1,.32C101.76,333.2,101.39,331.93,101.39,330.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "102.22 326.19 78.11 312.26 77.92 312.56 102.04 326.55 102.22 326.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "102.22 326.19 78.11 312.26 78.24 312.08 102.36 326.07 102.22 326.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "100.85 329.64 76.74 315.71 76.68 316.07 100.8 330.06 100.85 329.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "100.85 329.64 76.74 315.71 76.78 315.49 100.9 329.47 100.85 329.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "100.95 317.34 100.95 321.36 116.1 312.68 116.1 308.66 100.95 317.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "100.96 317.34 100.96 321.36 85.81 312.4 85.81 308.4 100.96 317.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "85.81 308.4 100.96 317.34 116.1 308.66 100.94 299.71 85.81 308.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "101.01 320.93 100.74 317.28 86.07 308.62 100.94 316.84 115.75 308.92 101.11 317.42 101.01 320.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "126.47 302.46 126.47 306.48 141.63 297.8 141.63 293.78 126.47 302.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "126.48 302.46 126.48 306.48 111.33 297.52 111.33 293.52 126.48 302.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "111.33 293.52 126.48 302.46 141.63 293.78 126.46 284.83 111.33 293.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "126.53 306.06 126.26 302.4 111.59 293.74 126.47 301.96 141.28 294.04 126.64 302.54 126.53 306.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "151.45 288.13 151.45 292.14 166.61 283.46 166.61 279.45 151.45 288.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "151.46 288.13 151.46 292.14 136.31 283.19 136.31 279.19 151.46 288.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "136.31 279.19 151.46 288.13 166.61 279.45 151.44 270.5 136.31 279.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "151.51 291.72 151.24 288.07 136.57 279.4 151.45 287.63 166.26 279.71 151.62 288.21 151.51 291.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "94.52 310.82 95.36 310.33 94.52 309.87 93.67 310.36 94.52 310.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "99.67 312.82 95.96 310.68 95.12 311.17 98.83 313.31 99.67 312.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "96.36 308.68 95.52 309.16 98.32 310.77 99.16 310.29 96.36 308.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "100.06 306.34 99.22 306.82 102.93 308.96 103.77 308.48 100.06 306.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "102 305.22 101.16 305.71 103.69 307.17 104.53 306.69 102 305.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "100.29 308.71 99.45 309.19 103.16 311.33 104 310.85 100.29 308.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "102.03 303 101.19 303.49 103.73 304.95 104.57 304.47 102.03 303"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "105.17 304.82 104.33 305.3 108.04 307.44 108.88 306.95 105.17 304.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "94.92 308.81 95.75 308.33 94.91 307.86 94.08 308.35 94.92 308.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "98.85 308.84 99.69 308.36 97.15 306.9 96.31 307.38 98.85 308.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "98.62 306.48 99.46 305.99 98.62 305.53 97.78 306.01 98.62 306.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "96.54 306.55 94.72 305.51 93.88 306 95.7 307.03 96.54 306.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "103.53 309.31 106.7 311.14 107.54 310.65 104.37 308.83 103.53 309.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "103.76 311.68 104.76 312.26 105.6 311.77 104.6 311.2 103.76 311.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "104.3 307.52 108.63 310.02 109.47 309.54 105.14 307.04 104.3 307.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "101.42 302.65 100.53 302.16 99.69 302.64 100.59 303.14 101.42 302.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "109.48 307.31 108.64 307.79 110.57 308.9 111.41 308.42 109.48 307.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "98.92 311.13 102.82 313.38 103.66 312.89 99.76 310.64 98.92 311.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "101.39 304.87 98.59 303.28 97.75 303.76 100.55 305.36 101.39 304.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "98.01 305.18 96.65 304.39 95.81 304.88 97.17 305.66 98.01 305.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "99.43 313.66 100.89 314.5 101.72 314.01 100.27 313.17 99.43 313.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "94.31 307.51 92.78 306.63 91.94 307.12 93.47 308 94.31 307.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "93.91 309.52 90.84 307.75 90 308.23 93.07 310 93.91 309.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "145.09 281.64 145.93 281.16 145.09 280.69 144.25 281.18 145.09 281.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "150.24 283.65 146.53 281.51 145.69 281.99 149.4 284.13 150.24 283.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "146.93 279.5 146.09 279.99 148.89 281.6 149.73 281.11 146.93 279.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "150.64 277.16 149.8 277.65 153.5 279.79 154.34 279.3 150.64 277.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "152.57 276.05 151.73 276.53 154.27 277.99 155.11 277.51 152.57 276.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "150.86 279.53 150.03 280.02 153.73 282.16 154.57 281.67 150.86 279.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "152.6 273.83 151.76 274.31 154.3 275.77 155.14 275.29 152.6 273.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "155.75 275.64 154.91 276.12 158.61 278.26 159.45 277.78 155.75 275.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "145.49 279.63 146.33 279.15 145.49 278.69 144.65 279.17 145.49 279.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "149.42 279.67 150.26 279.18 147.72 277.72 146.88 278.2 149.42 279.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "149.19 277.3 150.03 276.81 149.19 276.35 148.35 276.83 149.19 277.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "147.12 277.37 145.29 276.34 144.45 276.82 146.28 277.85 147.12 277.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "154.11 280.14 157.27 281.96 158.11 281.48 154.95 279.65 154.11 280.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "154.34 282.51 155.33 283.08 156.17 282.6 155.18 282.02 154.34 282.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "154.87 278.34 159.21 280.84 160.05 280.36 155.71 277.86 154.87 278.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "152 273.48 151.1 272.98 150.26 273.46 151.16 273.96 152 273.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "160.06 278.13 159.22 278.61 161.14 279.73 161.98 279.24 160.06 278.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "149.5 281.95 153.4 284.2 154.23 283.71 150.34 281.46 149.5 281.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "151.97 275.69 149.16 274.1 148.32 274.58 151.13 276.18 151.97 275.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "148.58 276 147.23 275.22 146.39 275.7 147.74 276.49 148.58 276"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "150.01 284.48 151.46 285.32 152.3 284.83 150.84 284 150.01 284.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "144.88 278.34 143.35 277.45 142.51 277.94 144.04 278.82 144.88 278.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "144.48 280.34 141.41 278.57 140.57 279.06 143.64 280.83 144.48 280.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M134.86,293.85l-8.94-5.16a2.16,2.16,0,0,0-2,0l-5.25,3a.61.61,0,0,0,0,1.15l5.59,3.22v3.22l2.78-1.6.56.32a2.16,2.16,0,0,0,2,0l5.24-3A.61.61,0,0,0,134.86,293.85Zm-10.44-1.25c-.58,0-1-.27-1-.61s.46-.6,1-.6,1.06.27,1.06.6S125,292.6,124.42,292.6Zm2.42,1.4c-.58,0-1-.28-1-.61s.47-.61,1-.61,1,.28,1,.61S127.42,294,126.84,294Zm2.42,1.39c-.58,0-1-.27-1-.6s.47-.61,1-.61,1.05.28,1.05.61S129.84,295.4,129.26,295.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "198.13 291.11 198.13 400.35 198.15 400.37 198.17 400.35 198.17 291.08 198.13 291.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "198.13 291.11 198.13 400.35 198.15 400.37 198.17 400.35 198.17 291.08 198.13 291.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "198.13 291.11 198.13 400.35 198.15 400.37 198.17 400.35 198.17 291.08 198.13 291.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-119",
    points: "197.86 204.27 148.71 176.52 139.88 159.27 117.43 148.04 117.43 115.07 197.88 162 197.86 162.01 197.86 204.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-118",
    points: "212.1 197.38 198.46 204.6 197.91 204.29 197.91 162.01 197.88 162 278.61 114.99 278.61 188.51 244.19 207.41 212.1 197.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "197.91 204.29 197.86 204.27 197.86 162.01 197.88 162 197.91 162.01 197.91 204.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "197.91 204.29 197.86 204.27 197.86 162.01 197.88 162 197.91 162.01 197.91 204.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "197.91 241.85 197.88 241.84 197.91 241.82 197.91 241.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "197.91 241.85 197.88 241.84 197.91 241.82 197.91 241.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-121",
    points: "148.71 176.52 197.86 204.27 197.86 241.82 117.43 195.06 117.43 148.04 139.88 159.27 148.71 176.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-119",
    points: "148.71 180.53 197.86 208.28 197.86 245.84 117.43 199.07 117.43 152.05 139.88 163.28 148.71 180.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "148.71 178.58 139.88 161.33 117.43 150.11 117.43 153.27 139.88 164.5 148.71 181.75 197.86 209.5 197.86 206.33 148.71 178.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "197.86 241.85 197.86 241.82 197.88 241.84 197.86 241.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "197.86 241.85 197.86 241.82 197.88 241.84 197.86 241.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-120",
    points: "197.91 241.82 197.91 204.29 198.46 204.6 212.1 197.38 244.19 207.41 278.61 188.51 278.61 194.93 197.91 241.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-118",
    points: "197.91 245.84 197.91 208.3 198.46 208.61 212.1 201.39 244.19 211.42 278.61 192.53 278.61 198.94 197.91 245.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "197.91 204.29 197.91 241.82 197.88 241.84 197.86 241.82 197.86 204.27 197.91 204.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "197.91 204.29 197.91 241.82 197.88 241.84 197.86 241.82 197.86 204.27 197.91 204.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "197.91 204.29 197.91 241.82 197.88 241.84 197.86 241.82 197.86 204.27 197.91 204.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "198.13 396.23 198.13 404.78 278.61 357.84 278.61 349.29 198.13 396.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "198.18 396.23 198.18 404.78 117.43 357.71 117.43 349.21 198.18 396.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "198.13 398.37 198.13 410.81 278.61 363.87 278.61 351.43 198.13 398.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "198.18 398.37 198.18 410.81 117.43 363.74 117.43 351.35 198.18 398.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "197.86 162.01 197.86 409.95 117.43 365.23 117.43 115.07 197.86 162.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "197.97 161.15 197.97 118.83 160.88 140.45 160.88 182.78 197.97 161.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "197.95 161.15 197.95 118.83 235.15 140.51 235.15 182.81 197.95 161.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "235.15 182.81 197.95 161.15 160.88 182.78 198.13 204.47 235.15 182.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "198.06 161.87 198.06 197.11 228.94 179.1 228.94 143.85 198.06 161.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "198.08 161.87 198.08 197.11 167.09 179.05 167.09 143.82 198.08 161.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "167.09 143.82 198.08 161.87 228.94 143.85 197.92 125.79 167.09 143.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "182.75 143.74 197.9 152.56 213.25 143.72 198.09 134.89 182.75 143.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "228.61 58.65 197.91 40.77 167.39 58.61 167.39 144.06 197.79 161.76 228.61 144.03 228.61 58.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "213.66 24.84 197.95 15.69 182.34 24.82 182.34 143.65 197.89 152.7 213.66 143.63 213.66 24.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-118",
    points: "198.17 291.08 214.34 281.46 223.17 256.77 278.61 224.7 278.61 209.68 198.15 256.6 198.17 256.62 198.17 291.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-140",
    points: "291.64 301.36 291.64 305.37 276.49 296.69 276.49 292.68 291.64 301.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-139",
    points: "291.63 301.36 291.63 305.37 306.78 296.42 306.78 292.42 291.63 301.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "306.78 292.42 291.63 301.36 276.49 292.68 291.65 283.73 306.78 292.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "291.58 304.95 291.85 301.3 306.52 292.63 291.64 300.86 276.83 292.94 291.48 301.44 291.58 304.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-140",
    points: "266.12 286.48 266.12 290.5 250.96 281.82 250.96 277.8 266.12 286.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-139",
    points: "266.11 286.48 266.11 290.5 281.25 281.54 281.25 277.54 266.11 286.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "281.25 277.54 266.11 286.48 250.96 277.8 266.13 268.85 281.25 277.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "266.06 290.07 266.32 286.42 281 277.75 266.12 285.98 251.31 278.06 265.95 286.56 266.06 290.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-140",
    points: "241.14 272.15 241.14 276.16 225.98 267.48 225.98 263.47 241.14 272.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-139",
    points: "241.13 272.15 241.13 276.16 256.28 267.21 256.28 263.2 241.13 272.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "256.28 263.2 241.13 272.15 225.98 263.47 241.15 254.51 256.28 263.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "241.08 275.74 241.35 272.09 256.02 263.42 241.14 271.65 226.33 263.73 240.97 272.23 241.08 275.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "298.07 294.84 297.23 294.35 298.07 293.89 298.91 294.37 298.07 294.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "292.92 296.84 296.63 294.7 297.47 295.19 293.76 297.33 292.92 296.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "296.23 292.7 297.07 293.18 294.27 294.79 293.43 294.31 296.23 292.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "292.53 290.36 293.37 290.84 289.66 292.98 288.82 292.5 292.53 290.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "290.59 289.24 291.43 289.73 288.89 291.19 288.06 290.7 290.59 289.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "292.3 292.73 293.14 293.21 289.43 295.35 288.59 294.87 292.3 292.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "290.56 287.02 291.4 287.51 288.86 288.97 288.02 288.48 290.56 287.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "287.42 288.83 288.26 289.32 284.55 291.46 283.71 290.97 287.42 288.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "297.67 292.83 296.83 292.35 297.68 291.88 298.51 292.37 297.67 292.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "293.74 292.86 292.9 292.38 295.44 290.92 296.28 291.4 293.74 292.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "293.97 290.49 293.13 290.01 293.97 289.55 294.81 290.03 293.97 290.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "296.05 290.56 297.87 289.53 298.71 290.02 296.88 291.05 296.05 290.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "289.06 293.33 285.89 295.16 285.05 294.67 288.22 292.85 289.06 293.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "288.83 295.7 287.83 296.28 286.99 295.79 287.99 295.22 288.83 295.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "288.29 291.54 283.95 294.04 283.12 293.56 287.45 291.05 288.29 291.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "291.16 286.67 292.06 286.18 292.9 286.66 292 287.16 291.16 286.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "283.11 291.32 283.95 291.81 282.02 292.92 281.18 292.44 283.11 291.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "293.67 295.14 289.77 297.39 288.93 296.91 292.83 294.66 293.67 295.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "291.19 288.89 294 287.29 294.84 287.78 292.04 289.38 291.19 288.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "294.58 289.19 295.94 288.41 296.77 288.9 295.42 289.68 294.58 289.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "293.16 297.68 291.7 298.51 290.87 298.03 292.32 297.19 293.16 297.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "298.28 291.53 299.81 290.65 300.65 291.13 299.12 292.02 298.28 291.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "298.68 293.54 301.75 291.77 302.59 292.25 299.52 294.02 298.68 293.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "247.5 265.66 246.66 265.18 247.5 264.71 248.34 265.2 247.5 265.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "242.35 267.67 246.05 265.53 246.89 266.01 243.19 268.15 242.35 267.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "245.66 263.52 246.5 264 243.7 265.62 242.86 265.13 245.66 263.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "241.95 261.18 242.79 261.67 239.09 263.81 238.25 263.32 241.95 261.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "240.02 260.06 240.86 260.55 238.32 262.01 237.48 261.53 240.02 260.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "241.72 263.55 242.56 264.04 238.86 266.18 238.02 265.69 241.72 263.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "239.99 257.85 240.82 258.33 238.29 259.79 237.45 259.31 239.99 257.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "236.84 259.66 237.68 260.14 233.98 262.28 233.14 261.8 236.84 259.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "247.1 263.65 246.26 263.17 247.1 262.71 247.94 263.19 247.1 263.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "243.17 263.69 242.33 263.2 244.87 261.74 245.71 262.22 243.17 263.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "243.4 261.32 242.56 260.83 243.4 260.37 244.24 260.85 243.4 261.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "245.47 261.39 247.3 260.36 248.14 260.84 246.31 261.87 245.47 261.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "238.48 264.16 235.32 265.98 234.48 265.5 237.64 263.67 238.48 264.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "238.25 266.52 237.26 267.1 236.42 266.62 237.41 266.04 238.25 266.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "237.72 262.36 233.38 264.86 232.54 264.38 236.88 261.88 237.72 262.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "240.59 257.5 241.49 257 242.33 257.48 241.43 257.98 240.59 257.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "232.53 262.15 233.37 262.63 231.44 263.75 230.61 263.26 232.53 262.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "243.09 265.97 239.19 268.22 238.35 267.73 242.25 265.48 243.09 265.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "240.62 259.71 243.43 258.12 244.26 258.6 241.46 260.2 240.62 259.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "244.01 260.02 245.36 259.24 246.2 259.72 244.85 260.5 244.01 260.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "242.58 268.5 241.13 269.34 240.29 268.85 241.74 268.01 242.58 268.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "247.71 262.36 249.24 261.47 250.08 261.96 248.55 262.84 247.71 262.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "248.11 264.36 251.17 262.59 252.01 263.08 248.95 264.85 248.11 264.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M257.73,279l5.24,3a2.19,2.19,0,0,0,2,0l.56-.32,2.78,1.6V280.1l5.59-3.22a.61.61,0,0,0,0-1.15l-5.25-3a2.16,2.16,0,0,0-2,0l-8.94,5.16C257.18,278.19,257.18,278.7,257.73,279Zm9.39-3c0-.33.47-.6,1.05-.6s1.05.26,1.05.6-.47.61-1.05.61S267.12,276.35,267.12,276Zm-2.42,1.4c0-.33.47-.61,1.05-.61s1.05.27,1.05.61-.47.6-1.05.61S264.7,277.75,264.7,277.41Zm-2.42,1.4c0-.34.47-.61,1.05-.61s1.05.27,1.05.61-.47.6-1.05.6S262.28,279.14,262.28,278.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-119",
    points: "154.48 267.65 197.58 291.42 198.13 291.11 198.13 256.62 198.15 256.6 117.43 209.59 117.43 266.57 128.98 272.75 154.48 267.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "359.43 280.89 359.43 459.54 430.43 418.13 430.43 239.48 359.43 280.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "359.46 280.89 359.46 459.54 288.22 418.01 288.22 239.41 359.46 280.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-142",
    points: "288.22 239.41 359.46 280.89 430.43 239.48 359.11 197.95 288.22 239.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "68.36 281.59 68.36 450.02 135.3 410.98 135.3 242.54 68.36 281.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "68.39 281.59 68.39 450.02 1.23 410.86 1.23 242.47 68.39 281.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-142",
    points: "1.23 242.47 68.39 281.59 135.3 242.54 68.06 203.39 1.23 242.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "217.71 423.52 217.71 436.44 154.67 400.34 154.67 387.42 217.71 423.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "217.67 423.52 217.67 436.44 280.68 399.2 280.68 386.33 217.67 423.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "280.68 386.33 217.67 423.52 154.67 387.42 217.75 350.18 280.68 386.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "217.46 428.66 218.57 423.29 279.61 387.24 217.72 422.8 156.12 388.51 217.01 423.86 217.46 428.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "390.43 230.42 405.39 246 354.89 217.07 339.93 201.49 390.43 230.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "390.4 230.42 405.36 246 412.06 242 412.06 217.74 390.4 230.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "412.06 217.74 390.4 230.42 339.93 201.49 361.67 188.76 412.06 217.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "397.25 237.9 391.23 230.21 411.09 218.57 390.45 229.77 341.26 202.49 389.8 230.73 397.25 237.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M381.3,220.92,357.15,207c-.49-.28-.43-.76.13-1.09l9.07-5.23a2.08,2.08,0,0,1,1.89-.08l24.16,13.94c.48.28.42.77-.14,1.09l-9.07,5.24A2.11,2.11,0,0,1,381.3,220.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M366.88,201.67l1.55.89a.81.81,0,0,0,.71,0,.22.22,0,0,0,0-.41l-1.55-.89a.75.75,0,0,0-.71,0C366.68,201.37,366.68,201.55,366.88,201.67Zm2.65,1.53.73.42a.83.83,0,0,0,.72,0,.22.22,0,0,0,0-.41l-.73-.42a.75.75,0,0,0-.71,0C369.33,202.9,369.33,203.08,369.53,203.2Zm1.84,1.06.73.42a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.42a.75.75,0,0,0-.71,0C371.17,204,371.17,204.14,371.37,204.26Zm1.83,1.06.74.42a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.42a.77.77,0,0,0-.71,0C373,205,373,205.2,373.2,205.32Zm1.84,1.06.73.42a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.42a.77.77,0,0,0-.71,0C374.84,206.08,374.84,206.26,375,206.38Zm1.83,1.05.74.43a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.74-.42a.77.77,0,0,0-.71,0C376.68,207.14,376.68,207.32,376.87,207.43Zm1.84,1.06.73.43a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.42a.77.77,0,0,0-.71,0C378.51,208.2,378.51,208.38,378.71,208.49Zm1.84,1.06.73.43a.81.81,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.74-.42a.77.77,0,0,0-.71,0C380.35,209.26,380.35,209.44,380.55,209.55Zm1.83,1.06.73.43a.83.83,0,0,0,.72,0,.22.22,0,0,0,0-.41l-.73-.42a.77.77,0,0,0-.71,0C382.18,210.32,382.18,210.5,382.38,210.61Zm1.84,1.06.73.43a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.42a.79.79,0,0,0-.72,0C384,211.38,384,211.56,384.22,211.67Zm1.83,1.06.74.43a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.42a.77.77,0,0,0-.71,0C385.85,212.44,385.86,212.62,386.05,212.73Zm1.84,1.06.73.43a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.43a.8.8,0,0,0-.71,0C387.69,213.5,387.69,213.68,387.89,213.79Zm1.87,1.09.74.42a.8.8,0,0,0,.71,0,.22.22,0,0,0,0-.41l-.73-.42a.75.75,0,0,0-.71,0C389.56,214.58,389.57,214.76,389.76,214.88Zm-24.53-12.2.64.36a.87.87,0,0,0,.8,0l.63-.36c.23-.13.23-.34,0-.47l-.63-.36a.92.92,0,0,0-.81,0l-.63.37A.25.25,0,0,0,365.23,202.68Zm3.28,1.42.63-.36a.25.25,0,0,0,0-.47l-.64-.36a.92.92,0,0,0-.81,0l-.63.37c-.22.13-.22.34,0,.47l.63.36A.89.89,0,0,0,368.51,204.1Zm.39.7.64.36a.89.89,0,0,0,.81,0l.63-.36c.22-.13.22-.34,0-.47l-.63-.36a.92.92,0,0,0-.81,0l-.63.37A.25.25,0,0,0,368.9,204.8Zm1.84,1.06.63.36a.89.89,0,0,0,.81,0l.63-.36a.25.25,0,0,0,0-.47l-.64-.36a.9.9,0,0,0-.8,0l-.64.37C370.51,205.52,370.51,205.73,370.74,205.86Zm3.9.59-.63-.36a.92.92,0,0,0-.81,0l-.63.37c-.22.13-.22.34,0,.46l.64.37a.89.89,0,0,0,.81,0l.63-.36C374.87,206.79,374.87,206.58,374.64,206.45Zm1.84,1.06-.63-.37a.92.92,0,0,0-.81,0l-.63.37c-.23.13-.23.34,0,.46l.63.37a.89.89,0,0,0,.81,0l.63-.36C376.71,207.85,376.7,207.64,376.48,207.51Zm1.84,1.06-.64-.37a.92.92,0,0,0-.81,0l-.63.37c-.22.13-.22.33,0,.46l.64.37a.89.89,0,0,0,.81,0l.63-.36A.25.25,0,0,0,378.32,208.57Zm1.83,1.06-.63-.37a.92.92,0,0,0-.81,0l-.63.37c-.23.13-.22.33,0,.46l.63.37a.89.89,0,0,0,.81,0l.63-.36C380.38,210,380.38,209.76,380.15,209.63Zm1.84,1.06-.64-.37a.89.89,0,0,0-.81,0l-.63.37c-.22.13-.22.33,0,.46l.63.37a.89.89,0,0,0,.81,0l.63-.36A.25.25,0,0,0,382,210.69Zm1.83,1.06-.63-.37a.89.89,0,0,0-.81,0l-.63.37c-.22.13-.22.33,0,.46l.64.37a.87.87,0,0,0,.8,0l.64-.36C384.05,212.09,384.05,211.88,383.82,211.75Zm-.23,1.52.63.37a.89.89,0,0,0,.81,0l.63-.36a.25.25,0,0,0,0-.47l-.64-.37a.87.87,0,0,0-.8,0l-.64.37C383.36,212.94,383.36,213.14,383.59,213.27Zm3.9.6-.63-.37a.89.89,0,0,0-.81,0l-.63.37c-.22.13-.22.33,0,.46l.64.37a.89.89,0,0,0,.81,0l.63-.36C387.72,214.21,387.72,214,387.49,213.87Zm2.69,1.55-1.45-.83a.92.92,0,0,0-.81,0l-.63.37c-.22.13-.22.34,0,.47l1.45.83a.87.87,0,0,0,.8,0l.64-.36C390.41,215.76,390.41,215.55,390.18,215.42Zm-26.65-11.76,1.45.83a.92.92,0,0,0,.81,0l.63-.37a.25.25,0,0,0,0-.47l-1.45-.83a.89.89,0,0,0-.81,0l-.63.36C363.3,203.32,363.31,203.53,363.53,203.66Zm2.65,1.53.64.36a.9.9,0,0,0,.8,0l.63-.37c.23-.13.23-.34,0-.47l-.63-.36a.89.89,0,0,0-.81,0l-.63.36A.25.25,0,0,0,366.18,205.19Zm2.47,1.42a.92.92,0,0,0,.81,0l.63-.37a.25.25,0,0,0,0-.47l-.64-.36a.89.89,0,0,0-.81,0l-.63.36c-.22.13-.22.34,0,.47Zm1.84,1.06a.89.89,0,0,0,.81,0l.63-.36c.22-.13.22-.34,0-.47l-.63-.36a.89.89,0,0,0-.81,0l-.63.36a.25.25,0,0,0,0,.47Zm1.83-.13-.64.36c-.22.13-.22.34,0,.47l.63.36a.89.89,0,0,0,.81,0l.63-.36a.25.25,0,0,0,0-.47l-.64-.36A.87.87,0,0,0,372.32,207.54Zm1.87,1-.71.41c-.2.12-.2.31,0,.42l.72.42a.85.85,0,0,0,.73,0l.71-.41c.2-.12.2-.31,0-.42l-.71-.42A.85.85,0,0,0,374.19,208.57Zm1.84,1.06-.71.41c-.2.12-.2.31,0,.42l.71.42a.85.85,0,0,0,.73,0l.71-.41c.2-.12.2-.31,0-.42l-.71-.42A.85.85,0,0,0,376,209.63Zm1.83,1.06-.71.41c-.2.12-.2.31,0,.42l.71.42a.85.85,0,0,0,.73,0l.71-.41c.2-.12.2-.31,0-.42l-.72-.42A.85.85,0,0,0,377.86,210.69Zm1.84,1.06-.71.41c-.2.12-.2.31,0,.42l.71.42a.85.85,0,0,0,.73,0l.71-.41c.2-.12.2-.31,0-.42l-.71-.42A.85.85,0,0,0,379.7,211.75Zm1.83,1.06-.71.41c-.2.12-.2.31,0,.42l.71.41a.82.82,0,0,0,.73,0l.71-.41c.2-.12.2-.31,0-.42l-.72-.42A.85.85,0,0,0,381.53,212.81Zm2.58,2.31.7-.41c.21-.12.2-.31,0-.43l-.71-.41a.85.85,0,0,0-.73,0l-.71.41c-.2.12-.2.31,0,.42l.72.41A.82.82,0,0,0,384.11,215.12Zm1.83,1.06.71-.41a.23.23,0,0,0,0-.43l-.72-.41a.85.85,0,0,0-.73,0l-.7.41c-.21.12-.2.31,0,.42l.71.41A.82.82,0,0,0,385.94,216.18Zm2.58.25-.71-.41a.82.82,0,0,0-.73,0l-.71.41c-.2.12-.2.31,0,.42l.71.42a.87.87,0,0,0,.74,0l.7-.41C388.73,216.73,388.72,216.54,388.52,216.43Zm-26.73-11.81,2.3,1.33a.85.85,0,0,0,.73,0l.71-.41c.2-.12.2-.31,0-.42l-2.3-1.33a.79.79,0,0,0-.73,0l-.71.4A.23.23,0,0,0,361.79,204.62Zm3.43,2,.71.41a.82.82,0,0,0,.73,0l.71-.41c.2-.12.2-.31,0-.42l-.72-.42a.85.85,0,0,0-.73,0l-.71.41C365,206.29,365,206.48,365.22,206.59Zm1.83,1.06.71.41a.82.82,0,0,0,.73,0l.71-.41a.23.23,0,0,0,0-.43l-.71-.41a.85.85,0,0,0-.73,0l-.71.41C366.85,207.35,366.85,207.54,367.05,207.65Zm1.84,1.06.71.41a.82.82,0,0,0,.73,0l.71-.41a.23.23,0,0,0,0-.43l-.72-.41a.85.85,0,0,0-.73,0l-.71.41C368.68,208.41,368.68,208.6,368.89,208.71Zm3.28,1.48.7-.41c.21-.12.2-.31,0-.43l-.71-.41a.85.85,0,0,0-.73,0l-.71.41c-.2.12-.2.31,0,.42l.72.41A.82.82,0,0,0,372.17,210.19Zm1.83,1.06.71-.41a.23.23,0,0,0,0-.43L374,210a.85.85,0,0,0-.73,0l-.7.41c-.21.12-.2.31,0,.42l.71.41A.82.82,0,0,0,374,211.25Zm1.84,1.06.71-.41c.2-.12.2-.31,0-.43l-.71-.41a.85.85,0,0,0-.73,0l-.71.41c-.2.12-.2.31,0,.42l.72.41A.82.82,0,0,0,375.84,212.31Zm1.83,1.05.71-.4a.23.23,0,0,0,0-.43l-.71-.41a.82.82,0,0,0-.73,0l-.71.41c-.2.12-.2.31,0,.42l.71.41A.79.79,0,0,0,377.67,213.36Zm1.84,1.06.71-.4c.2-.12.2-.31,0-.43l-.71-.41a.82.82,0,0,0-.73,0l-.71.41c-.2.12-.2.31,0,.42l.72.41A.79.79,0,0,0,379.51,214.42Zm1.83,1.06.71-.4a.23.23,0,0,0,0-.43l-.71-.41a.82.82,0,0,0-.73,0l-.71.41c-.2.12-.2.3,0,.42l.71.41A.79.79,0,0,0,381.34,215.48Zm.4.65.71.41a.79.79,0,0,0,.73,0l.71-.4a.23.23,0,0,0,0-.43l-.72-.41a.82.82,0,0,0-.73,0l-.71.41C381.53,215.83,381.53,216,381.74,216.13Zm5.08,1.28-1.81-1a.79.79,0,0,0-.73,0l-.71.41c-.2.12-.2.3,0,.42l1.81,1.05a.84.84,0,0,0,.74,0l.7-.41C387,217.71,387,217.53,386.82,217.41ZM360.1,205.65l3.26,1.88a.9.9,0,0,0,.83,0l.61-.36c.23-.13.23-.34,0-.48l-3.27-1.88a.91.91,0,0,0-.82,0l-.61.35A.25.25,0,0,0,360.1,205.65Zm4.48,2.59.62.35a.88.88,0,0,0,.82,0l.62-.36c.23-.13.22-.34,0-.48l-.62-.35a.9.9,0,0,0-.83,0l-.61.35A.25.25,0,0,0,364.58,208.24Zm1.84,1.06.61.35a.9.9,0,0,0,.83,0l.61-.36c.23-.13.23-.34,0-.48l-.62-.35a.88.88,0,0,0-.82,0l-.62.35A.26.26,0,0,0,366.42,209.3Zm1.83,1.06.62.35a.87.87,0,0,0,.83,0l.61-.35c.23-.13.23-.34,0-.48l-.62-.35a.9.9,0,0,0-.83,0l-.61.35C368,210,368,210.22,368.25,210.36Zm1.84,1.06.62.35a.85.85,0,0,0,.82,0l.62-.35c.22-.13.22-.34,0-.48l-.61-.35a.87.87,0,0,0-.83,0l-.61.35C369.86,211.07,369.86,211.28,370.09,211.42Zm1.83,1.06.62.35a.87.87,0,0,0,.83,0l.61-.35c.23-.13.23-.34,0-.48l-.62-.35a.87.87,0,0,0-.83,0l-.61.35C371.69,212.13,371.69,212.34,371.92,212.48Zm1.84,1.06.62.35a.88.88,0,0,0,.82,0l.62-.35c.22-.13.22-.34,0-.48l-.61-.35a.9.9,0,0,0-.83,0l-.61.36C373.53,213.19,373.53,213.4,373.76,213.54Zm1.83,1.06.62.35a.9.9,0,0,0,.83,0l.61-.35c.23-.13.23-.34,0-.48l-.62-.35a.88.88,0,0,0-.82,0l-.62.36C375.37,214.25,375.37,214.46,375.59,214.6Zm1.84,1.06.62.35a.88.88,0,0,0,.82,0l.62-.35a.26.26,0,0,0,0-.48l-.62-.35a.9.9,0,0,0-.83,0l-.61.36C377.2,215.31,377.2,215.52,377.43,215.66Zm1.84,1.06.61.35a.9.9,0,0,0,.83,0l.61-.35a.25.25,0,0,0,0-.48l-.62-.35a.88.88,0,0,0-.82,0l-.62.36C379,216.37,379,216.58,379.27,216.72Zm1.83,1.06.62.35a.93.93,0,0,0,.83,0l.61-.35a.25.25,0,0,0,0-.48l-.62-.35a.9.9,0,0,0-.83,0l-.61.36C380.87,217.43,380.87,217.64,381.1,217.78Zm3.93.61-.61-.36a.93.93,0,0,0-.83,0l-.61.35a.25.25,0,0,0,0,.48l.62.36a.91.91,0,0,0,.82,0l.62-.36C385.26,218.73,385.26,218.52,385,218.39Zm-23.76-11.76-1.44-.83a.91.91,0,0,0-.82,0l-.62.35a.26.26,0,0,0,0,.48l1.43.83a.93.93,0,0,0,.83,0l.61-.36C361.5,207,361.5,206.76,361.27,206.63Zm1.83,1.06-.62-.36a.91.91,0,0,0-.82,0l-.61.35c-.23.14-.23.35,0,.48l.62.36a.91.91,0,0,0,.82,0l.62-.36C363.33,208,363.33,207.82,363.1,207.69Zm1.84,1.06-.62-.36a.93.93,0,0,0-.83,0l-.61.35a.25.25,0,0,0,0,.48l.62.36a.93.93,0,0,0,.83,0l.61-.36C365.17,209.09,365.17,208.88,364.94,208.75Zm12.85,7.42-11.63-6.72a.93.93,0,0,0-.83,0l-.61.35a.25.25,0,0,0,0,.48L376.35,217a.93.93,0,0,0,.83,0l.61-.36C378,216.51,378,216.3,377.79,216.17Zm1.83,1.06-.61-.36a.93.93,0,0,0-.83,0l-.61.35a.25.25,0,0,0,0,.48l.62.36a.91.91,0,0,0,.82,0l.62-.36C379.85,217.57,379.85,217.36,379.62,217.23Zm1.84,1.06-.62-.36a.91.91,0,0,0-.82,0l-.62.35a.26.26,0,0,0,0,.48l.62.36a.93.93,0,0,0,.83,0l.61-.36C381.69,218.63,381.69,218.42,381.46,218.29Zm1.87,1.08-.61-.36a.93.93,0,0,0-.83,0l-.61.35a.25.25,0,0,0,0,.48l.62.36a.91.91,0,0,0,.82,0l.62-.36C383.56,219.71,383.56,219.5,383.33,219.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "337.08 246.76 352.62 255.83 370.82 245.27 355.27 236.22 337.08 246.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "337.43 246.79 352.58 255.63 370.31 245.34 355.15 236.52 337.43 246.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "337.78 246.83 352.53 255.43 369.8 245.41 355.04 236.81 337.78 246.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "338.13 246.86 352.48 255.23 369.29 245.48 354.93 237.12 338.13 246.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "338.48 246.89 352.44 255.03 368.78 245.55 354.81 237.41 338.48 246.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "338.82 246.92 352.39 254.83 368.27 245.62 354.7 237.71 338.82 246.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "339.17 246.95 352.34 254.63 367.76 245.69 354.58 238.01 339.17 246.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "339.52 246.98 352.3 254.44 367.25 245.75 354.47 238.31 339.52 246.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "339.87 247.01 352.25 254.24 366.75 245.82 354.36 238.61 339.87 247.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "340.22 247.04 352.2 254.04 366.24 245.89 354.24 238.91 340.22 247.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "340.57 247.07 352.16 253.84 365.73 245.96 354.13 239.21 340.57 247.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "340.92 247.11 352.11 253.64 365.22 246.03 354.02 239.51 340.92 247.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M371,245.62c-6.44,2.45-9.34.58-13.76-2s-6.33-4.74-1.52-6.65,9.42.1,13.83,2.65S374.46,244.28,371,245.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M355,239.72a3.7,3.7,0,0,0-.07,1.76,1.89,1.89,0,0,0,2.31.5c.92-.45,1.31-1.39,1.66-1.64s2.31-.47,3.78-1.71S364,236,362.5,236a12.26,12.26,0,0,0-5.07,1.27A15.73,15.73,0,0,0,355,239.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M355.72,241.06c1,.22,2.38-.7,3-1.22s1.72-.25,3.13-1.36,1.91-1.89,1.27-2.26-3-.27-4.84.72-3.06,1.71-3.06,1.71-.45,1.37-.22,1.66S355.12,240.94,355.72,241.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M355.7,218.06a24.15,24.15,0,0,0-.26,7.6c.53,4.25-.29,4.45-.48,7.46s-1.24,6.73.3,7.49a3.28,3.28,0,0,0,3.69-1.23c1.22-1.41,1.49-2.79,1.34-3s-.38-1.42.11-3.91a78.91,78.91,0,0,0,1.38-10.55A5.46,5.46,0,0,0,361,219Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M362.82,244.14s-.55,1.61.12,2a3.1,3.1,0,0,0,2.56.17c.85-.37,1.19-.74,2.09-.74a12.58,12.58,0,0,0,5-2.56c.67-.84,0-1.81-1.66-1.69s-4.05.33-4.47.47S362.82,244.14,362.82,244.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M363.56,245.33c1.57.18,2.07-.25,3.51-.55s5.53-1.95,5.46-2.87-1-.73-1.81-.65-3.33.25-3.53.25-4.32,1.86-4.32,1.86-.3,1.34,0,1.54S363.14,245.28,363.56,245.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M358.84,221.18a9.76,9.76,0,0,1,3.64,7.1c0,4.4-.48,15.76.19,16.39a4.18,4.18,0,0,0,4,.15c1.55-1.14,2.38-2.75,2.23-3.31s-1.34-2.57-.93-4.36,1.79-8,1.53-12.18-3.74-4.75-5.32-4.69A43.09,43.09,0,0,0,358.84,221.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M351.69,256a2.92,2.92,0,0,1-1.43-.38l-11.46-6.65a1.62,1.62,0,0,1,0-2.81L350,239.89V233.7a.61.61,0,0,1,.61-.61.61.61,0,0,1,.61.61v6.54a.6.6,0,0,1-.31.53l-11.47,6.42a.39.39,0,0,0-.21.35.4.4,0,0,0,.2.35l11.46,6.65a1.63,1.63,0,0,0,1.64,0l9.92-5.8V232a.61.61,0,1,1,1.21,0v17.05a.58.58,0,0,1-.3.52l-10.22,6A2.82,2.82,0,0,1,351.69,256Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M351.59,255.46a2.38,2.38,0,0,1-1.22-.33l-11.47-6.65a1.19,1.19,0,0,1-.6-1,1.23,1.23,0,0,1,.62-1.05L350.29,240V233.6a.2.2,0,1,1,.4,0v6.54a.22.22,0,0,1-.1.18l-11.47,6.41a.8.8,0,0,0-.41.7.76.76,0,0,0,.4.7l11.46,6.65a2,2,0,0,0,2,0l10.12-5.92V231.93a.21.21,0,1,1,.41,0v17a.19.19,0,0,1-.1.17l-10.22,6A2.41,2.41,0,0,1,351.59,255.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M351.54,255.23a2.26,2.26,0,0,1-1.14-.3l-11.47-6.65a1.06,1.06,0,0,1-.52-.92,1,1,0,0,1,.54-.9l11.45-6.41v-6.52a0,0,0,0,1,.08,0v6.54a.05.05,0,0,1,0,0L339,246.53a1,1,0,0,0,0,1.67l11.47,6.66a2.2,2.2,0,0,0,1.1.29,2.12,2.12,0,0,0,1.1-.3l10.2-6v-17a0,0,0,0,1,0,0,0,0,0,0,1,.05,0v17l-10.24,6A2.33,2.33,0,0,1,351.54,255.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "350.9 238.65 350.9 239.89 364.69 231.92 364.69 230.64 350.9 238.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "350.91 238.65 350.91 239.89 337.4 232.05 337.4 230.77 350.91 238.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "350.9 237.89 350.9 239.13 364.69 231.16 364.69 229.88 350.9 237.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "350.91 237.89 350.91 239.13 337.4 231.29 337.4 230.01 350.91 237.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "337.4 230.01 350.91 237.89 364.69 229.88 351.17 222.01 337.4 230.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M359.83,210.31a11.44,11.44,0,0,0,3,.43c.78.1,1.57.12,1.59-.28.05-.78-3.23-1.13-3.23-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M357.73,207.2a31.47,31.47,0,0,1,4-1.32,3.65,3.65,0,0,1,2.7.39c.64.27,1.08.55,1,.92,0,.17-.39-.06-.39-.06s.74.37.71.83-.48.08-.48.08.81.41.76.86-.53,0-.53,0,.69.37.7.75-.22.36-.72.21a6.6,6.6,0,0,0-3.06-.31c-1.17.26-1.83,1-2.75.68a3.64,3.64,0,0,0-2.12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M358.41,206.47a1.84,1.84,0,0,1,.74,1.63,9.5,9.5,0,0,1-1,2.79H347.31s-7.58.57-6.25-2.58,1.56-3.88,5.38-3a34,34,0,0,0,8.34,1.15C356.35,206.54,358.41,206.47,358.41,206.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.73,209.61c-.37.83-.6,1.28-.6,1.28H347.31s-6.4.83-6.25-2.56a42.36,42.36,0,0,0,9.82,1.41C355.07,209.73,357.64,209.66,358.73,209.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M344.66,221.38c1.11-.47,7.23-3.78,9.08-3.25,2.87.84,8.43,6.3,8.43,6.3s-14.45,10.38-19.64,6.58S344.66,221.38,344.66,221.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M350.4,224.34c1.12-.46,7.5-3.17,9.42-3,4.43.35,7.06,6.3,7.06,6.3s-13.06,9.43-18.61,6.36C341.77,230.38,350.4,224.34,350.4,224.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M353.86,195.8c1,.72,2,1.82,1.64,4.64s-.55,4.18-1.17,4.46-1-.15-1.23.62a8.87,8.87,0,0,0-.2,2.11L347,205.3a3,3,0,0,0,.33-2c-.23-1.08-1.7-3.32.1-6A5,5,0,0,1,353.86,195.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M355.85,198.56c-.06.54-.52,1.36-1.29,1.3a1.17,1.17,0,0,0-1.18,1.23c.11.45,0,.55,0,.55s-.53-.31-.85.1-.14,1.42,0,1.81-1.33,1.33-2.39,1.25-2.45-.41-2.81-1a5.92,5.92,0,0,1-.72-5.45,5.09,5.09,0,0,1,6.33-3.23C355.27,196,355.94,197.8,355.85,198.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.5,198.57a6.35,6.35,0,0,0,2.71,1.66,9.92,9.92,0,0,0,4.24.4.79.79,0,0,0-.07.46c.11.45,0,.55,0,.55s-.53-.31-.85.1-.14,1.42,0,1.81-1.33,1.33-2.39,1.25-2.45-.41-2.81-1A6,6,0,0,1,346.5,198.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M348.87,206.4a10.84,10.84,0,0,1-2.23-1.62h-2.28a3.49,3.49,0,0,0-3.25,2.9c-.48,2-.36,5-.54,8.07-.6,10.35-2.51,10.91.63,12.59s7.71,2.73,10.33.52,2.21-2.42,2.81-7.23,2.33-6.94.69-9.73-3.38-4.25-4.63-4.78A13.22,13.22,0,0,1,348.87,206.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M354.13,209.18c-.26-1.39-1.43-1.67-2.3-2a23.29,23.29,0,0,1-4.05-1.79,1.33,1.33,0,0,1-.61-1.17l-.62.53s-.19,1.35,1.65,2.23,4,1.27,5,2.44a7.12,7.12,0,0,0,1,1.07S354.38,210.58,354.13,209.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M350.56,213.34c1.95-2.11,3.94.13,5.33,2-.27,1.59-1.19,3.38-1.55,6.32-.6,4.81-.18,5-2.81,7.22a5,5,0,0,1-4.29,1.27C347.56,229.17,348,216.09,350.56,213.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M371.45,216.1a27.14,27.14,0,0,0,1.9-2.14c.46-.64,1-1.22,1.3-1,.6.51-1.43,3.12-1.43,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M371,219.59a32.64,32.64,0,0,0,4.19-.37,3.73,3.73,0,0,0,2.33-1.43c.47-.51.77-.93.56-1.25-.09-.14-.33.21-.33.21s.53-.63.33-1-.47.11-.47.11.58-.69.35-1.09-.51.17-.51.17.49-.61.35-1-.35-.25-.75.09a6.63,6.63,0,0,1-2.69,1.5c-1.17.23-2.08-.22-2.79.46a3.62,3.62,0,0,1-2,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M351.15,212a3.2,3.2,0,0,0-.68,4.8c1.25,1.59,8.1,5.57,10.28,5.88s11.44-2.35,11.44-2.35a11.8,11.8,0,0,0-.14-2.74,1.73,1.73,0,0,0-1-1.33s-6.46,1.66-8.39,1.34-4.85-2.82-6.74-4.18C353.88,211.89,352.78,210.94,351.15,212Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M350.94,224.6l-1.35-5.47-1,.58,1.35,5.45a33.92,33.92,0,0,1,1,8.09v4.65l1-.55v-4.72A34.53,34.53,0,0,0,350.94,224.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M348.58,219.71l-13.52-7.92,1.35,5.5a33.68,33.68,0,0,1,1,8.06V230l13.53,7.89v-4.65a33.51,33.51,0,0,0-1-8.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "335.06 211.79 348.58 219.71 349.59 219.13 336.05 211.22 335.06 211.79"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M277.63,96.56a2.78,2.78,0,0,1-1.39-.41L202.56,53.61a6.93,6.93,0,0,1-3-5.59V3c0-2.07,1.14-3,2.28-3a2.8,2.8,0,0,1,1.39.41L277,43a6.92,6.92,0,0,1,3,5.59v45C279.91,95.63,278.76,96.56,277.63,96.56ZM201.88,1.43c-.63,0-.86.84-.86,1.57V48a5.54,5.54,0,0,0,2.25,4.35L277,94.91a1.45,1.45,0,0,0,.68.22c.63,0,.85-.85.85-1.57v-45a5.58,5.58,0,0,0-2.24-4.36L202.56,1.65A1.35,1.35,0,0,0,201.88,1.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M277.63,94.94a1.3,1.3,0,0,1-.59-.19L203.37,52.21A5.32,5.32,0,0,1,201.21,48V3c0-.68.21-1.37.67-1.37a1.16,1.16,0,0,1,.58.19l73.68,42.54a5.32,5.32,0,0,1,2.16,4.19v45C278.3,94.25,278.09,94.94,277.63,94.94Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M259.29,76.62c-8.4-4.85-15.23-16.64-15.23-26.28s6.83-13.54,15.23-8.69,15.24,16.64,15.24,26.29S267.69,81.47,259.29,76.62Zm0-33.69c-7.78-4.49-14.12-.88-14.12,8.06s6.34,19.86,14.12,24.35,14.12.89,14.12-8S267.08,47.43,259.29,42.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M259.29,68.84c-4.66-2.69-8.45-9.23-8.45-14.58a11.32,11.32,0,0,1,.1-1.47l-3.49-2.73a16.62,16.62,0,0,0,.54,7.38c2.25,8.42,9.11,16,15.31,17l-1.23-4.58A8.61,8.61,0,0,1,259.29,68.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M266.9,53.17l-2.16,1.7a17.61,17.61,0,0,1,3,9.15,7.11,7.11,0,0,1-1.21,4.3l3,3.75C272.49,67.94,271.39,60.08,266.9,53.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M259.29,49.44a16.61,16.61,0,0,1,5.45,5.43l2.16-1.7a22.82,22.82,0,0,0-7.68-7.64v3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M259.22,49.39V45.53c-5.87-3.39-10.76-1.5-11.77,4.53l3.49,2.73C251.58,48.56,255,47,259.22,49.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M254.11,51.13l3,4.63a1.92,1.92,0,0,1,2.17.1,5.25,5.25,0,0,1,1.56,1.43l2-2.77a12.58,12.58,0,0,0-3.52-3.16C257.22,50.16,255.36,50.16,254.11,51.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M262.15,60.79c0,1.81-1.28,2.54-2.86,1.63a3.75,3.75,0,0,1-.36-.24l-.68,4.05a11,11,0,0,0,1,.69c3.74,2.16,6.79.42,6.79-3.87a11.23,11.23,0,0,0-.38-2.75L262,59.72A5,5,0,0,1,262.15,60.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M256.44,57.58l-3.93-2.27a15.23,15.23,0,0,0,5.74,10.92l.68-4.05A6.41,6.41,0,0,1,256.44,57.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M256.44,57.49a2.08,2.08,0,0,1,.68-1.73l-3-4.63a5,5,0,0,0-1.6,4.09v.09l3.93,2.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M206,17.15v1.91l36.1,20.85V38ZM229.31,35,206,21.54v1.91l23.35,13.49Zm0-9.32L206,12.22v1.91l23.35,13.49ZM206,27.83l30.36,17.55V43.47L206,25.93Zm0,17.59L236.32,63v-1.9L206,43.52Zm0-13.2,20.8,12V42.34l-20.8-12Zm13.15,10.1L206,34.71v1.9l13.15,7.61ZM206,41l17,9.82V48.91L206,39.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M119.29,96.81h0c-1.14,0-2.29-.93-2.29-3v-45a6.93,6.93,0,0,1,3-5.59L193.64.66A2.8,2.8,0,0,1,195,.25c1.14,0,2.29.93,2.29,3v45a6.92,6.92,0,0,1-3,5.59L120.68,96.4A2.8,2.8,0,0,1,119.29,96.81ZM195,1.68a1.42,1.42,0,0,0-.67.22L120.68,44.44a5.52,5.52,0,0,0-2.25,4.35v45c0,.73.23,1.57.86,1.57h0a1.35,1.35,0,0,0,.68-.22l73.67-42.54a5.52,5.52,0,0,0,2.25-4.35v-45C195.89,2.53,195.67,1.68,195,1.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M119.29,95.19a1.19,1.19,0,0,0,.58-.19l73.68-42.54a5.31,5.31,0,0,0,2.15-4.19v-45c0-.69-.2-1.38-.66-1.38a1.3,1.3,0,0,0-.59.19L120.77,44.6a5.34,5.34,0,0,0-2.15,4.19v45C118.62,94.5,118.83,95.19,119.29,95.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "192.16 36.6 192.16 46.7 123.2 86.51 123.2 71.93 130.63 56.56 139.28 55.65 152.58 35.14 162.63 44.5 168.66 30.81 182.26 36.66 192.16 36.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "192.16 41.41 192.16 46.7 123.2 86.51 123.2 75.43 134.96 61.35 141.14 64.49 152.27 42.9 160.62 50.33 166.65 41.01 177.93 44.71 192.16 41.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "192.16 44.87 192.16 46.7 123.2 86.51 123.2 80.97 128.15 72.57 136.81 74.57 149.18 58.68 161.54 56.79 165.87 50.5 178.86 50.59 192.16 44.87"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M411.41,209.69a2.08,2.08,0,0,1-1-.29l-46.92-27.09a4.7,4.7,0,0,1-2-3.79V149.85c0-1.5.86-2.17,1.72-2.17a2,2,0,0,1,1,.3l46.92,27.09a4.7,4.7,0,0,1,2,3.79v28.67C413.13,209,412.27,209.69,411.41,209.69Zm-48.23-60.58c-.17,0-.29.32-.29.74v28.67a3.3,3.3,0,0,0,1.3,2.55l46.92,27.09a.63.63,0,0,0,.3.1c.17,0,.29-.31.29-.73V178.86a3.3,3.3,0,0,0-1.3-2.55l-46.92-27.09A.71.71,0,0,0,363.18,149.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M411.41,208.4a.79.79,0,0,1-.37-.12l-46.92-27.09a3.4,3.4,0,0,1-1.37-2.67V149.85c0-.44.13-.88.43-.88a.82.82,0,0,1,.37.13l46.92,27.09a3.39,3.39,0,0,1,1.37,2.67v28.67C411.84,208,411.71,208.4,411.41,208.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "386.69 172.45 391.17 175.02 391.17 173.69 386.69 171.13 386.69 172.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "388.56 183.31 384.1 180.73 384.1 182.05 388.56 184.63 388.56 183.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "388.32 176.24 388.32 174.92 383.34 172.09 383.34 173.42 388.32 176.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "383.09 177.33 383.09 178.65 385.62 180.11 385.62 178.79 383.09 177.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "379.26 179.3 379.26 177.98 375.15 175.65 375.15 176.97 379.26 179.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "390.47 181.59 386.94 179.55 386.94 180.88 390.47 182.91 390.47 181.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "385.4 175.98 385.4 177.31 387.5 178.5 387.5 177.18 385.4 175.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "392.49 174.45 392.49 175.77 393.63 176.44 393.63 175.11 392.49 174.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "384.08 176.55 384.08 175.23 379.81 172.8 379.81 174.13 384.08 176.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "389.64 175.67 389.64 177 395.93 180.59 395.93 179.27 389.64 175.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "381.79 177.9 381.79 176.58 376.43 173.58 376.43 174.9 381.79 177.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "377.72 165.99 377.72 167.32 381.91 169.71 381.91 168.39 377.72 165.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "385.36 170.37 383.23 169.15 383.23 170.47 385.36 171.69 385.36 170.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "382.8 179.98 380.59 178.73 380.59 180.05 382.8 181.3 382.8 179.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "394.75 185.39 400.47 188.71 400.47 187.39 394.75 184.06 394.75 185.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "373.82 174.9 371.8 173.74 371.8 175.06 373.82 176.22 373.82 174.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "367.67 160.43 367.67 161.76 376.65 166.88 376.65 165.55 367.67 160.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "396.08 183.4 398.19 184.63 398.19 183.31 396.08 182.07 396.08 183.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "397.25 181.35 407.12 187.02 407.12 185.69 397.25 180.03 397.25 181.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "388.82 179.25 394.77 182.65 394.77 181.32 388.82 177.93 388.82 179.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "394.95 175.87 394.95 177.19 399.7 179.91 399.7 178.58 394.95 175.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "375.11 172.84 371.8 170.99 371.8 172.31 375.11 174.16 375.11 172.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "393.45 183.31 391.8 182.35 391.8 183.68 393.45 184.64 393.45 183.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "378.49 172.05 371.8 168.24 371.8 169.56 378.49 173.37 378.49 172.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "382.37 182.4 382.37 183.72 384.46 184.91 384.46 183.59 382.37 182.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "381.05 182.97 381.05 181.64 376.78 179.21 376.78 180.54 381.05 182.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "393.04 189.81 395.16 191.04 395.16 189.72 393.04 188.49 393.04 189.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "385.79 185.67 391.74 189.06 391.74 187.74 385.79 184.34 385.79 185.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "375.46 178.46 368.77 174.65 368.77 175.97 375.46 179.78 375.46 178.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "382.02 171.34 371.8 165.49 371.8 166.81 382.02 172.66 382.02 171.34"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M2.1,224.77h0c-1,0-2.1-.84-2.1-2.72V182.46a6.17,6.17,0,0,1,2.65-5l64.78-37.41a2.63,2.63,0,0,1,1.27-.37c1,0,2.1.84,2.1,2.72V182a6.19,6.19,0,0,1-2.65,5L3.36,224.4A2.46,2.46,0,0,1,2.1,224.77Zm66.6-83.65a1.11,1.11,0,0,0-.55.18L3.36,178.71a4.75,4.75,0,0,0-1.93,3.75v39.59c0,.6.17,1.29.67,1.29h0a1.17,1.17,0,0,0,.55-.18l64.78-37.4A4.8,4.8,0,0,0,69.37,182V142.41C69.37,141.82,69.19,141.12,68.7,141.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M2.09,223.26a1.09,1.09,0,0,0,.52-.17l64.78-37.4a4.68,4.68,0,0,0,1.9-3.69V142.41c0-.6-.18-1.21-.59-1.21a1.09,1.09,0,0,0-.51.17L3.4,178.77a4.7,4.7,0,0,0-1.89,3.69v39.59C1.51,222.65,1.69,223.26,2.09,223.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M61.87,171.63l-5.2,3v11.94l5.2-3ZM7.23,208.14v7l5.21-3v-7Zm46.4-41.71-5.2,3v21.9l5.2-3Zm-8.24-5.19-5.2,3v31.84l5.2-3Zm-8.24,21.67-5.2,3v14.93l5.2-3Zm-8.24-6.36-5.2,3v26l5.2-3Zm-8.23,11.23-5.21,3v19.57l5.21-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M148.68,123.92c5.46,2.56,7.74,1.06,11.24-1s5-3.86.86-5.85-7.76-.46-11.25,1.55S145.71,122.52,148.68,123.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M162,85.41c-.07,1.36.07,6.22-1.12,9.31s.15,5.06.42,6.74a30.35,30.35,0,0,1-.22,8.63c-.41,3.5-.37,5.17,0,5.92s.13,1.8-2.11,2.41-4.88.64-4.63-1.42c.08-.68,2,.88,2.65-.14s1.4-2.65,1-6.36-.82-6-1-8-.61-4.55-1-7.27-.85-10.82-.85-10.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M159.54,115.46c0-1.11-.27-4-.27-5.85s-1.34-8.42-.73-9.76c.88-1.93-.33-4.57-.33-5.57s0-7.92,0-9.43l3.75.56c-.07,1.36.07,6.22-1.12,9.31s.15,5.06.42,6.74a30.35,30.35,0,0,1-.22,8.63c-.41,3.5-.37,5.17,0,5.92s.13,1.8-2.11,2.41a10.31,10.31,0,0,1-1.71.33l.51-.28S159.54,116.58,159.54,115.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M161.35,116a2.76,2.76,0,0,1,.72,1.69c-.1.75-.7,1.69-.72,2.39s0,1.25,0,1.27a3.34,3.34,0,0,1-.51.06l-.22-.17v-2.55a3.49,3.49,0,0,0-2.05.38,5.12,5.12,0,0,1-3.6.56c-.86-.37-1.46-3-1.37-3.34s2.16.7,2.5.85a3.71,3.71,0,0,0,.45.17s-1.07-.31-1.32.09a1,1,0,0,0,.83,1.38c.85.14,1.91-1,2.8-1.36S161.12,116.54,161.35,116Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "142.52 70.73 144.6 81.86 151.16 78.1 149.09 66.94 142.52 70.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "142.93 71.08 145.01 82.21 151.16 78.1 149.09 66.94 142.93 71.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "143.69 70.81 145.77 81.94 151.16 78.1 149.09 66.94 143.69 70.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M157.64,90.05c-.48,1.31-1.12,3.91-1.7,5.75s-1.28,3.79-.94,5.11a22.87,22.87,0,0,1,1.21,6.61c0,3-.34,9.42.1,10.37s.86,1.85.62,2.43-2.32,1.08-4,2.17-3.91-1.22-3.06-1.73,1,.1,1.63-.31,2.11-1.66,2-3.19-1.77-11.57-2.24-13.78a36.57,36.57,0,0,1-.89-6.19,53,53,0,0,1,0-8.36C150.7,86.51,159,86.34,157.64,90.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M152.76,122.6l1.6-2a4.14,4.14,0,0,1-.17-1.73,6.47,6.47,0,0,0,.56-2.9,109.49,109.49,0,0,0-1.9-11.65c-.33-1.34.45-2.62.34-3.68s-1.17-4.12-.89-6.24c.16-1.28.71-4.67,1.13-7.17a6.87,6.87,0,0,0-.83.13c2.44-.54,6,.19,5,2.7-.48,1.31-1.12,3.91-1.7,5.75s-1.28,3.79-.94,5.11a22.87,22.87,0,0,1,1.21,6.61c0,3-.34,9.42.1,10.37s.86,1.85.62,2.43-2.32,1.08-4,2.17a1.91,1.91,0,0,1-1.48.27A1.89,1.89,0,0,0,152.76,122.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M159.69,79l-8.71.36s-.55,6.25-.75,8.6-.22,9.88-.22,9.88a8.33,8.33,0,0,0,4.57.86c2.11-.4,6.95-1.52,6.95-1.52s.17-2.32.3-4.45.58-6.93-.14-9A50.58,50.58,0,0,0,159.69,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M159.69,79l-8.71.36s-.55,6.25-.75,8.6-.22,9.88-.22,9.88a8.33,8.33,0,0,0,4.57.86c2.11-.4,6.95-1.52,6.95-1.52s.17-2.32.3-4.45.58-6.93-.14-9A50.58,50.58,0,0,0,159.69,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M156.67,118.58a2.35,2.35,0,0,1,.74,1.92c-.21,1-.79,1.09-.79,1.82v1.91l-.44.17-.49-.18V121.3a7.63,7.63,0,0,0-2.28,1.15,3.33,3.33,0,0,1-3.28.5c-.8-.41-2.28-2.47-1.9-2.88s3.25.43,3.25.43-1.08.11-1.25.66.77,1.24,1.51.91,1.56-1.36,3-1.95A3.18,3.18,0,0,0,156.67,118.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M147.08,76.88l-1.86-.79s-.67-1-1.16-1.18-.77-.19-.8-.35-.08-.38-.08-.38a.63.63,0,0,0-.75.57c-.07.68.18.69.18.69a.31.31,0,0,0-.21.26.6.6,0,0,0,.16.52l.11.1a.45.45,0,0,0,0,.39.78.78,0,0,0,.33.39s0,.46.21.57.46.14.82.26l2.41.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M145.21,76.25a4.08,4.08,0,0,0-.31-1.5c-.28-.52-.62-1.07-.73-1.27s-.4-.45-.61-.27-.12.22.06.74,0,.82.19,1.25S145.21,76.25,145.21,76.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M150.23,87.91c.18-2.13.65-7.49.73-8.45l1.84.32s.17,6.75.22,9.81c0,2.42-.26,7.15-.39,9a10.12,10.12,0,0,1-2.62-.85S150,90.26,150.23,87.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M161.29,64.39c.69,1.51,1.69,6.79,1.28,8.35-.27,1-2.68,7-2.68,7l-2-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M154.24,65.84c-.88.75-3.71,2.86-4.22,4.42s0,2.3.24,3.5a10.67,10.67,0,0,1,.61,4.73c-.23,2.52-.8,9.4-.91,10.22s.78,1.14,1.59,1.27,5.28.31,7.76-.64,3.08-1.33,3.08-1.91a14,14,0,0,0-1.23-5.71,13.63,13.63,0,0,1-1.55-6.19c.11-1.33,2.25-6.94,2.15-9s-1-4-2.52-3.51A32.42,32.42,0,0,0,154.24,65.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M155.21,90.05A6.37,6.37,0,0,1,153,85.78c-.11-2.68.39-5.19,1-5.27s1.12-1.12,1.12-1.9c0-3.63,1.09-10,.19-11a4,4,0,0,0-2.54-.63l1.45-1.19a32.42,32.42,0,0,1,5-2.86c1.5-.47,2.41,1.4,2.52,3.51s-2,7.71-2.15,9a13.63,13.63,0,0,0,1.55,6.19,14,14,0,0,1,1.23,5.71c0,.58-.6,1-3.08,1.91a19.47,19.47,0,0,1-6.62.73C153.37,90.1,154.26,90.1,155.21,90.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M157.51,53.73c-1.92-.45-4.39.41-4.87,2.72a10.32,10.32,0,0,0,.31,5.31c.42.65,1.66.54,2,1.09a2.75,2.75,0,0,1,.3,2.14,5.43,5.43,0,0,1-.71.82l3.13-.38,1.76-1.12s-.81-1.5-.44-2.14,2.47-2.57,1.8-5.48A4,4,0,0,0,157.51,53.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M159.27,63.39a3.23,3.23,0,0,1-1.76.8c-1.21.2-1.84,0-2.25.32a6,6,0,0,0-1,1.14,3.62,3.62,0,0,1,1.64-.68,8.67,8.67,0,0,0,3-.47c.56-.39.46-.65.46-.75A1.47,1.47,0,0,0,159.27,63.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M159.1,63.11s1.05.93.92,1.78-1,1.63-2.5,1.51-2.37-.29-3.11,0-2,.94-2,.94,1.34-2.17,2.48-2.36,2.61-.05,3.29-.39,1.1-.45,1.18-.87A.61.61,0,0,0,159.1,63.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M159.1,63.11s1,.54.84,1.39-1,1.63-2.5,1.51a6.86,6.86,0,0,0-3.17.17,12.5,12.5,0,0,0-1.83,1.19s1.34-2.17,2.48-2.36,2.61-.05,3.29-.39,1.1-.45,1.18-.87A.61.61,0,0,0,159.1,63.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M154.16,66a6.84,6.84,0,0,1,3.17-.17c1.51.12,2.37-.67,2.5-1.51a1.08,1.08,0,0,0-.14-.7,1.16,1.16,0,0,1,.25.87c-.13.83-1,1.63-2.5,1.51a6.86,6.86,0,0,0-3.17.17,12.5,12.5,0,0,0-1.83,1.19s.13-.21.34-.5A9.25,9.25,0,0,1,154.16,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M154.32,57a2.38,2.38,0,0,0-1.68-.51c-1.27.17-.1-2.45,2.72-3.22,2.15-.58,5.21.24,5.73,2.7.71,3.41-1.19,4.88-1.37,6.14s-4,1-3.53-1c.24-1,.36-1.91-.44-1.84S154.91,57.6,154.32,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M156.33,70.14c0,1.77-.68,7.45-.81,9s-1.14,2.74-2.21,2.53-4.75-1.59-5.68-1.9-2.55-.71-2.55-.71a3.68,3.68,0,0,1,.18-1.72,6.28,6.28,0,0,1,.79-1.14s1.21.37,2.57.73c1.21.32,3.7.87,3.7.87a46.73,46.73,0,0,0-.29-5.41c-.29-1.72-.75-3.68.24-4.64C153.44,66.57,156.32,67,156.33,70.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M147.29,78.67c.94.31,4.61,1.7,5.68,1.91s2.08-1,2.21-2.54.83-7.19.82-9a3.86,3.86,0,0,0-.05-.61,3.55,3.55,0,0,1,.38,1.67c0,1.77-.68,7.45-.81,9s-1.14,2.74-2.21,2.53-4.75-1.59-5.68-1.9-2.55-.71-2.55-.71a5,5,0,0,1,0-1C145.59,78.18,146.62,78.45,147.29,78.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M154.5,57.18c3.12,0,4.74-.51,6.27-2.11a3.39,3.39,0,0,1,.32.86c.71,3.41-1.19,4.88-1.37,6.14s-4,1-3.53-1c.24-1,.36-1.91-.44-1.84s-.83-1.36-1.28-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M161.72,57c-1.95-1.19-2.85.56-3.41,2.14s-1,3,1,3.33C162.2,63,163.78,58.3,161.72,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M158.31,59.17c.42-1.2,1-2.48,2.15-2.53-1,1-1,2.34.49,2.43a3.33,3.33,0,0,0,1.7-.29c.11,1.8-1.28,4.07-3.31,3.72S157.76,60.74,158.31,59.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "159.44 372.02 166.18 394.22 229.78 357.13 223.05 334.92 159.44 372.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "159.44 337.82 159.44 372.39 223.05 335.29 223.05 300.72 159.44 337.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M163.57,365.22v-25l55.36-32.29v25Zm2.54-23.57v19.14l50.28-29.32V312.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "159.48 372.02 159.48 337.82 154.67 335.04 154.67 386.95 166.21 394.22 159.48 372.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "171.56 342.81 169.5 343.99 169.5 341.64 171.56 340.45 171.56 342.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "175.41 340.58 173.36 341.77 173.36 339.41 175.41 338.23 175.41 340.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "179.27 338.36 177.22 339.54 177.22 337.19 179.27 336 179.27 338.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "183.13 336.13 181.07 337.31 181.07 334.96 183.13 333.77 183.13 336.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "186.98 333.9 184.93 335.09 184.93 332.73 186.98 331.55 186.98 333.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "190.84 331.68 188.78 332.86 188.78 330.5 190.84 329.32 190.84 331.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "194.69 329.45 192.64 330.63 192.64 328.28 194.69 327.09 194.69 329.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "198.55 327.22 196.5 328.41 196.5 326.05 198.55 324.87 198.55 327.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "202.41 325 200.35 326.18 200.35 323.83 202.41 322.64 202.41 325"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "206.26 322.77 204.21 323.95 204.21 321.6 206.26 320.42 206.26 322.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "210.12 320.54 208.07 321.73 208.07 319.37 210.12 318.19 210.12 320.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "213.97 318.32 211.92 319.5 211.92 317.15 213.97 315.96 213.97 318.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "171.56 346.99 169.5 348.18 169.5 345.82 171.56 344.64 171.56 346.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "175.41 344.77 173.36 345.95 173.36 343.6 175.41 342.41 175.41 344.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "179.27 342.54 177.22 343.73 177.22 341.37 179.27 340.19 179.27 342.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "183.13 340.31 181.07 341.5 181.07 339.14 183.13 337.96 183.13 340.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "186.98 338.09 184.93 339.27 184.93 336.92 186.98 335.73 186.98 338.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "190.84 335.86 188.78 337.05 188.78 334.69 190.84 333.51 190.84 335.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "194.69 333.64 192.64 334.82 192.64 332.46 194.69 331.28 194.69 333.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "198.55 331.41 196.5 332.6 196.5 330.24 198.55 329.05 198.55 331.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "202.41 329.18 200.35 330.37 200.35 328.01 202.41 326.83 202.41 329.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "206.26 326.96 204.21 328.14 204.21 325.79 206.26 324.6 206.26 326.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "210.12 324.73 208.07 325.92 208.07 323.56 210.12 322.38 210.12 324.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "213.97 322.5 211.92 323.69 211.92 321.33 213.97 320.15 213.97 322.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "171.56 351.15 169.5 352.33 169.5 349.98 171.56 348.79 171.56 351.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "175.41 348.92 173.36 350.11 173.36 347.75 175.41 346.57 175.41 348.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "179.27 346.69 177.22 347.88 177.22 345.52 179.27 344.34 179.27 346.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "183.13 344.47 181.07 345.65 181.07 343.3 183.13 342.11 183.13 344.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "186.98 342.24 184.93 343.43 184.93 341.07 186.98 339.89 186.98 342.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "190.84 340.02 188.78 341.2 188.78 338.85 190.84 337.66 190.84 340.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "194.69 337.79 192.64 338.98 192.64 336.62 194.69 335.43 194.69 337.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "198.55 335.56 196.5 336.75 196.5 334.39 198.55 333.21 198.55 335.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "202.41 333.34 200.35 334.52 200.35 332.17 202.41 330.98 202.41 333.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "206.26 331.11 204.21 332.3 204.21 329.94 206.26 328.75 206.26 331.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "210.12 328.88 208.07 330.07 208.07 327.71 210.12 326.53 210.12 328.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "213.97 326.66 211.92 327.84 211.92 325.49 213.97 324.3 213.97 326.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "171.56 355.33 169.5 356.52 169.5 354.16 171.56 352.98 171.56 355.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "175.41 353.11 173.36 354.29 173.36 351.94 175.41 350.75 175.41 353.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "179.27 350.88 177.22 352.07 177.22 349.71 179.27 348.53 179.27 350.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "183.13 348.66 181.07 349.84 181.07 347.49 183.13 346.3 183.13 348.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "186.98 346.43 184.93 347.61 184.93 345.26 186.98 344.07 186.98 346.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "190.84 344.2 188.78 345.39 188.78 343.03 190.84 341.85 190.84 344.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "194.69 341.98 192.64 343.16 192.64 340.81 194.69 339.62 194.69 341.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "198.55 339.75 196.5 340.94 196.5 338.58 198.55 337.39 198.55 339.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "202.41 337.52 200.35 338.71 200.35 336.35 202.41 335.17 202.41 337.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "206.26 335.3 204.21 336.48 204.21 334.13 206.26 332.94 206.26 335.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "210.12 333.07 208.07 334.26 208.07 331.9 210.12 330.71 210.12 333.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "213.97 330.85 211.92 332.03 211.92 329.67 213.97 328.49 213.97 330.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-294",
    points: "154.67 335.04 159.48 337.82 223.05 300.72 218.18 297.9 154.67 335.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M69.71,174.37a3.85,3.85,0,0,1-1.34-.21c-1.17-.48-3.92-.81-4.36-.28a4.7,4.7,0,0,0-.6,1.85s-3.06.13-3.42.45c-.17.15-.14.7.66.75a24.73,24.73,0,0,1,3.53.46l.74.45a9,9,0,0,0-1.4.35c-.29.15-.56.6-.26.79s2.16-.39,2.69-.34a6.78,6.78,0,0,0,2.33-.87,11,11,0,0,1,1.24-.54S70.8,174.39,69.71,174.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M69.07,234.68c6.75,2.57,9.8.61,14.44-2.07s6.65-5,1.59-7-9.88.11-14.51,2.78S65.39,233.28,69.07,234.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M69.81,201.88a7.83,7.83,0,0,1-.74,2.56c-.32.65-.42,1.4-.77,1.27s.1-3.13.1-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M85.79,228.48a4,4,0,0,1,.07,1.86,2,2,0,0,1-2.42.52c-1-.47-1.38-1.46-1.75-1.72s-2.42-.5-4-1.8-1.33-2.74.21-2.76a12.76,12.76,0,0,1,5.32,1.32A16.8,16.8,0,0,1,85.79,228.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M85.06,229.89c-1.11.23-2.51-.73-3.16-1.27s-1.8-.27-3.28-1.44-2-2-1.33-2.37,3.14-.28,5.07.76,3.22,1.79,3.22,1.79.47,1.44.23,1.75S85.68,229.76,85.06,229.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M85.07,197a25.17,25.17,0,0,1,.27,8c-.54,4.46.32,13.41.51,16.58s1.3,7.05-.31,7.85c-.93.46-2.58.2-3.87-1.29s-1.57-2.93-1.41-3.2.39-1.49-.12-4.11-1.52-9-1.44-11.06.82-11.81.82-11.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M78.7,209.76c-.08,2.07.94,8.44,1.44,11.06s.28,3.83.12,4.11.12,1.72,1.41,3.2a4.32,4.32,0,0,0,1.62,1.21,14.41,14.41,0,0,1-1.39-6.8c0-5.39-1.12-12.27-1.27-16-.1-2.2.42-6.35.42-9l-1.53.45S78.78,207.69,78.7,209.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M77.6,233.12s.58,1.7-.13,2.06a3.26,3.26,0,0,1-2.68.19c-.89-.4-1.25-.79-2.19-.79a13.15,13.15,0,0,1-5.29-2.68c-.71-.89,0-1.9,1.74-1.77a46.13,46.13,0,0,1,4.7.49C74.19,230.78,77.6,233.12,77.6,233.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M76.82,234.37c-1.64.2-2.16-.26-3.67-.57s-5.81-2.05-5.74-3,1.07-.76,1.91-.68,3.49.26,3.7.26,4.53,2,4.53,2,.31,1.4,0,1.61S77.26,234.32,76.82,234.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M80,198.19a9.2,9.2,0,0,1,0,5.74A51.63,51.63,0,0,0,78,216.48c0,4.62.51,16.54-.19,17.2a4.37,4.37,0,0,1-4.18.16c-1.63-1.19-2.51-2.89-2.35-3.48s1.41-2.7,1-4.57-1.88-8.37-1.6-12.79,1-15.95,1-15.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M76,161.72c-1,.5-2.09,1.35-2.14,4s-.08,3.85.44,4.19.92,0,1,.73a8.36,8.36,0,0,1-.1,1.93l5.68-1.28a2.7,2.7,0,0,1,0-1.85c.37-.93,2-2.76.76-5.44A4.52,4.52,0,0,0,76,161.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M73.8,163.93c0,.5.28,1.3,1,1.36a1,1,0,0,1,.88,1.27c-.15.39,0,.5,0,.5s.52-.21.76.21-.08,1.3-.24,1.64,1,1.38,2,1.46,2.27,0,2.69-.52A5.44,5.44,0,0,0,82.22,165,4.66,4.66,0,0,0,77,161.22C74.68,161.66,73.82,163.23,73.8,163.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M69,173.83a1.67,1.67,0,0,0-.6,1.52,8.55,8.55,0,0,0,1.07,2.5l9.88-.55s7.61-.32,7.28-3.43-2.36-2.82-6.76-1.68a40.9,40.9,0,0,1-7.56,1.46C70.88,173.78,69,173.83,69,173.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M74.27,174s.62-2.15,1.9-2.41,2.4-.1,3.26-.49A3.31,3.31,0,0,0,80.75,170s1,.28.26,1.16S74.27,174,74.27,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M68.86,176.71c.38.74.61,1.14.61,1.14l9.88-.55s7.59-.32,7.28-3.41c-1.83.44-6.42,2.32-10.6,2.54C72.2,176.64,69.85,176.69,68.86,176.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M74.57,197.45l-2.95-.4s-.74,11.54-1,15.95,1.17,10.91,1.6,12.79-.82,4-1,4.57.57,2,1.93,3.15a40.84,40.84,0,0,1,.14-6.79c.17-2-1.35-9.4-.93-13.81C72.74,209.08,74.2,199.8,74.57,197.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M79,172a14.58,14.58,0,0,0,2.4-1.12,22.19,22.19,0,0,1,2.84.13,3,3,0,0,1,2.53,3.08,41.42,41.42,0,0,1-1.18,7.19,16.49,16.49,0,0,0-.13,7.46c.5,2.73,2.22,8.73,2.09,9.38s-1.62,3-5,4.17-9.1,1.48-11.39-1.15.68-11.7.81-16.13-1.49-6.28.39-8.58a12,12,0,0,1,5.18-4A12.79,12.79,0,0,0,79,172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M74.11,174.15a4.74,4.74,0,0,1,2.66-1.85,10.9,10.9,0,0,0,3.63-1,1.88,1.88,0,0,0,.83-1l1.53.57a2.53,2.53,0,0,1-2,2.47c-2.13.65-4.54.62-6.09,1.52a14.22,14.22,0,0,0-2.37,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M74.11,174.15a4.74,4.74,0,0,1,2.66-1.85,10.9,10.9,0,0,0,3.63-1,1.88,1.88,0,0,0,.83-1l1.53.57s0,1.48-2.16,2.13-4.93.84-6.28,1.85a19.73,19.73,0,0,0-2,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M82.6,170.78c0,.3-.29,1.5-2.15,2.07-2.14.65-4.92.83-6.28,1.85-.51.38-.92.71-1.24,1l-.64.84a19.73,19.73,0,0,1,2-1.7c1.35-1,4.14-1.19,6.28-1.85s2.16-2.13,2.16-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M76.52,178c-1.47-2.18-3.58-.43-5.09,1,0,1.48.6,3.22.52,5.93-.13,4.43-3.1,13.5-.81,16.13a7.28,7.28,0,0,0,5,2,29.65,29.65,0,0,1-.39-3.59c-.17-3.81,1-5.93,1.44-11.05S78.42,180.86,76.52,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M82.25,165.24a5.71,5.71,0,0,1-2.68,1.12,9,9,0,0,1-3.89-.23.69.69,0,0,1,0,.43c-.15.39,0,.5,0,.5s.52-.21.76.21-.08,1.3-.24,1.64,1,1.38,2,1.46,2.27,0,2.69-.52A5.5,5.5,0,0,0,82.25,165.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M67.63,198.93a25.59,25.59,0,0,0-2.12,3c-.36.66-.34.78-.18,2.13.07.63.19,1.09.53,1.13.16,0,.06-.35.06-.35s.06.62.46.72.2-.4.2-.4.11.66.52.73.19-.45.19-.45.14.7.46.82.38-.1.38-.58a4.12,4.12,0,0,1,.75-1.95c.54-1,1-1.38.93-2.28a2.49,2.49,0,0,1,.69-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M73.13,176.75a3.09,3.09,0,0,1,4.05,2.39c.44,1.91-.49,9.13-1.22,11.13s-5.27,11-5.27,11a11.65,11.65,0,0,1-2.58-.65,3.29,3.29,0,0,1-1.46-1.36s3.13-7.74,3.73-9.54.38-6.36.57-8.39C71.18,178.87,71.37,177.36,73.13,176.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M191.78,386.51c5.45,2.57,7.74,1.07,11.23-.95s5-3.86.87-5.85-7.76-.46-11.25,1.56S188.81,385.11,191.78,386.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M220.3,367.07c-1.81.42-6.87-.8-9.18-1s-5.82-.57-5.82-.57-.55,8.48-.66,9.84a19.27,19.27,0,0,0,.18,3.35c0,.47-1,1-2.47,1.79a8.5,8.5,0,0,1-3.81.92c-1.06-.23-.7-1.47.51-1.7a3.6,3.6,0,0,0,2.32-2.35c.12-.42.93-1.76.1-5.31a51.77,51.77,0,0,1-1.12-8.81c0-.83,0-2.31,1.7-2.61s17.72-1.81,17.72-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M204.77,377.72a2.38,2.38,0,0,1,.75,1.92c-.22,1-.8,1.09-.8,1.82v1.91l-.44.17-.49-.18v-2.92a7.63,7.63,0,0,0-2.28,1.15,3.35,3.35,0,0,1-3.28.5c-.8-.41-2.28-2.48-1.9-2.88s3.25.43,3.25.43-1.08.11-1.25.65.77,1.25,1.51.92,1.56-1.36,3-1.95A3.18,3.18,0,0,0,204.77,377.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M204.45,378.56a2.72,2.72,0,0,1,.72,1.68c-.1.76-.7,1.69-.72,2.4s0,1.24,0,1.27a3.37,3.37,0,0,1-.52,0l-.21-.16v-2.56a3.57,3.57,0,0,0-2.05.38,5,5,0,0,1-3.6.56c-.86-.37-1.46-2.94-1.37-3.33s2.16.7,2.49.84a2.39,2.39,0,0,0,.46.17s-1.07-.3-1.33.09a1,1,0,0,0,.84,1.38c.85.15,1.91-1.05,2.8-1.36S204.21,379.14,204.45,378.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M195.73,345.78a3.4,3.4,0,0,0-1-.59c-1-.33-3-1.35-3-1.94a7.42,7.42,0,0,1,.73-2s-2-1.84-2.06-2,.26-.44.81,0a19.88,19.88,0,0,0,2.57,1.62l.74.11a8.07,8.07,0,0,1-.74-1c-.11-.26,0-.7.26-.67s1.21,1.44,1.58,1.69a5.82,5.82,0,0,1,1.06,1.84,8.35,8.35,0,0,0,.52,1S196.46,346.36,195.73,345.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-312",
    points: "197.43 343.81 196.98 343.3 195.06 345.4 195.63 345.77 197.43 343.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M214.84,394.3a2.86,2.86,0,0,0,1.44-.39l11.57-6.71a1.64,1.64,0,0,0,0-2.84l-11.27-6.3v-6.25a.62.62,0,0,0-1.23,0v6.61a.6.6,0,0,0,.32.53l11.58,6.48a.42.42,0,0,1,.21.35.39.39,0,0,1-.2.35l-11.58,6.72a1.65,1.65,0,0,1-1.65,0L204,387V370.13a.61.61,0,1,0-1.22,0v17.21a.6.6,0,0,0,.3.53l10.32,6A2.81,2.81,0,0,0,214.84,394.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M214.94,393.79a2.42,2.42,0,0,0,1.23-.34l11.58-6.71a1.23,1.23,0,0,0,.61-1.07,1.21,1.21,0,0,0-.63-1.05l-11.48-6.43v-6.48a.2.2,0,0,0-.2-.21.21.21,0,0,0-.21.21v6.6a.19.19,0,0,0,.11.18L227.53,385a.83.83,0,0,1,.42.7.79.79,0,0,1-.41.71L216,393.1a2,2,0,0,1-2.06,0l-10.22-6V370a.21.21,0,0,0-.21-.2.2.2,0,0,0-.2.2v17.22a.19.19,0,0,0,.1.17l10.32,6A2.43,2.43,0,0,0,214.94,393.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M215,393.55a2.23,2.23,0,0,0,1.15-.31l11.58-6.71a1.06,1.06,0,0,0,0-1.84l-11.56-6.47v-6.58a0,0,0,0,0-.08,0v6.6a.05.05,0,0,0,0,0l11.58,6.48a1,1,0,0,1,.5.85,1,1,0,0,1-.48.85l-11.58,6.71a2.18,2.18,0,0,1-1.11.3,2.21,2.21,0,0,1-1.12-.3l-10.3-6V370a0,0,0,0,0,0,0,0,0,0,0,0,0,0v17.22l10.34,6.07A2.34,2.34,0,0,0,215,393.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-315",
    points: "215.63 376.81 215.63 378.06 201.71 370.01 201.71 368.72 215.63 376.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "215.63 376.81 215.63 378.06 229.26 370.14 229.26 368.85 215.63 376.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-317",
    points: "215.63 376.05 215.63 377.3 201.71 369.25 201.71 367.96 215.63 376.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-318",
    points: "215.63 376.05 215.63 377.3 229.26 369.38 229.26 368.09 215.63 376.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "229.26 368.09 215.63 376.05 201.71 367.96 215.36 360.01 229.26 368.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-320",
    points: "215.72 375.69 213.97 375.29 201.71 367.96 215.72 375.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M215.3,370.53c-1.82.41-6.87-.8-9.19-1s-5.82-.57-5.82-.57-.55,8.49-.65,9.85a18.36,18.36,0,0,0,.18,3.35c0,.47-1,.95-2.47,1.78a8.41,8.41,0,0,1-3.81.93c-1.06-.23-.7-1.48.5-1.7a3.63,3.63,0,0,0,2.33-2.35c.12-.43.93-1.76.1-5.31a52.24,52.24,0,0,1-1.13-8.81c0-.84,0-2.31,1.7-2.61s17.73-1.82,17.73-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M222.71,356.72a19.5,19.5,0,0,1-4.69,1.59c-1.78.19-5.44.36-5.44.36s-4.65.87-5.28,1.1a42.56,42.56,0,0,0-4.56,3.37c-.45.41-.53,2.57-.49,4.23s-.15,2.08,1.44,2.65,8.92,2.36,14.71,0c6.16-2.49,6.51-5.37,6.51-6.8C224.91,360.43,222.71,356.72,222.71,356.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M223.89,340.19c1.09,1.13,2.53,6.81,3.1,7.87s2.42,3.93.38,5.18-6.32,1.63-6.32,1.63,1.36-3.18,1.47-3.18,1.9-.87,1.9-.87l-2.16-5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M213.37,328.84c-1.13.89-1.89,4.12-1.17,6.32s1.66,2.38,2,2.57,1.55,2.12,1.1,3,3.06.38,3.93-.34.91-1,.91-1a3.2,3.2,0,0,1-.49-2.43c.41-1,2.19-4.76,0-7.33A4.62,4.62,0,0,0,213.37,328.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M219.88,339.17s2.19-.95,3.63.34,1.13,2.61.94,5.1c-.28,3.79-1.89,7.68-2,9.39a7.38,7.38,0,0,0,1.29,3.82s-.68,1.06-4.5,1.43a18.54,18.54,0,0,1-6.78-.56s.37-4.28.34-5.41-1.17-2.84-1.28-4.81-.15-4.92,1.32-5.86a22.81,22.81,0,0,0,2.54-1.89,6.79,6.79,0,0,0,2.76-.12A2.26,2.26,0,0,0,219.88,339.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M212.76,353.28c0-1.14-1.17-2.84-1.28-4.81-.1-1.75-.14-4.28.9-5.48,1.54.1,3.63.52,3.78,1.83a76.86,76.86,0,0,1-.16,11.4c-.15,1.21-.31,2.23-.45,3a16.78,16.78,0,0,1-3.13-.57S212.79,354.41,212.76,353.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M212.8,342.61a2.29,2.29,0,0,1,3.29,1.36,3.69,3.69,0,0,1-2.38,4.39c-2.08.91-7,4.42-7.68,4.88s-1.89,1.28-3.37,0-7.37-7.53-7.37-7.53l2-2.16s4.16,4.35,5.11,5,1.85,1.17,1.85,1.17S211.44,343.29,212.8,342.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M211.82,331.6a8.76,8.76,0,0,0,1.78,1.25c.72.3.53.87.45,1.32,0,0,.87.23,1.06.53s.57.87.15,1.4-1.55,1.77-1.06,3.26c.7,2.09-2.25,3.61-2.25,3.61s5.07,2.25,8.49.66c3.11-1.44,3.94-4.12,3.07-4.65s-2.42-.8-2.08-5.64a5.3,5.3,0,0,0-5.87-5.6C211,328,211.82,331.6,211.82,331.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M215.6,362.62l1.36-5.53,1,.6-1.36,5.5a34,34,0,0,0-1,8.17v4.69l-1-.55v-4.77A33.65,33.65,0,0,1,215.6,362.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M218,357.69l13.66-8-1.37,5.55a34.35,34.35,0,0,0-1,8.14v4.71l-13.65,8v-4.69a34.1,34.1,0,0,1,1-8.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-330",
    points: "231.63 349.69 217.97 357.69 216.96 357.1 230.63 349.11 231.63 349.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-331",
    points: "231.63 349.69 217.68 357.45 216.15 365.25 218.17 357.7 231.63 349.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "229.82 385.61 214.28 394.68 196.08 384.11 211.63 375.06 229.82 385.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "229.47 385.64 214.33 394.48 196.59 384.18 211.75 375.36 229.47 385.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "229.13 385.67 214.37 394.28 197.1 384.25 211.86 375.66 229.13 385.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "228.78 385.7 214.42 394.08 197.61 384.32 211.98 375.96 228.78 385.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "228.43 385.73 214.47 393.88 198.12 384.39 212.09 376.26 228.43 385.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "228.08 385.76 214.51 393.68 198.63 384.46 212.2 376.56 228.08 385.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "227.73 385.8 214.56 393.48 199.14 384.53 212.32 376.86 227.73 385.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "227.38 385.83 214.61 393.28 199.65 384.6 212.43 377.16 227.38 385.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "227.03 385.86 214.65 393.08 200.16 384.67 212.54 377.46 227.03 385.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "226.68 385.89 214.7 392.88 200.67 384.74 212.66 377.76 226.68 385.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "226.33 385.92 214.75 392.68 201.18 384.81 212.77 378.06 226.33 385.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "225.98 385.95 214.79 392.48 201.69 384.88 212.89 378.36 225.98 385.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M199.76,381.18a2.32,2.32,0,0,1,.75,1.91c-.21,1-.79,1.09-.79,1.83v1.9l-.44.17-.49-.18V383.9a7.45,7.45,0,0,0-2.28,1.14,3.32,3.32,0,0,1-3.29.5c-.79-.41-2.27-2.47-1.89-2.88s3.24.43,3.24.43-1.07.12-1.24.66.77,1.24,1.51.91,1.56-1.35,3-1.94A3.17,3.17,0,0,0,199.76,381.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M243.4,414.11a1.78,1.78,0,0,0,.71,1.61l.82.48c.46.26.17-.33.86-.73a5.58,5.58,0,0,0,2.54-4.37c0-.8.73-.8.28-1.07l-.91-.49a1.82,1.82,0,0,0-1.77.2A5.59,5.59,0,0,0,243.4,414.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M244.28,414.61c0,1.61,1.14,2.25,2.54,1.45a5.59,5.59,0,0,0,2.53-4.38c0-1.61-1.13-2.25-2.53-1.44A5.57,5.57,0,0,0,244.28,414.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M244.9,414.5a1.52,1.52,0,0,0,.61,1.38l1.23.73c.39.22.14-.28.74-.62a4.81,4.81,0,0,0,2.17-3.76c0-.68.63-.69.25-.91l-1.29-.74a1.55,1.55,0,0,0-1.53.16A4.8,4.8,0,0,0,244.9,414.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M246.18,415.25c0,1.38,1,1.93,2.18,1.24a4.82,4.82,0,0,0,2.18-3.76c0-1.38-1-1.93-2.18-1.24A4.82,4.82,0,0,0,246.18,415.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M247.33,414.88c0,.8.57,1.12,1.26.72a2.78,2.78,0,0,0,1.26-2.17c0-.79-.57-1.11-1.26-.71A2.78,2.78,0,0,0,247.33,414.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M246.7,410.17a1.83,1.83,0,0,1,1.73-.21,2,2,0,0,0-1.51.3,5.6,5.6,0,0,0-2.54,4.37,1.72,1.72,0,0,0,.8,1.66c-.62-.17-1-.79-1-1.74A5.6,5.6,0,0,1,246.7,410.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M248.26,411.43a1.58,1.58,0,0,1,1.5-.18,1.7,1.7,0,0,0-1.31.26,4.79,4.79,0,0,0-2.19,3.77,1.49,1.49,0,0,0,.69,1.43,1.4,1.4,0,0,1-.88-1.5A4.83,4.83,0,0,1,248.26,411.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M234.41,419.28a1.78,1.78,0,0,0,.71,1.61l.82.48c.46.26.17-.33.86-.73a5.58,5.58,0,0,0,2.54-4.37c0-.8.73-.8.28-1.07l-.91-.49a1.82,1.82,0,0,0-1.77.2A5.59,5.59,0,0,0,234.41,419.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M235.29,419.78c0,1.61,1.14,2.25,2.54,1.45a5.59,5.59,0,0,0,2.53-4.38c0-1.61-1.13-2.25-2.53-1.44A5.57,5.57,0,0,0,235.29,419.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M235.91,419.67a1.52,1.52,0,0,0,.61,1.38l1.23.73c.39.22.14-.28.74-.62a4.81,4.81,0,0,0,2.17-3.76c0-.68.63-.69.25-.91l-1.3-.75a1.56,1.56,0,0,0-1.52.17A4.8,4.8,0,0,0,235.91,419.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M237.19,420.42c0,1.38,1,1.93,2.18,1.24a4.81,4.81,0,0,0,2.17-3.76c0-1.38-1-1.93-2.17-1.24A4.82,4.82,0,0,0,237.19,420.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M237.71,415.34a1.83,1.83,0,0,1,1.73-.21,2,2,0,0,0-1.51.3,5.6,5.6,0,0,0-2.54,4.37,1.72,1.72,0,0,0,.8,1.66c-.62-.17-1-.79-1-1.74A5.6,5.6,0,0,1,237.71,415.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M239.27,416.6a1.58,1.58,0,0,1,1.5-.18,1.7,1.7,0,0,0-1.31.26,4.79,4.79,0,0,0-2.19,3.77,1.49,1.49,0,0,0,.69,1.43,1.4,1.4,0,0,1-.88-1.5A4.83,4.83,0,0,1,239.27,416.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M238.21,420.05c0,.8.57,1.12,1.26.72a2.78,2.78,0,0,0,1.26-2.17c0-.79-.57-1.11-1.26-.71A2.78,2.78,0,0,0,238.21,420.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M261.76,403.74a1.78,1.78,0,0,0,.71,1.61l.82.48c.46.25.17-.33.86-.73a5.6,5.6,0,0,0,2.54-4.37c0-.8.73-.8.28-1.07l-.9-.49a1.82,1.82,0,0,0-1.77.2A5.6,5.6,0,0,0,261.76,403.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M262.64,404.24c0,1.61,1.14,2.25,2.54,1.44a5.57,5.57,0,0,0,2.54-4.37c0-1.61-1.14-2.25-2.54-1.45A5.6,5.6,0,0,0,262.64,404.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M263.26,404.13a1.52,1.52,0,0,0,.61,1.38l1.23.73c.39.22.14-.28.74-.62a4.81,4.81,0,0,0,2.17-3.76c0-.68.64-.69.25-.91l-1.3-.75a1.56,1.56,0,0,0-1.52.17A4.82,4.82,0,0,0,263.26,404.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M264.54,404.87c0,1.38,1,1.94,2.18,1.25a4.82,4.82,0,0,0,2.18-3.76c0-1.38-1-1.93-2.18-1.24A4.81,4.81,0,0,0,264.54,404.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M265.7,404.51c0,.8.56,1.12,1.25.72a2.75,2.75,0,0,0,1.26-2.17c0-.79-.56-1.11-1.26-.71A2.77,2.77,0,0,0,265.7,404.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M265.06,399.8a1.83,1.83,0,0,1,1.73-.21,2,2,0,0,0-1.51.3,5.6,5.6,0,0,0-2.54,4.37,1.72,1.72,0,0,0,.8,1.66c-.62-.17-1-.79-1-1.74A5.6,5.6,0,0,1,265.06,399.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M266.62,401.06a1.58,1.58,0,0,1,1.5-.18,1.71,1.71,0,0,0-1.31.26,4.79,4.79,0,0,0-2.19,3.77,1.48,1.48,0,0,0,.7,1.43c-.54-.15-.88-.68-.88-1.5A4.82,4.82,0,0,1,266.62,401.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M252.77,408.91a1.78,1.78,0,0,0,.71,1.61l.82.48c.46.25.17-.33.86-.73a5.6,5.6,0,0,0,2.54-4.37c0-.8.73-.8.28-1.07l-.9-.49a1.82,1.82,0,0,0-1.77.2A5.6,5.6,0,0,0,252.77,408.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-348",
    cx: 256.19,
    cy: 407.94,
    rx: 3.57,
    ry: 2.06,
    transform: "translate(-225.29 423.22) rotate(-59.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M254.27,409.3a1.52,1.52,0,0,0,.61,1.38l1.23.73c.39.22.14-.28.74-.62A4.81,4.81,0,0,0,259,407c0-.68.64-.69.25-.91l-1.3-.75a1.56,1.56,0,0,0-1.52.17A4.82,4.82,0,0,0,254.27,409.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M255.55,410c0,1.38,1,1.94,2.18,1.25a4.82,4.82,0,0,0,2.18-3.76c0-1.38-1-1.93-2.18-1.24A4.81,4.81,0,0,0,255.55,410Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M256.07,405a1.83,1.83,0,0,1,1.73-.21,2,2,0,0,0-1.51.3,5.6,5.6,0,0,0-2.54,4.37,1.72,1.72,0,0,0,.8,1.66c-.62-.17-1-.79-1-1.74A5.6,5.6,0,0,1,256.07,405Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M257.63,406.23a1.58,1.58,0,0,1,1.5-.18,1.7,1.7,0,0,0-1.31.26,4.79,4.79,0,0,0-2.19,3.77,1.49,1.49,0,0,0,.69,1.43,1.4,1.4,0,0,1-.88-1.5A4.83,4.83,0,0,1,257.63,406.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M256.58,409.68c0,.8.56,1.12,1.25.72a2.75,2.75,0,0,0,1.26-2.17c0-.79-.56-1.12-1.26-.71A2.77,2.77,0,0,0,256.58,409.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-352",
    points: "281.38 433.58 273.04 427.94 273.04 407.59 266.12 404.05 266.74 402.84 274.4 406.76 274.4 427.22 281.47 432 297.75 423.54 297.75 385.73 309.76 356.94 309.76 279.1 311.12 279.1 311.12 357.22 299.11 386.01 299.11 424.37 281.38 433.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-353",
    points: "288.88 448.76 264.65 433.85 264.65 412.81 257.73 409.27 258.35 408.06 266.01 411.98 266.01 433.09 288.94 447.2 315.43 433.51 315.43 395.57 322.91 387.86 322.91 344.19 342.74 312.51 343.89 313.24 324.27 344.58 324.27 388.41 316.79 396.12 316.79 434.34 288.88 448.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-354",
    points: "290.24 460.09 255.81 439.3 255.81 418.25 248.89 414.71 249.51 413.5 257.17 417.42 257.17 438.53 290.29 458.54 326.54 439.86 326.54 413.56 326.64 413.39 343.77 385.45 343.77 340.66 359.2 350.39 379.81 338.77 379.81 306.56 379.91 306.4 398.27 276.7 399.43 277.42 381.17 306.95 381.17 339.57 359.16 351.98 345.13 343.12 345.13 385.83 345.03 386 327.9 413.94 327.9 440.69 290.24 460.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-355",
    points: "285.94 467.8 246.29 444.75 246.29 423.69 239.37 420.15 239.99 418.94 247.65 422.86 247.65 443.96 285.98 466.25 331.75 442.58 331.75 429.99 339.46 423.41 339.46 408.21 359.65 420.89 380.26 409.27 380.26 382.7 409.05 343.48 409.05 325.34 410.41 325.34 410.41 343.93 381.62 383.14 381.62 410.07 359.61 422.48 340.82 410.67 340.82 424.04 333.11 430.61 333.11 443.41 285.94 467.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M190.83,414.11a1.78,1.78,0,0,1-.71,1.61l-.82.48c-.46.26-.17-.33-.86-.73a5.58,5.58,0,0,1-2.54-4.37c0-.8-.73-.8-.28-1.07l.9-.49a1.82,1.82,0,0,1,1.77.2A5.6,5.6,0,0,1,190.83,414.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M190,414.61c0,1.61-1.14,2.25-2.54,1.45a5.6,5.6,0,0,1-2.54-4.38c0-1.61,1.14-2.25,2.54-1.44A5.57,5.57,0,0,1,190,414.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M189.33,414.5a1.52,1.52,0,0,1-.61,1.38l-1.23.73c-.39.22-.14-.28-.74-.62a4.82,4.82,0,0,1-2.18-3.76c0-.68-.63-.69-.24-.91l1.3-.75a1.56,1.56,0,0,1,1.52.17A4.82,4.82,0,0,1,189.33,414.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M188.05,415.25c0,1.38-1,1.93-2.18,1.24a4.82,4.82,0,0,1-2.18-3.76c0-1.38,1-1.93,2.18-1.24A4.82,4.82,0,0,1,188.05,415.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M186.89,414.88c0,.8-.56,1.12-1.25.72a2.75,2.75,0,0,1-1.26-2.17c0-.79.56-1.11,1.26-.71A2.77,2.77,0,0,1,186.89,414.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M187.53,410.17a1.83,1.83,0,0,0-1.73-.21,2,2,0,0,1,1.51.3,5.6,5.6,0,0,1,2.54,4.37,1.72,1.72,0,0,1-.8,1.66c.62-.17,1-.79,1-1.74A5.6,5.6,0,0,0,187.53,410.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M186,411.43a1.58,1.58,0,0,0-1.5-.18,1.71,1.71,0,0,1,1.31.26,4.79,4.79,0,0,1,2.19,3.77,1.48,1.48,0,0,1-.7,1.43c.54-.15.88-.68.88-1.5A4.82,4.82,0,0,0,186,411.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M199.82,419.28a1.78,1.78,0,0,1-.71,1.61l-.82.48c-.46.26-.17-.33-.86-.73a5.58,5.58,0,0,1-2.54-4.37c0-.8-.73-.8-.28-1.07l.9-.49a1.82,1.82,0,0,1,1.77.2A5.6,5.6,0,0,1,199.82,419.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M198.94,419.78c0,1.61-1.14,2.25-2.54,1.45a5.6,5.6,0,0,1-2.54-4.38c0-1.61,1.14-2.25,2.54-1.44A5.57,5.57,0,0,1,198.94,419.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M198.32,419.67a1.52,1.52,0,0,1-.61,1.38l-1.23.73c-.39.22-.14-.28-.74-.62a4.81,4.81,0,0,1-2.17-3.76c0-.68-.64-.69-.25-.91l1.3-.75a1.56,1.56,0,0,1,1.52.17A4.82,4.82,0,0,1,198.32,419.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M197,420.42c0,1.38-1,1.93-2.18,1.24a4.82,4.82,0,0,1-2.18-3.76c0-1.38,1-1.93,2.18-1.24A4.82,4.82,0,0,1,197,420.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M196.52,415.34a1.83,1.83,0,0,0-1.73-.21,2,2,0,0,1,1.51.3,5.6,5.6,0,0,1,2.54,4.37,1.72,1.72,0,0,1-.8,1.66c.62-.17,1-.79,1-1.74A5.6,5.6,0,0,0,196.52,415.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M195,416.6a1.58,1.58,0,0,0-1.5-.18,1.7,1.7,0,0,1,1.31.26,4.79,4.79,0,0,1,2.19,3.77,1.49,1.49,0,0,1-.69,1.43,1.4,1.4,0,0,0,.88-1.5A4.83,4.83,0,0,0,195,416.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M196,420.05c0,.8-.56,1.12-1.25.72a2.75,2.75,0,0,1-1.26-2.17c0-.79.56-1.11,1.26-.71A2.77,2.77,0,0,1,196,420.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M172.47,403.74a1.78,1.78,0,0,1-.71,1.61l-.82.48c-.46.25-.17-.33-.86-.73a5.57,5.57,0,0,1-2.54-4.37c0-.8-.73-.8-.28-1.07l.9-.49a1.82,1.82,0,0,1,1.77.2A5.6,5.6,0,0,1,172.47,403.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M171.58,404.24c0,1.61-1.13,2.25-2.53,1.44a5.57,5.57,0,0,1-2.54-4.37c0-1.61,1.14-2.25,2.54-1.45A5.59,5.59,0,0,1,171.58,404.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M171,404.13a1.55,1.55,0,0,1-.61,1.38l-1.22.72c-.4.23-.15-.27-.75-.61a4.82,4.82,0,0,1-2.18-3.76c0-.68-.63-.69-.24-.91l1.3-.75a1.56,1.56,0,0,1,1.52.17A4.82,4.82,0,0,1,171,404.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M169.68,404.87c0,1.38-1,1.94-2.17,1.25a4.82,4.82,0,0,1-2.18-3.76c0-1.38,1-1.93,2.18-1.24A4.8,4.8,0,0,1,169.68,404.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M168.53,404.51c0,.8-.56,1.12-1.25.72a2.75,2.75,0,0,1-1.26-2.17c0-.79.56-1.11,1.26-.71A2.77,2.77,0,0,1,168.53,404.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M169.17,399.8a1.85,1.85,0,0,0-1.74-.21,2,2,0,0,1,1.52.3,5.6,5.6,0,0,1,2.54,4.37,1.72,1.72,0,0,1-.8,1.66,1.62,1.62,0,0,0,1-1.74A5.6,5.6,0,0,0,169.17,399.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M167.61,401.06a1.58,1.58,0,0,0-1.5-.18,1.71,1.71,0,0,1,1.31.26,4.81,4.81,0,0,1,2.18,3.77,1.47,1.47,0,0,1-.69,1.43c.54-.15.88-.68.88-1.5A4.84,4.84,0,0,0,167.61,401.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M181.46,408.91a1.78,1.78,0,0,1-.71,1.61l-.82.48c-.46.25-.17-.33-.86-.73a5.6,5.6,0,0,1-2.54-4.37c0-.8-.73-.8-.28-1.07l.9-.49a1.82,1.82,0,0,1,1.77.2A5.6,5.6,0,0,1,181.46,408.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-372",
    cx: 178.04,
    cy: 407.94,
    rx: 2.06,
    ry: 3.57,
    transform: "translate(-181.55 145.63) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M180,409.3a1.55,1.55,0,0,1-.61,1.38l-1.23.73c-.39.22-.14-.28-.74-.62A4.82,4.82,0,0,1,175.2,407c0-.68-.63-.69-.24-.91l1.29-.74a1.55,1.55,0,0,1,1.53.16A4.82,4.82,0,0,1,180,409.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M178.68,410c0,1.38-1,1.94-2.18,1.25a4.82,4.82,0,0,1-2.18-3.76c0-1.38,1-1.93,2.18-1.24A4.81,4.81,0,0,1,178.68,410Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M178.16,405a1.83,1.83,0,0,0-1.73-.21,2,2,0,0,1,1.51.3,5.6,5.6,0,0,1,2.54,4.37,1.72,1.72,0,0,1-.8,1.66c.62-.17,1-.79,1-1.74A5.6,5.6,0,0,0,178.16,405Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M176.6,406.23a1.58,1.58,0,0,0-1.5-.18,1.71,1.71,0,0,1,1.31.26,4.78,4.78,0,0,1,2.18,3.77,1.47,1.47,0,0,1-.69,1.43c.54-.15.88-.68.88-1.5A4.84,4.84,0,0,0,176.6,406.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M177.65,409.68c0,.8-.56,1.12-1.25.72a2.75,2.75,0,0,1-1.26-2.17c0-.79.56-1.12,1.26-.71A2.77,2.77,0,0,1,177.65,409.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-376",
    points: "152.84 433.59 123.65 418.01 123.65 379.65 111.6 348.04 121.87 311.56 123.17 311.93 113.04 347.98 125.01 379.52 125.01 417.2 152.76 432 159.83 427.22 159.83 406.76 167.49 402.84 168.11 404.05 161.19 407.59 161.19 427.94 152.84 433.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-377",
    points: "151.56 444.91 112.19 424.13 112.19 375.09 98.49 382.96 98.49 291.57 99.85 291.57 99.85 380.61 113.55 372.74 113.55 423.31 151.51 443.34 168.22 433.09 168.22 411.98 175.88 408.06 176.5 409.27 169.58 412.81 169.58 433.85 151.56 444.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-378",
    points: "153.37 454.2 104.25 428.44 104.25 401.86 82.4 385.99 82.4 343.12 68.35 351.98 50.44 341.37 50.44 308.76 32.17 279.23 33.33 278.52 51.8 308.38 51.8 340.6 68.33 350.39 83.76 340.66 83.76 385.3 105.61 401.16 105.61 427.62 153.33 452.64 177.06 438.53 177.06 417.42 184.72 413.5 185.34 414.71 178.42 418.25 178.42 439.3 153.37 454.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-379",
    points: "154.95 463.72 154.62 463.54 96.32 432.98 96.32 421.03 76.28 432.13 76.28 412.03 67.92 417.25 45.22 405.55 45.22 378.61 16.43 339.39 16.43 320.81 17.79 320.81 17.79 338.95 46.58 378.17 46.58 404.72 67.86 415.69 77.64 409.58 77.64 429.82 97.68 418.72 97.68 432.15 154.92 462.17 186.58 443.96 186.58 422.86 194.24 418.94 194.86 420.15 187.94 423.69 187.94 444.75 154.95 463.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M396.77,277.69c0,1.5,1.06,2.1,2.36,1.35A5.21,5.21,0,0,0,401.5,275c0-1.5-1.06-2.11-2.37-1.35A5.22,5.22,0,0,0,396.77,277.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M407.48,325.12c0,1.5,1.06,2.11,2.36,1.35a5.2,5.2,0,0,0,2.37-4.08c0-1.5-1.06-2.1-2.37-1.35A5.23,5.23,0,0,0,407.48,325.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M312.92,279.56c0,1.5-1.06,2.1-2.36,1.35a5.21,5.21,0,0,1-2.37-4.08c0-1.5,1.06-2.11,2.37-1.35A5.22,5.22,0,0,1,312.92,279.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M345.73,312.88c0,1.5-1.05,2.11-2.36,1.35a5.2,5.2,0,0,1-2.37-4.08c0-1.5,1.06-2.1,2.37-1.35A5.2,5.2,0,0,1,345.73,312.88Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-380",
    cx: 99.4,
    cy: 290.43,
    rx: 3.34,
    ry: 1.93,
    transform: "translate(-201.5 229.67) rotate(-59.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M120.15,311.86c0,1.5,1.06,2.11,2.37,1.35a5.2,5.2,0,0,0,2.37-4.08c0-1.5-1.06-2.1-2.37-1.35A5.21,5.21,0,0,0,120.15,311.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-380",
    cx: 31.73,
    cy: 277.85,
    rx: 1.93,
    ry: 3.34,
    transform: "translate(-135.89 54) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M19.31,320.87c0,1.5-1.06,2.11-2.37,1.35a5.22,5.22,0,0,1-2.36-4.08c0-1.5,1.06-2.1,2.36-1.35A5.21,5.21,0,0,1,19.31,320.87Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfrontDesk);
export default __webpack_public_path__ + "static/media/confrontDesk.b7a8157d4d7c90f0e4c9bf865a351f4b.svg";
export { ForwardRef as ReactComponent };